<template>
 <div class="reveal">
  <div class="slides">

    <section :id="filtered_chapter_id(5)">
      <h1 id="doc_chapter" v-html="filtered_chapter_title(5)">
      </h1>
    </section>

    <!--
    <section>
      <section :id="filtered_section_id(0, 1)">
        <h2 id="doc_section" v-html="filtered_section_title(0, 1)">
        </h2>
      </section>
      --> 

      <section>

         <div class="boxbody">
 
         <span v-if="seminar_hosted==false && seminar_joined==false">
	   <h2>Host Seminar</h2>
         </span>
         <span v-else-if="seminar_hosted==true">
	   <h2>Hosting Seminar Room</h2>
         </span>
         <span v-else-if="seminar_joined==true">
	   <h2>Joined in Seminar Room</h2>
         </span>

         <hr style="height:2px;border-width:0;color:gray;background-color:gray">

         <br />
         <div id="div_seminar_host">
	   <div>password: <input type="password" id="password" style="font-size:70%;"></div>
	   <div>Click <a id="host" href="#"><i class="fa fa-users"></i></a> to host a seminar.</div>
         </div>

         <div id="div_seminar_close">
          Click 
          <a id="close" href="#"><i class="fa fa-window-close"></i></a> 
          to close the seminar room.
         </div>

	</div>
      </section>

      <section>
         <div class="boxbody">

         <span v-if="seminar_hosted==false && seminar_joined==false">
	   <h2>No Seminar Room</h2>
         </span>
         <span v-else-if="seminar_hosted==true">
	   <h2>Invite Clients</h2>
         </span>
         <span v-else-if="seminar_joined==true">
	   <h2>Seminar Room</h2>
         </span>
         <span v-else>
	   <h2></h2>
         </span>

         <hr style="height:2px;border-width:0;color:gray;background-color:gray">

	 <div id="div_seminar_room">
	   <div>
	     <canvas id="qrcode" style="width:300px;height:300px;"></canvas>
	   </div>				
	   <a id="room"></a>
         </div>

         </div>
      </section>

    <!--
    </section>
      --> 

    <section>

      <section :id="filtered_section_id(5, 1)">
        <h2 id="doc_section" v-html="filtered_section_title(5, 1)">
        </h2>
      </section>

      <section data-markdown>
        <textarea data-template>

<div class="boxbody">

### 不好的数据库设计
****

<span style="font-size: 85%"> 

建立一个数据库来描述学生的借书情况，有这样一些属性：\
&emsp;借书证号(lcno)、学生姓名(sname)、学生所在系(sdepart)、\
&emsp;学生电话(phone)、借阅的图书号(bno)、\
&emsp;借阅图书名(bname)、借阅日期(date) 

用一个关系模式LibStu(lcno, sname, sdepart, phone, bno, bname, date)表示 \
设定主键为(lcno, bno, date)

该关系模式好吗？

</span>
 
 </div>

---
<div class="boxbody">

### 不好的数据库设计
****

<span style="font-size: 85%"> 

假定有这样一个关系

</span>

<span style="font-size: 55%"> 

| lcno | sname | sdepart | phone | bno | bname | date |
| -------- | ------- | :-------: | ------- | ------- | ------ | ------ |
| 200013001 | 王铭 | CS | 87654321 | B001 | 数据结构 | 20240403 | 
| 200013001 | 王铭 | CS | 87654321 | B002 | 数据库 | 20240403 | 
| 200013001 | 王铭 | CS | 87654321 | B003 | 离散数学 | 20240406 | 
| 200013001 | 王铭 | CS | 87654321 | B004 | 操作系统 | 20240406 | 
| 200013001 | 王铭 | CS | 87654321 | B005 | 心理学 | 20240420 | 
| 200013001 | 王铭 | CS | 87654321 | B006 | 人工智能 | 20240420 | 
| 202012001 | 李力 | MA | 87652345 | C001 | 哲学 | 20240508 | 
| 202012002 | 张成 | MA | 87653456 | B001 | 数据结构 | 20240509 | 

</span>
 
</div>

---
<div class="boxbody">

### 不好的数据库设计
****

<span style="font-size: 95%"> 

存在更新异常

</span>

<span style="font-size: 75%"> 

- 冗余太大 \
例 一个学生借多本书
- 修改复杂:
更改表所对应的某个实体实例或者关系实例的单个属性时，需要进行多行更新 \
例 "王铭"转系
- 插入异常:
无法插入某个实体实例, 因为缺少某些属性的值 \
例 新生注册但没借书
- 删除异常: 
如果删除表的某一个实体实例或关系实例时，导致丢失另一个不同实体实例或关系实例的信息 \
例 还掉了借的所有书

</span>
 
</div>

---
<div class="boxbody">

### 不好的数据库设计
****

<span style="font-size: 85%"> 

解决办法：将模式LibStu分解下列成三个模式

</span>

<span style="font-size: 75%"> 

Student(lcno, sname, sdepart, phone) \
Book(bno, bname) \
StuBook(sno, bno, date) 

</span>
 
</div>

---
<div class="boxbody">

### 不好的数据库设计
****

<span style="font-size: 85%"> 

解决办法：将模式LibStu分解成三个模式 \
一个关系被分解为三个关系

</span>

<span style="font-size: 45%"> 

<div style="display: grid; grid-template-columns: 60% 40%;"> 
<div>

| lcno | sname | sdepart | phone |
| -------- | ------- | :-------: | ------- |
| 200013001 | 王铭 | CS | 87654321 |
| 202012001 | 李力 | MA | 87652345 |
| 202012002 | 张成 | MA | 87653456 |
 
| bno | bname | 
| ------ | ------ |
| B001 | 数据结构 | 
| B002 | 数据库 | 
| B003 | 离散数学 |
| B004 | 操作系统 | 
| B005 | 心理学 | 
| B006 | 人工智能 |
| C001 | 哲学 |
</div>
<div>

| lcno | bno | date |
| ------- | ------ | ------ |
| 200013001 | B001 | 20240403 | 
| 200013001 | B002 | 20240403 | 
| 200013001 | B003 | 20240406 | 
| 200013001 | B004 | 20240406 | 
| 200013001 | B005 | 20240420 | 
| 200013001 | B006 | 20240420 | 
| 202012001 | C001 | 20240508 | 
| 202012002 | B001 | 20240509 | 
</div>
</div>

</span>

</div>

---
<div class="boxbody">

### 不好的数据库设计
****

<span style="font-size: 95%"> 

解决办法：\
将模式LibStu分解成三个模式,  
一个关系被分解为三个关系

</span>

<span style="font-size: 85%"> 

前面的问题解决了否？
- 一个学生借多本书
- "王铭"转系
- 新生注册但没借书
- 还掉了借的所有书

能否保证不再存在其它的更新异常？ 

</span>

</div>

---
<div class="boxbody">

### 不好的数据库设计
****

<span style="font-size: 95%"> 

另一个实例

</span>

<span style="font-size: 85%"> 

用一个关系模式StuLocCourse(sno, sdepart, sloc, cno, grade)来描述学生的有关信息 \
主键为(sno, cno)
- sno为学生的学号
- sdepart为学生所在系
- sloc为学生的住处，且每个系的学生住在同一个地方
- cno为课程号
- grade为成绩

</span>

</div>

---
<div class="boxbody">

### 不好的数据库设计
****

<span style="font-size: 95%"> 

另一个实例

</span>

<span style="font-size: 85%"> 

分析关系模式StuLocCourse中的更新异常
- 冗余太大 \
例 一个学生修很多课程        
- 修改复杂 \
例 一个学生转系
- 插入异常 \
例 插入一个尚未选课的学生信息
- 删除异常 \
例 一个学生只选修了一门课, 但现在决定不选了

</span>

</div>

---
<div class="boxbody">

### 不好的数据库设计
****

<span style="font-size: 95%"> 

另一个实例

</span>

<span style="font-size: 80%"> 

解决办法：\
将关系模式StuLocCourse(sno, sdepart, sloc, cno, grade) \
分解为两个关系模式, \
StuLoc(sno, sdepart, sloc)和StuCourse(sno, cno, grade)

消除了前面的更新异常了吗?
- 一个学生修很多课程 &#x2714;       
- 一个学生转系 &#x2714;
- 插入一个尚未选课的学生信息 &#x2714;
- 一个学生只选修了一门课，但现在决定不选了 &#x2714;

</span>

</div>

---
<div class="boxbody">

### 不好的数据库设计
****

<span style="font-size: 95%"> 

另一个实例

</span>

<span style="font-size: 80%"> 

解决办法：\
将关系模式StuLocCourse(sno, sdepart, sloc, cno, grade) \
分解为两个关系模式, \
StuLoc(sno, sdepart, sloc)和StuCourse(sno, cno, grade)

去掉了所有更新异常吗?
- 一个系有很多学生，且同系学生住在一个地方 &#x2717;
- 一个学生转系 &#x2717;
- 一个新系创建但新生尚未注册 &#x2717;
- 一个系所有学生毕业了 &#x2717;

</span>

</div>

---
<div class="boxbody">

### 不好的数据库设计
****

<span style="font-size: 95%"> 

另一个实例

</span>

<span style="font-size: 80%"> 

解决办法：\
将关系模式StuLoc(sno, sdepart, sloc) 
分解为两个关系模式, \
StuDep(sno, sdepart)和DepLoc(sdepart, sloc)

去掉了StuLoc中的更新异常吗?
- 一个系有很多学生，且同系学生住在一个地方 &#x2714;
- 一个学生转系 &#x2714;
- 一个新系创建但新生尚未注册 &#2714;
- 一个系所有学生毕业了 &#x2714;

</span>

</div>

---
<div class="boxbody">

### 不好的数据库设计
****

<span style="font-size: 95%"> 

另一个实例

</span>

<span style="font-size: 80%"> 

解决办法：\
将关系模式StuLoc(sno, sdepart, sloc) 
分解为两个关系模式, \
StuDep(sno, sdepart)和DepLoc(sdepart, sloc)

StuDep和DepLoc中还存在其它更新异常吗? \
不存在了，因为StuDep和DepLo都只是二目关系模式，已经足够小了

一般情况下，如何判断一个关系模式是否存在更新异常？

出现更新异常的原因 \
在模式中存在某些不好的数据依赖，如函数依赖、多值依赖

</span>

</div>

---
<div class="boxbody">

### 规范化的含义
****

<span style="font-size: 95%"> 

规范化(Normalization)是将属性分配给一个实体的过程，用以减少数据冗余和减少更新异常。\
这个过程实际上就是将一个低一级范式的关系模式，通过模式分解转换为若干个高一级范式的关系模式的集合的过程。

</span>

</div>

        </textarea>
      </section>

    </section>

    <section>

      <section :id="filtered_section_id(5, 2)">
        <h2 id="doc_section" v-html="filtered_section_title(5, 2)">
        </h2> 
      </section>

      <section data-markdown>
        <textarea data-template>

<div class="boxbody">

### 函数依赖
****

<span style="font-size: 95%"> 

函数依赖(Functional Dependency)定义

</span>

<span style="font-size: 85%">
 
设$R(U)$是属性集$U$上的关系模, $X$、$Y$是$U$的子集。\
若对于$R(U)$的任意一个可能的关系$r$，$r$中不可能存在两个元组在$X$上的属性值相等，而在$Y$上的属性值不等，则称$X$函数确定$Y$或$Y$函数依赖于$X$，记作
$X \\rightarrow Y$。
<style type="text/css"> img[alt=fundepdef] { width: 50%; } </style> 
&emsp; ![fundepdef]({{require("../assets/db/ch05/fun_dep_def.svg")}})

</span>

</div>

---
<div class="boxbody">

### 函数依赖
****

<span style="font-size: 95%"> 

函数依赖与属性间的关系

</span>

<span style="font-size: 85%">

- 若$X$、$Y$是$1:1$关系, 则存在$X \\rightarrow Y$或$Y \\rightarrow X$ \
如 学号与借书证号
- 若$X$、$Y$是m:1关系, 则存在$X \\rightarrow Y$但$Y \\nrightarrow X$ \
如 学号与姓名
- 若$X$、$Y$是m:n关系, 则$X$、$Y$间不存在函数依赖关系 \
如 姓名与课程 

</span>

</div>

---
<div class="boxbody">

### 函数依赖
****

<span style="font-size: 95%"> 

函数依赖另一种定义

</span>

<span style="font-size: 85%">

若$R$的任意关系有：对$X$中的每个属性值，在$Y$中都有惟一的值与之对应，则称$Y$函数依赖于$X$, 记作$X \\rightarrow Y$, $X$叫做决定因素。

若$X \\rightarrow Y$, $Y \\rightarrow X$, 则记作$X \\leftrightarrow Y$。

如果$Y$不函数依赖于$X$, 则记做$X \\nrightarrow Y$。

- 函数依赖是语义范畴的概念，只能通过语义确定
- 函数依赖要求对关系模式的<b>所有关系</b>都成立

</span>

</div>

---
<div class="boxbody">

### 函数依赖
****

<span style="font-size: 58%">

例 试指出学生关系模式
Student(sno, sname, class, cno, tno, tname, tage, taddr, grade)中存在的函数依赖。
- $\\mathsf{sno} \\rightarrow \\mathsf{sname}$, 每个学号只能有一个学生姓名
- $\\mathsf{sno} \\rightarrow \\mathsf{class}$, 每个学号只能有一个班级
- $\\mathsf{cno} \\rightarrow \\mathsf{tno}$, 设每门课只有一个教师任教，而一个教师可教多门课
- $\\mathsf{tno} \\rightarrow \\mathsf{tname}$, 每个教师只能有一个姓名
- $\\mathsf{tno} \\rightarrow \\mathsf{tage}$, 每个教师只能有一个年龄
- $\\mathsf{tno} \\rightarrow \\mathsf{taddr}$, 每个教师只能有一个地址
- $\\mathsf{(sno, cno)} \\rightarrow \\mathsf{grade}$, 每个学生学习一门课只能有一个成绩
- $\\mathsf{(sno, cno)} \\rightarrow \\mathsf{sname}$
- $\\mathsf{(sno, cno)} \\rightarrow \\mathsf{class}$
- $\\mathsf{(sno, cno)} \\rightarrow \\mathsf{cno}$
- $\\mathsf{(sno, cno)} \\rightarrow \\mathsf{tname}$
- $\\mathsf{(sno, cno)} \\rightarrow \\mathsf{tage}$
- $\\mathsf{(sno, cno)} \\rightarrow \\mathsf{taddr}$
</span>

</div>

---
<div class="boxbody">

### 函数依赖
****

<span style="font-size: 95%"> 

平凡、非平凡函数依赖

</span>

<span style="font-size: 85%">

- $X \\rightarrow Y$, 但$Y \\nsubseteq X$, 则称$X \\rightarrow Y$是非平凡的函数依赖 
- $X \\rightarrow Y$, 但$Y \\subseteq X$, 则称$X \\rightarrow Y$是平凡的函数依赖 

</span>

</div>

---
<div class="boxbody">

### 函数依赖
****

<span style="font-size: 95%"> 

完全、部分函数依赖 \
(Full Dependency, Partial Dependency)

</span>

<span style="font-size: 80%">

- 完全函数依赖: 在$R(U)$中, 如果$X \\rightarrow Y$, 并且对于$X$的任何真子集$X'$, 都有$X' \\rightarrow Y$, 则称$Y$对$X$完全函数依赖, 记作 $X \\xrightarrow{\text{f}} Y$
    - 左部为单属性的函数依赖一定是完全函数依赖
- 部分函数依赖: 在$R(U)$中, 如果$X \\rightarrow Y$, 并且存在$X$的真子集$X'$, 都有$X' \\rightarrow Y$, 则称$Y$对$X$部分函数依赖, 记作 $X \\xrightarrow{\text{p}} Y$

</span>

</div>

---
<div class="boxbody">

### 函数依赖
****

<span style="font-size: 85%"> 

左部为多属性函数依赖，如何判断其是否为完全函数依赖？\
方法：取真子集，看其能否决定右部属性

</span>

<span style="font-size: 70%">

例 试指出学生关系模式
Student(sno, sname, class, cno, tno, tname, tage, taddr, grade)中存在的完全函数依赖和部分函数依赖

$\\mathsf{sno} \\rightarrow \\mathsf{sname}$、
$\\mathsf{sno} \\rightarrow \\mathsf{class}$、
$\\mathsf{tname} \\rightarrow \\mathsf{tage}$、\
$\\mathsf{tname} \\rightarrow \\mathsf{taddr}$、
$\\mathsf{cno} \\rightarrow \\mathsf{tname}$
都是完全函数依赖

$\\mathsf{(sno, cno)} \\rightarrow \\mathsf{grade}$是一个完全函数依赖，\
因为
$\\mathsf{sno} \\nrightarrow \\mathsf{grade}$、
$\\mathsf{sno} \\nrightarrow \\mathsf{grade}$

</span>

</div>

---
<div class="boxbody">

### 函数依赖
****

<span style="font-size: 85%"> 

左部为多属性函数依赖，如何判断其是否为完全函数依赖？\
方法：取真子集，看其能否决定右部属性

</span>

<span style="font-size: 70%">

例 试指出学生关系模式
Student(sno, sname, class, cno, tno, tname, tage, taddr, grade)中存在的完全函数依赖和部分函数依赖

$\\mathsf{(sno, cno)} \\rightarrow \\mathsf{sname}$、
$\\mathsf{(sno, cno)} \\rightarrow \\mathsf{class}$、
$\\mathsf{(sno, cno)} \\rightarrow \\mathsf{tname}$、
$\\mathsf{(sno, cno)} \\rightarrow \\mathsf{tage}$、
$\\mathsf{(sno, cno)} \\rightarrow \\mathsf{taddr}$
都是部分函数依赖, 因为
$\\mathsf{sno} \\rightarrow \\mathsf{sname}$、
$\\mathsf{sno} \\rightarrow \\mathsf{class}$、
$\\mathsf{cno} \\rightarrow \\mathsf{tname}$、
$\\mathsf{cno} \\rightarrow \\mathsf{tage}$、
$\\mathsf{cno} \\rightarrow \\mathsf{taddr}$

</span>

</div>

---
<div class="boxbody">

### 函数依赖
****

<span style="font-size: 85%"> 

传递函数依赖

</span>

<span style="font-size: 70%">

定义：在$R(U)$中，如果$X \\rightarrow Y (Y \\nsubseteq X)$，$Y \\nrightarrow X$，且$Y \\rightarrow Z$，则称$Z$对$X$传递函数依赖，记作：$X \\xrightarrow{\\text{t}} Z$。

例 试指出学生关系模式
Student(sno, sname, class, cno, tno, tname, tage, taddr, grade)中存在的传递函数依赖。

因为$\\textsf{cno} \\rightarrow \\textsf{tno}$，$\\textsf{tno} \\rightarrow \\textsf{tname}$，\
所以$\\textsf{cno} \\rightarrow \\textsf{tname}$是一个传递函数依赖。\
类似地，$\\textsf{cno} \\rightarrow \\textsf{taddr}$也是一个传递函数依赖。

</span>

</div>

---
<div class="boxbody">

### 函数依赖
****

<span style="font-size: 85%"> 

候选键的形式定义

</span>

<span style="font-size: 70%">

设$X$为$R(U, F)$中的属性或属性组，若$X \\xrightarrow{\\text{f}} U$, 则$X$为$R$的候选键。

- 存在性与不唯一性
- 主属性: 包含在任何一个侯选键中的属性
- 非主属性：不包含在任何一个候选键中的属性
- 全键：整个属性组为键 \
例 $R$(customer, commodity, pdate)

</span>

</div>

        </textarea>
      </section>

    </section>

    <section>

      <section :id="filtered_section_id(5, 3)">
        <h2 id="doc_section" v-html="filtered_section_title(5, 3)">
        </h2>
      </section>

      <section data-markdown>
        <textarea data-template>

<div class="boxbody">

### 范式(Normal Forms)
****

<span style="font-size: 85%">

定义：关系数据库中符合某一级别的关系模式的集合。\
所谓"第几范式"，是表示关系模式的某一种级别。\
$R$为第几范式可以写成$R \in \\text{xNF}$。

各范式之间的包含关系为 \
5NF $\\subset$ 4NF $\\subset$ BCNF $\\subset$ 3NF $\\subset$ 2NF $\\subset$ 1NF

并不总是需要达到最高范式

</span>

</div>

---
<div class="boxbody">

### 范式
****

<span style="font-size: 95%"> 

实例

</span>

<span style="font-size: 75%"> 

有一个关系模式StuLocCourse(sno, sdepart, sloc, cno, grade) \
sno为学生的学号, 
sdepart为学生所在系, 
sloc为学生的住处，且每个系的学生住在同一个地方, 
cno为课程号, 
grade为成绩, 
主键为(sno, cno)

函数依赖有: \
sno $\\rightarrow$ sdepart, sno $\\rightarrow$ sloc, sdepart $\\rightarrow$ sloc \
(sno, cno) $\\xrightarrow{\\text{f}}$ grade, 
(sno, cno) $\\xrightarrow{\\text{p}}$ sdepart, 
(sno, cno) $\\xrightarrow{\\text{p}}$ sloc

<style type="text/css"> img[alt=nfrfundepexamp01] { width: 28%; } </style> 
&emsp; ![nfrfundepexamp01]({{require("../assets/db/ch05/nf_rfundep_examp01.svg")}})

</span>

</div>

---
<div class="boxbody">

### 第1范式(First Normal Form, 1NF) 
****

<span style="font-size: 90%">
 
定义: 如果一个关系模式不含有多值属性(表里为重复字段)和内部结构(如记录类型)属性, 则称该模式为第1范式。

</span>

<span style="font-size: 80%"> 

- 关系模式StuLocCourse $\\in$ 1NF
- 关系模式StuLocCourse存在更新异常(插入异常和删除异常)

</span>

</div>

---
<div class="boxbody">

### 第2范式(Second Normal Form, 2NF) 
****

<span style="font-size: 90%"> 

定义: 
若$R \\in$ 1NF，且每一个<b>非主属性完全函数依赖于键</b>，则$R \\in$ 2NF。

</span>

<span style="font-size: 80%"> 

例 关系模式StuLocCourse存在非主属性对键的部分函数依赖, \
故 StuLocCourse $\\in$ 1NF, StuLocCourse $\\notin$ 2NF

</span>

</div>

---
<div class="boxbody">

### 第2范式(Second Normal Form, 2NF) 
****

<span style="font-size: 90%"> 

例 

</span>

<span style="font-size: 80%"> 

将关系模式StuLocCourse分解为两个关系模式 \
StuLoc(sno, sdepart, sloc), StuCourse(sno, cno, grade)

<style type="text/css"> img[alt=2nfpexamp] { width: 28%; } </style> 
&emsp; ![2nfexamp]({{require("../assets/db/ch05/2nf_example.svg")}})

StuLoc的键为sno, StuCourse的键为(sno, cno), \
不存在非主属性对键的部分函数依赖, \
故 
StuLoc $\\in$ 2NF, 
StuCourse $\\in$ 2NF 

</span>

</div>

---
<div class="boxbody">

### 第2范式(Second Normal Form, 2NF) 
****

<span style="font-size: 90%"> 

例 

</span>

<span style="font-size: 68%"> 

关系模式StuLoc、 StuCourse消除了StuLocCourse中的某些更新异常，但仍然存在更新异常 

<div style="display: grid; grid-template-columns: 50% 50%;"> 
<div>

- 一个学生修很多课程 &#x2714; 
- 一个学生转系 &#x2714;
- 插入一个尚未选课的学生信息 &#x2714;
- 一个学生只选修了一门课，\
但现在决定不选了 &#x2714;

</div>
<div>

- 一个系有很多学生，且同系学生住在一个地方 &#x2717;  
- 一个学生转系 &#x2717;
- 一个新系创建但新生尚未注册 &#x2717;
- 一个系所有学生毕业了 &#x2717;

</div>
</div>

结论：2NF可以消除一些1NF中存在的更新异常，但仍然存在更新异常

</span>

</div>

---
<div class="boxbody">

### 第3范式(Third Normal Form, 3NF) 
****

<span style="font-size: 90%"> 

定义: 
若$R \\in$ 2NF，且每一个<b>非主属性不传递函数依赖于键</b>，则$R \\in$ 3NF。

</span>

<span style="font-size: 80%"> 

例 \
关系模式StuLoc存在非主属性对键的传递函数依赖sno $\\rightarrow$ sloc, 故StuLoc $\\notin$ 3NF \
关系模式StuCourse的键为(sno, cno), 不存在非主属性对键的传递函数, 故StuCourse $\\in$ 3NF

</span>

</div>

---
<div class="boxbody">

### 第3范式(Third Normal Form, 3NF) 
****

<span style="font-size: 90%"> 

例 

</span>

<span style="font-size: 80%"> 

将关系模式StuLoc分解为两个关系模式 \
StuDept(sno, sdepart), DeptLoc(sdepart, sloc)

<style type="text/css"> img[alt=3nfpexamp] { width: 28%; } </style> 
&emsp; ![3nfexamp]({{require("../assets/db/ch05/3nf_example.svg")}})

StuDept的键为sno, DeptLoc的键为sdepart, \
不存在非主属性对键的传递函数依赖, \
故 
StuDept $\\in$ 3NF, 
DeptLoc $\\in$ 3NF 

</span>

</div>

---
<div class="boxbody">

### 第3范式(Third Normal Form, 3NF) 
****

<span style="font-size: 90%"> 

例 

</span>

<span style="font-size: 68%"> 

关系模式StuDept、DeptLoc消除了StuLoc中的更新异常

- 一个系有很多学生，且同系学生住在一个地方 &#x2714; 
- 一个学生转系 &#x2714;
- 一个新系创建但新生尚未注册 &#x2714;
- 一个系所有学生毕业了 &#x2714;

结论：3NF可以消除一些2NF中存在的更新异常，但仍然存在更新异常

</span>

</div>

---
<div class="boxbody">

### Boyce-Codd范式
****

<span style="font-size: 90%"> 

Boyce-Codd范式(Boyce-Codd Normal Form, BCNF)
定义: 
若$R \\in$ 1NF，且<b>每一个决定因素都包含键</b>，则$R \\in$ BCNF。

</span>

<span style="font-size: 80%"> 

例 \
关系模式
StuCourse(sno, cno, grade)
有函数依赖(sno, cno) $\\rightarrow$ grade, 其决定因素包含键, StuCourse $\\in$ BCNF \
关系模式
StuDept(sno, sdepart)
有函数依赖sno $\\rightarrow$ sdepart, 其决定因素包含键, StuDept $\\in$ BCNF \
关系模式
DeptLoc(sdepart, sloc)
有函数依赖sdepart $\\rightarrow$ sloc, 其决定因素包含键, DeptLoc $\\in$ BCNF

</span>

</div>

---
<div class="boxbody">

### Boyce-Codd范式
****

<span style="font-size: 90%"> 

并非所有属于3NF的关系模式都属于BCNF

</span>

<span style="font-size: 80%"> 

例

有关系模式StuTeachCourse(sno, tno, cno), sno表示学生学号, tno表示教师编号, cno表示课程编号。
每一位教师只教一门课, 每门课有若干教师, 某一学生选定某门课，就对应一个固定的教师。

由语义可以得到函数依赖: \
tno $\\rightarrow$ cno, (sno, cno) $\\rightarrow$ tno, (sno, tno) $\\rightarrow$ cno, (sno, tno) $\\rightarrow$ (sno, tno, cno)

StuTeachCourse的键有(sno, cno)、(sno, tno) 

</span>

</div>

---
<div class="boxbody">

### Boyce-Codd范式
****

<span style="font-size: 90%"> 

并非所有属于3NF的关系模式都属于BCNF

所有属于BCNF的关系模式都属于3NF (可反证)

</span>

<span style="font-size: 80%"> 

例

StuTeachCourse
没有非主属性, 不存在非主属性对键的部分与传递依赖，故StuTeachCourse $\\in$ 3NF 

StuTeachCourse有函数依赖tno $\\rightarrow$ cno, 其决定因素tno不包含键, 故StuTeachCourse $\\notin$ BCNF

</span>

</div>

---
<div class="boxbody">

### 反规范化设计
****

<span style="font-size: 90%"> 

- 反规范化设计是为了提高查询效率
- 进行反规范化设计后，需要采取措施，处理可能出现的更新异常
 
</span>

<span style="font-size: 80%"> 

</span>

</div>

        </textarea>
      </section>

    </section>

    <section>

      <section :id="filtered_section_id(5, 4)">
        <h2 id="doc_section" v-html="filtered_section_title(5, 4)">
        </h2>
      </section>

      <section data-markdown>
        <textarea data-template>

<div class="boxbody">

### 逻辑蕴涵
****

<span style="font-size: 90%"> 

定义 设$F$是关系模式$R$的函数依赖集, $X$、$Y$是$R$的属性子集, 如果从$F$的函数依赖中能够推出$X \\rightarrow Y$, 则称$F$逻辑蕴涵$X \\rightarrow Y$。

在进行函数依赖的检查时，基于已有函数依赖集判断另外一些函数依赖是否成立，通过函数依赖的逻辑蕴涵即可做到。
 
</span>

<span style="font-size: 80%"> 

</span>

</div>

---
<div class="boxbody">

### Armstrong公理(阿氏公理)
****

<span style="font-size: 90%"> 

公理
对$R(U, F)$有
- 自反律: 若$Y \\subseteq X$, 则$X \\rightarrow Y$。
- 增广律: 若$X \\rightarrow Y$, 则$XZ \\rightarrow YZ$。
- 传递律: 若$X \\rightarrow Y$、$Y \\rightarrow Z$，则$X \\rightarrow Z$。

理解
- 自反律：所有的平凡函数依赖都是成立的
- 增广律：函数依赖两边增加相同属性也成立
- 传递律：由已知函数依赖可以推导出新依赖
 
</span>

<span style="font-size: 80%"> 

</span>

</div>

---
<div class="boxbody">

### Armstrong公理(阿氏公理)推论
****

<span style="font-size: 85%"> 

推论
- 合并规则：若$X \\rightarrow Y$、$X \\rightarrow Z$，则$X \\rightarrow YZ$。
- 分解规则：若$X \\rightarrow YZ$，则$X \\rightarrow Y$、$X \\rightarrow Z$。
- 伪传递规则：若$X \\rightarrow Y$、$WY \\rightarrow Z$，则$WX \\rightarrow Z$。

</span>

<span style="font-size: 80%"> 

</span>

</div>

---
<div class="boxbody">

### 函数依赖集闭包
****

<span style="font-size: 85%"> 

定义 设有关系模式$R(U, F)$, $X$、$Y$为$U$的子集, 函数依赖集$F$的闭包为: 
$F^{+} = \\lbrace X \\rightarrow Y \\vert X \\rightarrow Y \\text{基于阿氏公理推出} \\rbrace$, 
即$F^+$为$F$所逻辑蕴含的函数依赖全体. 

函数依赖集$F$的闭包$F^+$包括 \
&#x2460; $F$中的函数依赖, 由属性语义决定; \
&#x2461; 由$F$推出的平凡的函数依赖: \
&emsp; $A \\rightarrow \\phi$、$A \\rightarrow A$、$AB \\rightarrow A$、$\\ldots$这一类函数依赖与$F$无关, \
&emsp; 对$R$中任何属性都成立; \
&#x2462; 由$F$推出的非平凡的函数依赖

</span>

<span style="font-size: 80%"> 

</span>

</div>

---
<div class="boxbody">

### 函数依赖集闭包
****

<span style="font-size: 85%"> 

例

</span>

<span style="font-size: 80%">
 
有关系模式$R(A, B, C)$, 它的函依赖集$F = \\lbrace A \\rightarrow B, B \\rightarrow C \\rbrace$, 计算$F$的闭包. 

解: \
(1) $F$中的函数依赖: $A \\rightarrow B$, $B \\rightarrow C$ \
(2) 由$F$推出的非平凡函数依赖: $A \\rightarrow C$, $AC \\rightarrow B$ $\\ldots$ \
(3) 由$F$推出的平凡函数依赖: $A \\rightarrow \\phi$, $A \\rightarrow A$ $\\ldots$

$F^+$的计算很麻烦, 可能会非常大

</span>

</div>

---
<div class="boxbody">

### 属性集闭包
****

<span style="font-size: 85%"> 

定义 设有关系模式$R(U, F)$, $F$是属性集合$U$上的一个函数依赖集, $X \\subseteq U$, 属性集$X$关于$F$的闭包 
$X_F^+ = \\lbrace A \\vert X \\rightarrow A \\text{能由}F\\text{用阿氏公理导出} \\rbrace$, 可简写为$X^+$.

$X_F^+$是由$X$从$F$中推出的所有函数依赖右部的集合.

</span>

<span style="font-size: 80%">
 
例 

$R(A, B, C)$中, $F = \\lbrace A \\rightarrow B, B \\rightarrow C \\rbrace$, 则
$A_F^+ = \\lbrace A, B, C \\rbrace$, $B_F^+ = \\lbrace B, C \\rbrace$, $C_F^+ = \\lbrace C \\rbrace$

</span>

</div>

---
<div class="boxbody">

### 函数依赖集闭包转变成属性集闭包计算
****

<span style="font-size: 85%"> 

定理 \
$X \\rightarrow Y$能从$F$中用阿氏公理导出的充要条件是: $Y \\subseteq X_F^+$. 

判断$X \\rightarrow Y$在不在$F^+$中, 只要判断$Y$是否属于$X^+$. 

因此计算$F^+$的问题可以变换成计算$X^+$的问题, \
$X^+$的计算相对简单. 

</span>

<span style="font-size: 80%">
 
</span>

</div>

---
<div class="boxbody">

### 属性集闭包计算
****

<span style="font-size: 85%"> 

算法 有关系模式$R(U, F)$, $F$是属性集合$U$上的一个函数依赖集, $X \\subseteq U$, 求属性集$X$关于$F$的闭包$X_F^+$($X^+$)

</span>

<span style="font-size: 70%">

(1) $X^0 = X$ \
(2) $X^{i + 1} = X^i \\cup A$, \
&emsp;$A$由如下所有$Z_j$构成:  
&emsp;$F$中没有使用过的$Y_j \\rightarrow Z_j$且$Y_j \\subseteq X^i$; \
&emsp;求得$X^{i+1}$ 后, 对$Y_j \\rightarrow Z_j$做已使用的标记; \
&emsp;如果找不到这样的$A$, 则转(4) \
(3) 若$X^{i+1} = X^i$或$X^{i+1} = U$则转(4), 否则转(2) \
(4)结束, 输出$X^{i+1}$, 即为$X^+$

算法会终止吗? 最多$\\left| U \\right| - \\left| X \\right|$步

</span>

</div>

---
<div class="boxbody">

### 属性集闭包计算
****

<span style="font-size: 85%"> 

例

</span>

<span style="font-size: 70%">

有关系模式$R \\langle U, F \\rangle$, 其中 
$U = \\lbrace A, B, C, D, E, I \\rbrace$, 
$F = \\lbrace A \\rightarrow D, AB \\rightarrow E, BI \\rightarrow E, CD \\rightarrow I, E \\rightarrow C \rbrace$, 
请计算$(AE)^+$. 

解 \
(1) $X^0 = \\lbrace A, E \\rbrace$ \
(2) $X^1 = X^0 \\cup \\lbrace D, C \\rbrace = \\lbrace A, C, D, E \\rbrace$, 用了$A \\rightarrow D$和$E \\rightarrow C$ \
(3) $X^2 = X^1 \\cup \\lbrace I \\rbrace = \\lbrace A, C, D, E, I \\rbrace$, 用了$CD \\rightarrow I$ \
(4) $F$中没有左部属于$X^2$的函数依赖, $X^2$为$(AE)^+$

</span>

</div>

---
<div class="boxbody">

### 属性集闭包计算
****

<span style="font-size: 85%"> 

例

</span>

<span style="font-size: 70%">

有关系模式$R \\langle U, F \\rangle$, 其中 \
$U = \\lbrace A, B, C, D, E, G \\rbrace$, 
$F = \\lbrace AB \\rightarrow C, C \\rightarrow A, BC \\rightarrow D, ACD \\rightarrow B, D \\rightarrow EG, BE \\rightarrow C,$ \
&emsp;&emsp;&ensp;$CG \\rightarrow BD, CE \\rightarrow AG \\rbrace$, \
请计算$(BD)^+$.

解 \
(1) $X^0 = \\lbrace B, D \\rbrace$ \
(2) $X^1 = \\lbrace B, D, E, G \\rbrace$, 用了$D \\rightarrow EG$ \
(3) $X^2 = \\lbrace B, C, D, E, G \\rbrace$, 用了$BE \\rightarrow C$ \
(4) $X^3 = \\lbrace A, B, C, D, E, G \\rbrace$, 用了$C \\rightarrow A$ \
(5) $X^3 = U$, 所以$(BD)^+ = X^3 = \\lbrace A, B, C, D, E, G \\rbrace$

</span>

</div>

---
<div class="boxbody">

### 阿氏公理系统的完备性
****

<span style="font-size: 85%"> 

建立阿氏公理系统的目的在于有效而准确地从已知的函数依赖推出未知的函数依赖, 公理系统满足两个特性: \
(1) 正确性 \
按阿氏公理推出的依赖都是正确的 \
(2) 完备性 \
能推出所有的依赖 \
等价于所有不能用公理系统推出的依赖都不成立, \
即不能由已知函数依赖集$F$逻辑蕴涵

</span>

<span style="font-size: 70%">

</span>

</div>

---
<div class="boxbody">

### 函数依赖集等价
****

<span style="font-size: 85%"> 

等价定义 \
关系模式$R$有两个函数依赖集$F$、$G$, 如果$F^+ = G^+$, 就说函数依赖集$F$覆盖$G$或$F$与$G$等价.

有关性质 \
(1) 若$G \\subseteq F$, 则$G^+ \\subseteq F^+$ \
(2) $(F^+)^+ = F^+$

</span>

<span style="font-size: 70%">

</span>

</div>

---
<div class="boxbody">

### 函数依赖集等价
****

<span style="font-size: 85%"> 

判断方法 \
定理 关系模式$R$有两个函数依赖集$F = G$的充分必要条件是$F \\subseteq G^+$和$G \\subseteq F^+$.

</span>

<span style="font-size: 80%">

- 对每个属于$F$形如$X \\rightarrow Y$的属性依赖, 有$X \\rightarrow Y \\in G^+$, 即$Y \\subseteq X_G^+$
- 对每个属于$G$形如$X \\rightarrow Y$的属性依赖, 有$X \\rightarrow Y \\in F^+$, 即$Y \\subseteq X_F^+$

</span>

</div>

---
<div class="boxbody">

### 函数依赖集等价
****

<span style="font-size: 85%"> 

例

</span>

<span style="font-size: 65%">

关系模式$R$上有两个函数依赖集, $F = \\lbrace A \\rightarrow B, B \\rightarrow C \\rbrace$, $G = \\lbrace A \\rightarrow BC, B \\rightarrow C \\rbrace$, 请判断$F$和$G$是否等价.

解 \
(1) 先检查$F$中的每一个函数依赖是否属于$G^+$ \
$\\because$ $A_G^+ = \\lbrace A, B, C \\rbrace$, $\\therefore$ $\\lbrace B \\rbrace \\subseteq A_G^+$, $\\therefore$ $A \\rightarrow B \\in G^+$ \
$\\because$ $B_G^+ = \\lbrace B, C \\rbrace$, $\\therefore$ $\\lbrace C \\rbrace \\subseteq B_G^+$, $\\therefore$ $B \\rightarrow C \\in G^+$ \
$\\therefore$ $F \\subseteq G^+$ \
(2) 然后检查$G$中的每一个函数依赖是否属于$F^+$ \
$\\because$ $A_F^+ = \\lbrace A, B, C \\rbrace$, $\\therefore$ $\\lbrace B, C \\rbrace \\subseteq A_F^+$, $\\therefore$ $A \\rightarrow BC \\in F^+$ \
$\\because$ $B_F^+ = \\lbrace B, C \\rbrace$, $\\therefore$ $\\lbrace C \\rbrace \\subseteq B_F^+$, $\\therefore$ $B \\rightarrow C \\in F^+$ \
$\\therefore$ $G \\subseteq F^+$ \
由(1)和(2)可得$F$和$G$等价. 

</span>

</div>

---
<div class="boxbody">

### 最小函数依赖集
****

<span style="font-size: 85%"> 

定义

</span>

<span style="font-size: 68%">

关系模式$R$上有函数依赖集$F$, 
若$F$满足下列条件, \
(1) $F$中每个函数依赖的右部都是单属性; \
(2) 对于$F$的任一函数依赖$X \\rightarrow A$, $F - \\lbrace X \\rightarrow A \rbrace$与$F$都不等价, \
&emsp;即无多余函数依赖; \
(3) 对于$F$中的任一函数依赖$X \\rightarrow A$和$X$的真子集$X'$, \
&emsp;$(F - ( X \\rightarrow A) ) \\cup \\lbrace X' \\rightarrow A \\rbrace$与$F$都不等价, \
&emsp;即左部无多余属性 \
则称$F$为一个最小函数依赖集$F_{\\text{m}}$.

最小 \
(1) $F$中每个函数依赖的右部没有多余的属性; \
(2) $F$中不存在多余的函数依赖; \
(3) $F$中每个函数依赖的左部没有多余的属性

</span>

</div>

---
<div class="boxbody">

### 最小函数依赖集
****

<span style="font-size: 85%"> 

例

</span>

<span style="font-size: 80%">

如下函数依赖集, 哪个是最小依赖集？
 
$F_1 = \\lbrace A \\rightarrow D, BD \\rightarrow C, C \\rightarrow AD \\rbrace$ \
$F_2 = \\lbrace AB \\rightarrow C, B \\rightarrow A, B \\rightarrow C \\rbrace$ \
$F_3 = \\lbrace BC \\rightarrow D, D \\rightarrow A, A \\rightarrow D \\rbrace$

$F_1$中第三个依赖的右部不是单属性 \
$F_2$中第一个依赖左部有多余属性$A$ \
$F_3$满足最小依赖集的三个条件

</span>

</div>

---
<div class="boxbody">

### 最小函数依赖集
****

<span style="font-size: 80%"> 

定理 关系模式$R$上的函数依赖集$F$与一个最小函数依赖集$F_{\\text{m}}$等价. 

算法 计算最小函数依赖集$F_{\\text{m}}$

</span>

<span style="font-size: 80%">

(1) 分解: 使$F$中任一函数依赖的右部仅含有单属性. \
(2) 删除冗余的函数依赖: \
&emsp;对$F$中任一$X \\rightarrow A$, 在$F - \\lbrace X \\rightarrow A \\rbrace$中求$X^+$, \
&emsp;若$A \\subseteq X^+$, 则$X \\rightarrow A$为多余的. \
(3) 最小化左边的多余属性: \
&emsp;对$F$中任一$XY \\rightarrow A$, 在$F$中求$X^+$, \
&emsp;若$A \\subseteq X^+$, 则$Y$为多余的.

</span>

</div>

---
<div class="boxbody">

### 最小函数依赖集
****

<span style="font-size: 60%"> 

例

</span>

<span style="font-size: 55%">

关系模式$R$上有函数依赖集$F = \\lbrace B \\rightarrow C, C \\rightarrow AB, BC \\rightarrow A \\rbrace$, 求与$F$等价的最小函数依赖集.

(1) 分解$C \\rightarrow AB$, $F = \\lbrace B \\rightarrow C, C \\rightarrow A, C \\rightarrow B, BC \\rightarrow A \\rbrace$ \
(2) 判断$B \\rightarrow C$是否冗余 \
&emsp;$F' = \\lbrace C \\rightarrow A, C \\rightarrow B, BC \\rightarrow A \\rbrace$, $B_{F'}^+ = \\lbrace B \\rbrace$, $B \\rightarrow C$非冗余 \
(3) 判断$C \\rightarrow A$是否冗余 \
&emsp;$F' = \\lbrace B \\rightarrow C, C \\rightarrow B, BC \\rightarrow A \\rbrace$, $C_{F'}^+ = \\lbrace A, B, C \\rbrace$, \
&emsp;$C \\rightarrow A$冗余, $F = \\lbrace B \\rightarrow C, C \\rightarrow B, BC \\rightarrow A \\rbrace$ \
(4) 判断$C \\rightarrow B$是否冗余 \
&emsp;$F' = \\lbrace B \\rightarrow C, BC \\rightarrow A \\rbrace$, $C_{F'}^+ = \\lbrace C \\rbrace$, $C \\rightarrow B$非冗余 \
(5) 判断$BC \\rightarrow A$是否冗余 \
&emsp;$F' = \\lbrace B \\rightarrow C, C \\rightarrow B \\rbrace$, $BC_{F'}^+ = \\lbrace B, C \\rbrace$, $BC \\rightarrow A$非冗余 \
(6) 判断$BC \\rightarrow A$左边是否有多余属性 \
&emsp;$B_F^+ = \\lbrace A, B, C \\rbrace$, $\\lbrace A \\rbrace \\subseteq B_F^+$, $C$在$BC \\rightarrow A$中是多余的. \
故$F_{\\text{m}} = \\lbrace B \\rightarrow C, C \\rightarrow B, B \\rightarrow A \\rbrace$.

</span>

</div>

---
<div class="boxbody">

### 最小函数依赖集
****

<span style="font-size: 60%"> 

例

</span>

<span style="font-size: 55%">

关系模式$R$上有函数依赖集
$F = \\lbrace A \\rightarrow B, ABCD \\rightarrow E, EF \\rightarrow G, EF \\rightarrow H, ACDF \\rightarrow EG \\rbrace$, 
求与$F$等价的最小函数依赖集.

$F_{\\text{m}} = \\lbrace A \\rightarrow B, ACD \\rightarrow E, EF \\rightarrow G, EF \\rightarrow H \\rbrace$

</span>

</div>

---
<div class="boxbody">

### 最小函数依赖集
****

<span style="font-size: 90%"> 

一个函数依赖集的最小集不是惟一的。

</span>

<span style="font-size: 80%">

例

关系模式$R$上有函数依赖集
$F = \\lbrace A \\rightarrow B, B \\rightarrow A, B \\rightarrow C, A \\rightarrow C, C \\rightarrow A \\rbrace$, 
$F_{\\text{m1}} = \\lbrace A \\rightarrow B, B \\rightarrow C, C \\rightarrow A \\rbrace$, 
$F_{\\text{m2}} = \\lbrace A \\rightarrow B, B \\rightarrow A, A \\rightarrow C, C \\rightarrow A \\rbrace$. 

$F_{\\text{m1}}$里函数依赖无多余属性, 判断$B \\rightarrow C$是否冗余 \
$F_{\\text{m2}}$里函数依赖无多余属性, 依次判断$B \\rightarrow A$、$A \\rightarrow C$是否冗余

</span>

</div>

        </textarea>
      </section>

    </section>

    <section>

      <section :id="filtered_section_id(5, 5)">
        <h2 id="doc_section" v-html="filtered_section_title(5, 5)">
        </h2>
      </section>

      <section data-markdown>
        <textarea data-template>

<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 90%"> 

定义 关系模式$R \\langle U, D, \\mathtt{Dom}, F \\rangle$ 的分解就是将其分解成一组等价的子关系子模式. 

包括三个方面 \
(1) 属性的分解 \
(2) 关系的分解 \
(3) 函数依赖的分解

</span>

<span style="font-size: 80%">


</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 90%"> 

等价模式分解 

(1) 属性等价 \
(2) 保持无损连接 \
(3) 保持函数依赖

</span>

<span style="font-size: 80%">


</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 90%"> 

模式分解的属性等价性

关系模式$R \\langle U \\rangle$被分解为关系模式$R_1 \\langle U_1 \\rangle$、$R_2 \\langle U_2 \\rangle$、$\\ldots$、$R_n \\langle U_n \\rangle$, 
若$U = U_1 \\cup U_2 \\cup \\ldots \\cup U_n$, 
则该分解是属性等价的分解.

</span>

<span style="font-size: 80%">


</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 86%"> 

模式分解的无损连接性

关系模式$R \\langle U \\rangle$一个分解为$\\rho = \\lbrace R_1 \\langle U_1 \\rangle, R_2 \\langle U_2 \\rangle, \\ldots, R_n \\langle U_n \\rangle \\rbrace$, 
若对$R$中任一个关系$r$, 有 $r = \\Pi_{U_1}(r) \\Join \\Pi_{U_2}(r) \\Join \\ldots \\Join \\Pi_{U_n}(r)$, 
则该分解是保持无损连接的分解.

满足属性等价且有冗余属性的分解一定具有无损连接性吗？

</span>

<span style="font-size: 80%">


</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 90%"> 

</span>

<span style="font-size: 80%">

<style type="text/css"> img[alt=relmoddecompnolos] { width: 80%; } </style> 
&emsp; ![relmoddecompnolos]({{require("../assets/db/ch05/relmod_decomp_nolos.svg")}})

满足属性等价且有冗余属性的分解不一定具有无损连接性

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 86%"> 

模式分解的函数依赖保持性

定义
关系模式$R \\langle U, F \\rangle$, 
$F$是$R$的函数依赖集, $Z$是$R$的一个属性子集, $Z \\subseteq U$, 称$Z$所涉及到的$F^+$中所有的函数依赖为$F$在$Z$上的投影, 记为$\\Pi_Z(F)$, 有
$\\Pi_Z(F) = \\lbrace X \\rightarrow Y \vert X \\rightarrow Y \in F^+ 且 XY \\subseteq Z \\rbrace$. 

</span>

<span style="font-size: 80%">

例 关系模式$R \\langle U, F \\rangle$, $F = \\lbrace A \\rightarrow B, C \\rightarrow B, B \\rightarrow D, D \\rightarrow C \\rbrace$, \
设$Z = CD$, 则$\\Pi_{CD}(F) = \\lbrace C \\rightarrow D, D \\rightarrow C \\rbrace$.

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 86%"> 

模式分解的函数依赖保持性

关系模式$R \\langle U, F \\rangle$被分解为关系模式$R_1 \\langle U_1 \\rangle$、$R_2 \\langle U_2 \\rangle$、$\\ldots$、$R_k \\langle U_k \\rangle$, 
若$F$等价于$\\big( \\Pi_{U_1}(F) \\cup \\Pi_{U_2}(F) \\cup \\ldots \\cup \\Pi_{U_k}(F) \\big)$, 
则该分解是具有函数依赖保持性的分解.

</span>

<span style="font-size: 80%">

保持函数依赖的分解就是指: 当一个关系模式$R$被分解后, 无语义丢失, 原来的函数依赖关系都分散在分解后的子模式中. 

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 90%"> 

例

</span>

<span style="font-size: 80%">

有关系模式$R(A, B, C)$, 存在函数依赖集$F = \\lbrace A \\rightarrow B,  B \\rightarrow C \\rbrace$, \
下面的几个分解中, 哪一个最好？\
$ \\rho_1 = \\lbrace R_1(A), R_2(B), R_3(C) \\rbrace $ \
$ \\rho_2 = \\lbrace R_4(A, B), R_5(A, C) \\rbrace $ \
$ \\rho_3 = \\lbrace R_4(A, B), R_6(B, C) \\rbrace $ \
$ \\rho_4 = \\lbrace R_5(A, C), R_6(B, C) \\rbrace $ 

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 90%"> 

例

</span>

<span style="font-size: 80%">

| 分解 | 属性等价 | 保持无损连接 | 保持函数依赖 |
| :--------: | :-------: | :-------: | :-------: |
| $\\rho_1$ | &#x2714 | &#x2717 | &#x2717 |
| $\\rho_2$ | &#x2714 | &#x2714 | &#x2717 |
| $\\rho_3$ | &#x2714 | &#x2714 | &#x2714 |
| $\\rho_4$ | &#x2714 | &#x2717 | &#x2717 |

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

算法 无损连接性检验 \
输入: 关系模式$R(A_1, A_2, \\ldots, A_n)$, \
&emsp;&emsp;&ensp;其有函数依赖集$F$以及分解 \
&emsp;&emsp;&ensp;$ \\rho = \\lbrace R_1 \\langle U_1 \\rangle, R_2 \\langle U_2 \\rangle, \\ldots, R_k \\langle U_k \\rangle \\rbrace$. \
输出: 确定$\\rho$是否具有无损连接性.

</span>

<span style="font-size: 70%">

(1) 构造一个$k$行$n$列的表, 第$i$行对应于关系模式$R_i$, 第$j$列对应于属性$A_j$. 若$A_j \in U_i$, 则在第$i$行第$j$列上放符号$a_j$, 否则放符号$b_{ij}$. (属于用$a$代表, 且位置信息用$j$表示; 不属于用$b$代表, 且位置信息用$ij$表示)

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

无损连接性检验 

</span>

<span style="font-size: 70%">

(2) 考察$F$中每一个函数依赖$X \\rightarrow Y$, 并修改表中的元素: \
在$X$的分量中寻找相同的行, 然后将这些行中$Y$的分量改为相同的符号, 如果其中有$a_j$, 则将$b_{ij}$改为$a_j$; 若其中无$a_j$, 则全部改为$b_{ij}$ ($i$是这些行的行号最小值)
- 如果发现表中某一行变成了$a_1, a_2, \\ldots, a_n$, 则分解$\\rho$具有无损连接性. 
- 如果$F$中所有函数依赖都已考察完毕, 不能再修改表中的内容, 且没有发现这样的行, 则分解$\\rho$不具有无损连接性. 

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

无损连接性检验 举例

</span>

<span style="font-size: 70%">

关系模式$R \\langle U, F \\rangle$, 
$U = \\lbrace A, B, C, D, E \\rbrace$, $F = \\lbrace AB \\rightarrow C, C \\rightarrow D, D \\rightarrow E \\rbrace$. 
$R$的一个分解为 $ \\rho = \\lbrace R_1(A, B, C), R_2(C, D), R_3(D, E) \\rbrace $.
请判断$\\rho$是否具有无损连接性.
<style type="text/css"> img[alt=decompnolossexamp01] { width: 56%; } </style> 
&emsp; ![decompnolossexamp01]({{require("../assets/db/ch05/decomp_noloss_examp01.svg")}})

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

无损连接性检验 举例

</span>

<span style="font-size: 70%">

关系模式$R \\langle U, F \\rangle$, 
$U = \\lbrace A, B, C, D, E \\rbrace$, $F = \\lbrace A \\rightarrow C, B \\rightarrow C, C \\rightarrow D, DE \\rightarrow C, CE \\rightarrow A \\rbrace$. 
$R$的一个分解为 $ \\rho = \\lbrace R_1(A, D), R_2(A, B), R_3(B, E), R_4(C, D, E), R5(A, E) \\rbrace $.
请判断$\\rho$是否具有无损连接性.
<style type="text/css"> img[alt=decompnolossexamp0201] { width: 60%; } </style> 
&emsp; ![decompnolossexamp0201]({{require("../assets/db/ch05/decomp_noloss_examp0201.svg")}})

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

无损连接性检验 举例

</span>

<span style="font-size: 70%">

<style type="text/css"> img[alt=decompnolossexamp0202] { width: 60%; } </style> 
&emsp; ![decompnolossexamp0202]({{require("../assets/db/ch05/decomp_noloss_examp0202.svg")}})

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

无损连接性检验 举例

</span>

<span style="font-size: 70%">

<style type="text/css"> img[alt=decompnolossexamp0203] { width: 60%; } </style> 
&emsp; ![decompnolossexamp0203]({{require("../assets/db/ch05/decomp_noloss_examp0203.svg")}})

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

特殊情况: 只有两个子模式的无损分解判定

</span>

<span style="font-size: 70%">

定理 关系模式$R \\langle U, F \\rangle$, $F$是$R$上的函数依赖集, 分解$ \\rho = \\lbrace R_1 \\langle U_1, F_1 \\rangle, R_2 \\langle U_2, F_2 \\rangle \\rbrace $具有无损连接性的充分必要条件是: 
$ (U_1 \\cap U_2) \\rightarrow (U_1 - U_2) \\in F^+ $
或  
$ (U_1 \\cap U_2) \\rightarrow (U_2 - U_1) \\in F^+ $.

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

无损连接性检验 举例

</span>

<span style="font-size: 70%">

关系模式$R \\langle U, F \\rangle$, 
$U = \\lbrace A, B, C \\rbrace$, $F = \\lbrace A \\rightarrow B, C \\rightarrow B \\rbrace$. 
$R$的两个分解: 
$ \\rho_1 = \\lbrace R_1(A, B), R_2(B, C) \\rbrace $, 
$ \\rho_2 = \\lbrace R_3(A, C), R_2(B, C) \\rbrace $.
请判断$\\rho_1$、$\\rho_2$是否具有无损连接性.

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

无损连接性检验 举例

</span>

<span style="font-size: 70%">

判断$\\rho_1$是否具有无损连接性

$F = \\lbrace A \\rightarrow B, C \\rightarrow B \\rbrace$,  
$ \\rho_1 = \\lbrace R_1(A, B), R_2(B, C) \\rbrace $ 

(1) 构造表

</span>

<span style="font-size: 60%">

| $R_i$ | $A$ | $B$ | $C$ |
| :--------: | ------- | :-------: | ------- |
| $AB$ | $a_1$ | $a_2$ | $b_{13}$ |
| $BC$ | $b_{21}$ | $a_2$ | $a_{3}$ |

</span>

<span style="font-size: 70%">

对$A \\rightarrow B$, $A$列中无相同的行;
对$C \\rightarrow B$, $C$列中无相同的行. \
$\\rho_1$不具有无损连接性.

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

无损连接性检验 举例

</span>

<span style="font-size: 70%">

判断$\\rho_1$是否具有无损连接性

$F = \\lbrace A \\rightarrow B, C \\rightarrow B \\rbrace$,  
$ \\rho_1 = \\lbrace R_1(A, B), R_2(B, C) \\rbrace $ 

(2) 利用定理

$U_1 \\cap U_2 = \\lbrace B \\rbrace$, 
$U_1 - U_2 = \\lbrace A \\rbrace$, 
$U_2 - U_1 = \\lbrace C \\rbrace$, \
$(U_1 \\cap U_2) \\nrightarrow (U_1 - U_2)$,
$(U_1 \\cap U_2) \\nrightarrow (U_2 - U_1)$. \
$\\rho_1$不是无损连接分解. 

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

无损连接性检验 举例

</span>

<span style="font-size: 70%">

判断$\\rho_2$是否具有无损连接性

$F = \\lbrace A \\rightarrow B, C \\rightarrow B \\rbrace$,  
$ \\rho_2 = \\lbrace R_3(A, C), R_2(B, C) \\rbrace $ 

(1) 构造表

</span>

<span style="font-size: 60%">

<div style="display: grid; grid-template-columns: 50% 50%;">
<div> 

| $R_i$ | $A$ | $B$ | $C$ |
| :--------: | ------- | ------- | :-------: |
| $AC$ | $a_1$ | $b_{12}$ | $a_{3}$ |
| $BC$ | $b_{21}$ | $a_2$ | $a_{3}$ |

</div>
<div>

| $R_i$ | $A$ | $B$ | $C$ |
| :--------: | ------- | ------- | :-------: |
| $AC$ | $a_1$ | $a_2$ | $a_{3}$ |
| $BC$ | $b_{21}$ | $a_2$ | $a_{3}$ |

</div>
</div>

</span>

<span style="font-size: 70%">

对$C \\rightarrow B$, $C$列有相同的行, 
改写B列的相异符号为$a$, 下标为列号$2$. \
第一行变为$a_1 a_2 a_3$,
$\\rho_2$具有无损连接性.

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

无损连接性检验 举例

</span>

<span style="font-size: 70%">

判断$\\rho_2$是否具有无损连接性

$F = \\lbrace A \\rightarrow B, C \\rightarrow B \\rbrace$,  
$ \\rho_2 = \\lbrace R_3(A, C), R_2(B, C) \\rbrace $ 

(2) 利用定理

$U_3 \\cap U_2 = \\lbrace C \\rbrace $, 
$U_3 - U_2 = \\lbrace A \\rbrace$, 
$U_2 - U_3 = \\lbrace B \\rbrace$, \
$(U_3 \\cap U_2) \\rightarrow (U_2 - U_3)$,
$\\rho_2$是无损连接分解. 

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

例

</span>

<span style="font-size: 70%">

关系模式$R \\langle U, F \\rangle$, 
$U = \\lbrace A, B, C \\rbrace$, $F = \\lbrace A \\rightarrow B \\rbrace$. 
$R$的一个分解为 
$ \\rho = \\lbrace R_1(A, B), R_2(A, C) \\rbrace $, 
请判断$\\rho$是否具有无损连接性和函数依赖保持性.

$U_1 = AB$, $U_2 = AC$, \
因为$( U_1 \\cap U_2) \\rightarrow ( U_1 - U_2 )$, 即$A \\rightarrow B$, 所以$\\rho$相对于$F$是无损连接分解. \
因为$\\Pi_{U_1}(F) \\cup \\Pi_{U_2}(F) = \\lbrace A \\rightarrow B \\rbrace$, 与$F$等价, 所以$\\rho$相对于$F$是函数依赖保持的分解. 

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

例

</span>

<span style="font-size: 70%">

关系模式$R \\langle U, F \\rangle$, 
$U = \\lbrace A, B, C \\rbrace$, $F = \\lbrace A \\rightarrow C, B \\rightarrow C \\rbrace$. 
$R$的一个分解为 
$ \\rho = \\lbrace R_1(A, B), R_2(A, C) \\rbrace $, 
请判断$\\rho$是否具有无损连接性和函数依赖保持性.

$U_1 = AB$, $U_2 = AC$, \
因为$( U_1 \\cap U_2) \\rightarrow ( U_2 - U_1 )$, 即$A \\rightarrow C$, 所以$\\rho$相对于$F$是无损连接分解. \
因为$\\Pi_{U_1}(F) \\cup \\Pi_{U_2}(F) = \\lbrace A \\rightarrow C \\rbrace$, 与$F$不等价, 所以$\\rho$相对于$F$不是函数依赖保持的分解. 

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

例

</span>

<span style="font-size: 70%">

关系模式$R \\langle U, F \\rangle$, 
$U = \\lbrace A, B, C \\rbrace$, $F = \\lbrace A \\rightarrow B, B \\rightarrow C \\rbrace$. 
$R$的一个分解为 
$ \\rho = \\lbrace R_1(A, C), R_2(B, C) \\rbrace $, 
请判断$\\rho$是否具有无损连接性和函数依赖保持性.

$U_1 = AC$, $U_2 = BC$, \
$( U_1 \\cap U_2) = C$, $U_2 - U_1 = B$, $U_1 - U_2 = A$, 
$C \\rightarrow A$与$C \\rightarrow B$都不成立, 所以$\\rho$相对于$F$不是无损连接分解. \
$\\Pi_{U_1}(F) \\cup \\Pi_{U_2}(F) = \\lbrace B \\rightarrow C \\rbrace$, 与$F$不等价, 所以$\\rho$相对于$F$不是函数依赖保持的分解. 

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

对于任一关系模式，可找到一个分解达到3NF，且具有无损连接性和函数依赖保持性。

对于任一关系模式，可找到一个分解达到BCNF，可以保证无损连接，但不一定能保证保持函数依赖集。

</span>

<span style="font-size: 70%">

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

分解为3NF子模式且具有无损连接性和函数依赖保持性的算法

</span>

<span style="font-size: 60%">

输入: 关系模式$R \\langle U, F \\rangle$ \
输出: 子关系模式集 \
(1) 最小化：求$F$的最小函数依赖集$F_{\\text{m}}$. \
(2) 排除: 对$F_{\\text{m}}$中任一$X \\rightarrow A$, 若$XA = U$, $R$已为3NF, 则不分解, 结束. \
(3) 独立: 若$R$中$Z$属性在$F_{\\text{m}}$中未出现, 则所有$Z$为一个子模式的属性集, 令$U = U - Z$. \
(4) 分组: \
&emsp;&ensp;对$F_{\\text{m}}$中$X \\rightarrow A_1$、$\\ldots$、$X \\rightarrow A_n$, 用合成规则合成一个函数依赖, \
&emsp;&ensp;再对$F_{\\text{m}}$中每个$X \\rightarrow A$, 令$U_i = XA$. \
&emsp;&ensp;$R$的分解$\\rho = \\lbrace R_1(U_1), R_2(U_2), \\ldots, R_k(U_k) \\rbrace$. \
(5) 添键: 如果分解中没有一个子模式含$R$的候选码$X$, 则将分解变成$\\rho = \\lbrace R_1(U_1), R_2(U_2), \\ldots, R_k(U_k), R_{k + 1}(X) \\rbrace$; 如果存在$U_i \\subseteq U_j$, 则删去$R_i$. 

</span>

</div>

---
<div class="boxbody">

### 等价模式分解
****

<span style="font-size: 80%"> 

例

</span>

<span style="font-size: 60%">

有关系模式$R \\langle U, F \\rangle$, $U = \\lbrace E, G, H, I, J \\rbrace$, $F = \\lbrace E \\rightarrow I, J \\rightarrow I, I \\rightarrow G, GH \\rightarrow I, IH \\rightarrow E \\rbrace$, 将其分解为3NF子模式且同时具有无损连接性和函数依赖保持性.

求出$F$的最小函数依赖集为$F_{\\text{m}} = \\lbrace E \\rightarrow I, J \\rightarrow I, I \\rightarrow G, GH \\rightarrow I, IH \\rightarrow E \\rbrace$. \
得到分解为: $\\lbrace R_1(E, I), R_2(J, I), R_3(I, G), R_4(G, H, I), R_5(I, H, E) \\rbrace$ \
由候选码的定义和属性闭包的求解算法可以得到R的候选码中至少包含$J$和$H$, 且$({J, H})^+ = \\lbrace I, J, H, G, E \\rbrace = U$, $\\lbrace J, H \\rbrace$是$R$的候选码. \
上面的分解中没有子模式含有属性集$\\lbrace J, H \\rbrace$, 加上候选码并去重后得到最终的分解：$\\lbrace R_1(J, I), R_2(G, H, I), R_3(I, H, E), R_4(J, H) \\rbrace$.

</span>

</div>



        </textarea>
      </section>

    </section>

    <section data-background-color="white">

      <section :id="filtered_section_id(5, 6)">
        <h2 id="doc_section" v-html="filtered_section_title_thanks(5, 6)">
        </h2>
      </section>

    </section>

  </div>
 </div>
</template>


<script>
  import { isProxy, toRaw } from 'vue';
  import { reactive } from "vue";
  import VueHead from 'vue-head';
 
  import config from '../config.js';

  // import Reveal from 'reveal.js/dist/reveal.esm.js';
  // import Reveal from 'reveal.js';
  import Reveal from 'reveal.js/dist/reveal.js';
  import RevealMath from "reveal.js/plugin/math/math.esm";
  // import RevealSearch from "reveal.js/plugin/search/plugin.js";
  import speakerViewHTML from '@/assets/html/speaker-view.html';

  import { ElMessage } from 'element-plus';
  import { axios } from "axios";

  import { EditorState } from "@codemirror/state";
  import { EditorView, lineNumbers, highlightActiveLine} from "@codemirror/view";
  import { defaultKeymap } from "@codemirror/commands";
  import { bracketMatching, defaultHighlightStyle, syntaxHighlighting} from '@codemirror/language';
  import { python } from "@codemirror/lang-python";
  import { sql } from "@codemirror/lang-sql";
  import { bbedit } from '@uiw/codemirror-theme-bbedit';

  import { marked } from 'marked';
  import { mangle } from "marked-mangle";
  import { gfmHeadingId } from "marked-gfm-heading-id";

  import { io } from "socket.io-client";
  
  import QRious from "qrious";    

  import Chart from 'chart.js/auto'; 

  import links_html from '@/viewsslidescn/outline_db_05normalize.html';

  export default {
    name: "slides_iframe_db_chap05",

    /*
    components: {
       AudioPlayer,
    },
     */
	
    data(){
      return {
	Reveal: 0, 
    
        g_slide_id: 'dmdb',
        g_reveal_theme: "white",
        links_html,

        whu_logo: require('../assets/db/dm/whu_logo.svg'),

        eraser_src: require('../assets/imgs/chalkboard/sponge.png'),
        boardmarker_black: require('../assets/imgs/chalkboard/boardmarker-black.png'),
        boardmarker_blue: require('../assets/imgs/chalkboard/boardmarker-blue.png'),
        boardmarker_red: require('../assets/imgs/chalkboard/boardmarker-red.png'),
        boardmarker_green: require('../assets/imgs/chalkboard/boardmarker-green.png'),
        boardmarker_orange: require('../assets/imgs/chalkboard/boardmarker-orange.png'),
        boardmarker_purple: require('../assets/imgs/chalkboard/boardmarker-purple.png'),
        boardmarker_yellow: require('../assets/imgs/chalkboard/boardmarker-yellow.png'),
        chalk_white: require('../assets/imgs/chalkboard/chalk-white.png'),
        chalk_blue: require('../assets/imgs/chalkboard/chalk-blue.png'),
        chalk_red: require('../assets/imgs/chalkboard/chalk-red.png'),
        chalk_green: require('../assets/imgs/chalkboard/chalk-green.png'),
        chalk_orange: require('../assets/imgs/chalkboard/chalk-orange.png'),
        chalk_purple: require('../assets/imgs/chalkboard/chalk-purple.png'),
        chalk_yellow: require('../assets/imgs/chalkboard/chalk-yellow.png'),
        blackboard_png: require('../assets/imgs/chalkboard/blackboard.png'),
        whiteboard_png: require('../assets/imgs/chalkboard/whiteboard.png'),
        // chalkboard_src: require('../assets/chalkboard/chalkboard.json'),

        seminar_hosted: false, 
        seminar_joined: false, 

        chapter_titles:
          [
           'Course Overview',
	   '数据库简介',
	   '关系数据模型<br />与关系代数',
	   '结构化查询<br />语言SQL',			
	   '数据库设计与应用',			
	   '关系模式规范化',
	   '事务管理与<br />并发控制',	
          ],

        chapter_ids:
          [
           'overview',
	   'intro',
	   'relation',
	   'sql',			
	   'dbdesing',			
	   'normal',
	   'tran',	
	   'nosql',
           'review',	
          ],

        sections_titles:
          [
           [		
           'General Information',
           'Reference and Resources',
           'Grading',
           'Course Contents',
           'Thank You! <br />Any Questions?',
           ],
           [
           '信息与数据',
           '数据管理',
           '数据库系统发展',
           '数据库系统需求',
           '数据库系统组成结构',
           '常用数据库系统',
	   'Thank You! <br />Any Questions?',	
           ],
           [
		'关系数据模型',
		'关系完整性约束',
		'关系代数',
		'查询优化',
		'about key-value database',
		'Thank You! <br />Any Questions?',	
           ],
           [
		'SQL概述',
		'SQL访问控制',
		'SQL数据定义',
		'SQL定义完整性',
		'SQL数据操作',
		'简单查询',
		'复杂查询',
		'SQL过程与函数',
		'Thank You! <br />Any Questions?',	
           ],
           [
		'数据库设计概述',
		'E-R模型设计与转换',
		'存储结构与索引',
		'嵌入式SQL与数据库应用',
		'Thank You! <br />Any Questions?',	
           ],
    	   [
		'规范化含义',
		'函数依赖',
		'范式',
		'数据依赖公理',
		'等价模式分解',
		'Thank You! <br />Any Questions?',	
	   ], 
          ],

        sections_ids:
          [
           [		
            'geninfo',
            'ref',
            'grade', 
            'content',
            'thanks',
           ],
           [
            'infodata',
            'infomgm',
            'dbsysdev',
            'dbsysreq',
            'dbsyscomp',
            'dbsyslist',
	    'thanks',	
           ],
           [
		'rmod',
		'rint',
		'ralg',
		'queopt',
		'aboutkvdb',
		'thanks',
           ],
           [
		'sql_intro',
		'acc_ctl',
		'ddl',
		'def_int',
		'dml',
		'simp_que',
		'cplx_que',
		'fun_proc',
		'thanks',
           ],
           [
		'db_design_intro', 
		'er_design',
		'storage_index', 
		'embed_sql_app',
		'thanks',
           ],
           [
		'normal_concept',
		'fun_dep', 
		'norm_form',
		'as_axiom',
		'relmodel_decomp',
		'thanks',
           ],
           [
           ],
           [
           ],
           [
           ],
          ],

      } // end of return 
    }, // end of data(){

    head: {
      // link tags
      link: [
        { rel: 'apple-touch-icon-precomposed', href: require( '../assets/db/dm/apple-touch-icon-114x114.png'), sizes: '114x114', type: 'image/png' }, 
        // ...
      ],
    }, 

    created() {
      const _this = this;
    },

    mounted() {

      // polyfill
      if (!String.prototype.startsWith) {
	  String.prototype.startsWith = function (searchString, position) {
	    return this.substr(position || 0, searchString.length) === searchString;
	  };
      }
      if (!String.prototype.endsWith) {
	  String.prototype.endsWith = function (search, this_len) {
	    if (this_len === undefined || this_len > this.length) {
	      this_len = this.length;
	    }
	    return this.substring(this_len - search.length, this_len) === search;
	  };
      }

      marked.use(mangle());
      const options = {
	 prefix: "my-prefix-",
      };
      marked.use(gfmHeadingId(options));

      let app = document.getElementById("app");
      if ( app.className != 'reveal' ) {
        app.className = "reveal";
	
        this.Reveal = new Reveal({ 
          center: true,
          hash: true,
          slideNumber: 'c/t',
          // autoSlide: 5000,
          // loop: true,
          // logo: true,
          // showNotes: true,        
          showNotes: 'separate-page', 
          controls: true,
          progress: true,
	  history: true,
          transition: 'slide',

          plugins: [ RevealMath ],
          // plugins: [ RevealMath.KaTex ],
          // plugins: [ RevealSearch ],

          menu: {
		  numbers: 'c',
		  openSlideNumber: true,
                  hideMissingTitles: true,
		  themes: false,
		  themesPath: 'dist/theme/',
		  transitions: true,
		  custom: [
		    {
		      title: 'Custom',
		      icon: '<i class="fa fa-bookmark">',
		      src: "links.html",
		    },
		  ],
          },

	  chalkboard: { 
	     // src: this.chalkboard_src,
	     storage: "chalkboard-session-storage",
	  },

	  seminar: { 
		server: "http://172.28.6.107:6090/",
		port: 6090,
		// server: "https://fajiangyu.net:8090/",
		// port: 8090,
		hash: '$2a$05$hhgakVn1DWBfgfSwMihABeYToIBEiQGJ.ONa.HWEiNGNI6mxFCy8S', // for password '123456'
		room: 'tc',
		autoJoin: true, 
	  },

	  chart: {
		defaults: {
			color: 'lightgray', // color of labels
			scale: { 
				beginAtZero: true, 
				ticks: { stepSize: 1 },
				grid: { color: "lightgray" } , // color of grid lines
			},
		},
		bar: { backgroundColor: [ "rgba(20,220,220,.8)" , "rgba(220,120,120,.8)", "rgba(20,120,220,.8)" ]},
		pie: { backgroundColor: [ ["rgba(20,220,220,.8)" , "rgba(220,120,120,.8)", "rgba(20,120,220,.8)"] ]},
	  },
        });
	
        this.g_deck = this.Reveal;
        this.Reveal.initialize();

        var room = this.getParameterByName("room") || this.generateToken(32);
        // console.log("seminar room: ", room);
        var link = this.addParam(window.location.href, "room", room );
        document.getElementById("room").innerHTML = link;
        document.getElementById("room").href = link;
        var qrcode = new QRious({ element: document.getElementById('qrcode'), level: 'H', padding: 25, size: 500, value: link });
        document.getElementById("div_seminar_host").style.visibility = 'visible';
        document.getElementById("div_seminar_room").style.visibility = 'hidden';
        document.getElementById("div_seminar_close").style.visibility = 'hidden';

        this.initRevealMarkdownSlides(this.Reveal);

        /*
        let myTheme = EditorView.theme({
         // "&": {
         //    border: "1px solid #c0c0c0",
         // },
         "&.cm-editor.cm-focused": {
            outline: "none",
         },
        }, {dark: false})

        let edView01 = new EditorView({
         state: EditorState.create({
            doc: this.cardcont_dm_python04_code,
            extensions: [
               EditorState.readOnly.of(true),
               // lineNumbers(),
               EditorView.lineWrapping,
               highlightActiveLine(),
               bracketMatching(),
               syntaxHighlighting(defaultHighlightStyle, { fallback: true }),
               python(),
               sql(),
               myTheme, 
               bbedit, 
            ],
          }),
          parent: document.querySelector("#editor01")
        });
         */

        this.initRevealMenu(this.Reveal);

        this.initTitleFooter("");
        
        if ( !this.isiOs() ) {
	   this.initScreenfull();
	} 

        this.initRevealToolbar(this.Reveal);

        if ( !this.isMobile() ) {
           this.initSpeakerView(this.Reveal);
        }
 
        this.initRevealZoom(this.Reveal);
        RevealZoom.zoom_in();
      
        this.initChalkboard(this.Reveal);

        this.initSeminar(this.Reveal);

        document.querySelector("#host").addEventListener('click', function(e) {
		e.preventDefault();
		RevealSeminar.open_or_join_room(document.getElementById('password').value);
        });
        document.querySelector("#close").addEventListener('click', function(e) {
		e.preventDefault();
		RevealSeminar.close_room(document.getElementById('password').value);
        });

        this.initChart(this.Reveal);	

        this.initPoll(this.Reveal);

        this.initQnA(this.Reveal);

        this.initSearch(this.Reveal);
      }

    }, // end of mounted  

    computed: {

      filtered_chapter_title: function() {
        let that = this;
        return (chapter_counter) => chapter_counter + '. ' + that.chapter_titles.slice(chapter_counter, chapter_counter + 1);
        // return (chapter_counter) => that.chapter_titles.slice(chapter_counter, chapter_counter + 1);
      },

      filtered_chapter_id: function() {
        let that = this;
        return (chapter_counter) => that.chapter_ids.slice(chapter_counter, chapter_counter + 1);
      },

      filtered_section_title: function() {
        let that = this;
         return (chapter_counter, section_counter) => chapter_counter + '.' + section_counter + ' ' +
                that.sections_titles[chapter_counter].slice(section_counter - 1, section_counter);
        // return (chapter_counter, section_counter) => section_counter + '. ' +
               that.sections_titles[chapter_counter].slice(section_counter - 1, section_counter);
      },

      filtered_section_id: function() {
        let that = this;
        return (chapter_counter, section_counter) => 
               that.sections_ids[chapter_counter].slice(section_counter - 1, section_counter);
      },

      filtered_section_title_thanks: function() {
        let that = this;
        return (chapter_counter, section_counter) =>
               that.sections_titles[chapter_counter].slice(section_counter - 1, section_counter);
      },

    }, // end of computed   

    methods: {
       isMobile() {
	   if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
	     return true
	   } else {
	     return false
	   }
       },

       /*	
       isMobileExciPad() {
	   if(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
	     return true
	   } else {
	     return false
	   }
       },
        */

       isiOs() {
	   if(/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
	     return true
	   } else {
	     return false
	   }
       },

       copy_code: function(code_text='') {
          try {
             return navigator.clipboard
                .writeText(code_text)
                .then( () => {
                   ElMessage({
                      showClose: true,
                      message: 'copy code succeed',
                      type: 'success',
                      offset: 800,
                   });
                   return Promise.resolve()
                })
                .catch( err => {
                   console.error('copy failed:', err)
                   ElMessage({
                      showClose: true,
                      message: 'copy code failed',
                      type: 'error',
                      offset: 800,
                   });
                   return Promise.reject(err)
                })
          } catch (e) {
             // console.log('copy_code: not support navigator.clipboard.writeText')
             const copy_data = code_text
             let copy_text_area = document.createElement('textarea') 
             copy_text_area.style.position = 'fixed'
             copy_text_area.style.top = '-10000px'
             copy_text_area.style.zIndex = '-999'
             document.body.appendChild(copy_text_area)
             // console.log('copy_text_area', copy_text_area)
             copy_text_area.value = copy_data
             // console.log(copy_text_area.value)
             copy_text_area.focus()
             copy_text_area.select()
             try { 
                let result = document.execCommand('Copy') 
                // copy_text_area.remove()
                document.body.removeChild(copy_text_area)
                if (!result || result === 'unsuccessful') {
                   ElMessage({
                      showClose: true,
                      message: 'copy code failed',
                      type: 'error',
                      offset: 800,
                   });
                   return Promise.reject('copy code failed')
                } else {
                   ElMessage({
                      showClose: true,
                      message: 'copy code succeed',
                      type: 'success',
                      offset: 800,
                   });
                   return Promise.resolve()
                }
             } catch (e) {
                document.body.removeChild(copy_text_area)
                ElMessage({
                   showClose: true,
                   message: 'copy code failed',
                   type: 'error',
                   offset: 800,
                });
                return Promise.reject('this browser does not support document.execCommand Copy')
             }
          }
       },

       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*!
	 * The reveal.js markdown plugin. Handles parsing of
	 * markdown inside of presentations as well as loading
	 * of external markdown documents.
	 */

	/**
	 * Starts processing and converting Markdown within the
	 * current reveal.js deck.
	 */
	initRevealMarkdownSlides: function( deck ) {
		let that = this;

		const DEFAULT_SLIDE_SEPARATOR = '\r?\n---\r?\n',
		// const DEFAULT_SLIDE_SEPARATOR = '---',
			  DEFAULT_NOTES_SEPARATOR = 'notes?:',
			  DEFAULT_ELEMENT_ATTRIBUTES_SEPARATOR = '\\\.element\\\s*?(.+?)$',
			  DEFAULT_SLIDE_ATTRIBUTES_SEPARATOR = '\\\.slide:\\\s*?(\\\S.+?)$';

		const SCRIPT_END_PLACEHOLDER = '__SCRIPT_END__';

		const CODE_LINE_NUMBER_REGEX = /\[([\s\d,|-]*)\]/;

		const HTML_ESCAPE_MAP = {
		  '&': '&amp;',
		  '<': '&lt;',
		  '>': '&gt;',
		  '"': '&quot;',
		  "'": '&#39;'
		};

		let { renderer, animateLists, ...markedOptions } = deck.getConfig().markdown || {};

		if( !renderer ) {
			renderer = new marked.Renderer();

			renderer.code = ( code, language ) => {

				// Off by default
				let lineNumbers = '';

				// Users can opt in to show line numbers and highlight
				// specific lines.
				// ```javascript []        show line numbers
				// ```javascript [1,4-8]   highlights lines 1 and 4-8
				if( CODE_LINE_NUMBER_REGEX.test( language ) ) {
					lineNumbers = language.match( CODE_LINE_NUMBER_REGEX )[1].trim();
					lineNumbers = `data-line-numbers="${lineNumbers}"`;
					language = language.replace( CODE_LINE_NUMBER_REGEX, '' ).trim();
				}

				// Escape before this gets injected into the DOM to
				// avoid having the HTML parser alter our code before
				// highlight.js is able to read it
				code = escapeForHTML( code );

				return `<pre><code ${lineNumbers} class="${language}">${code}<\/code><\/pre>`;
			};
		}

		if( animateLists === true ) {
			renderer.listitem = text => `<li class="fragment">${text}<\/li>`;
		}

		marked.setOptions( {
			renderer,
			...markedOptions
		} );

		// return processSlides( deck.getRevealElement() ).then( convertSlides );
		processSlides( deck.getRevealElement() ).then( convertSlides );

		/**
		 * Retrieves the markdown contents of a slide section
		 * element. Normalizes leading tabs/whitespace.
		 */
		function getMarkdownFromSlide ( section ) {
			// look for a <script> or <textarea data-template> wrapper
			var template = section.querySelector( '[data-template]' ) || section.querySelector( 'script' );

			// strip leading whitespace so it isn't evaluated as code
			var text = ( template || section ).textContent;

			// restore script end tags
			text = text.replace( new RegExp( SCRIPT_END_PLACEHOLDER, 'g' ), '<\/script>' );

			var leadingWs = text.match( /^\n?(\s*)/ )[1].length,
				leadingTabs = text.match( /^\n?(\t*)/ )[1].length;

			if( leadingTabs > 0 ) {
				text = text.replace( new RegExp('\\n?\\t{' + leadingTabs + '}(.*)','g'), function(m, p1) { return '\n' + p1 ; } );
			}
			else if( leadingWs > 1 ) {
				text = text.replace( new RegExp('\\n? {' + leadingWs + '}(.*)', 'g'), function(m, p1) { return '\n' + p1 ; } );
			}

			return text;
		}

		/**
		 * Retrieves the markdown contents of a slide section
		 * element. Normalizes leading tabs/whitespace.
		 */
		function getMarkdownFromFile ( section ) {
			/*
			// look for a <script> or <textarea data-template> wrapper
			var template = section.querySelector( '[data-template]' ) || section.querySelector( 'script' );

			// strip leading whitespace so it isn't evaluated as code
			var text = ( template || section ).textContent;
			 */

			var text = section.getAttribute( 'data-markdown' );
			// console.log("getMarkdownFromFile data-markdown text: ", text);

			// restore script end tags
			text = text.replace( new RegExp( SCRIPT_END_PLACEHOLDER, 'g' ), '<\/script>' );

			var leadingWs = text.match( /^\n?(\s*)/ )[1].length,
				leadingTabs = text.match( /^\n?(\t*)/ )[1].length;

			if( leadingTabs > 0 ) {
				text = text.replace( new RegExp('\\n?\\t{' + leadingTabs + '}(.*)','g'), function(m, p1) { return '\n' + p1 ; } );
			}
			else if( leadingWs > 1 ) {
				text = text.replace( new RegExp('\\n? {' + leadingWs + '}(.*)', 'g'), function(m, p1) { return '\n' + p1 ; } );
			}

			return text;
		}

		/**
		 * Given a markdown slide section element, this will
		 * return all arguments that aren't related to markdown
		 * parsing. Used to forward any other user-defined arguments
		 * to the output markdown slide.
		 */
		function getForwardedAttributes ( section ) {
			var attributes = section.attributes;
			var result = [];

			for( var i = 0, len = attributes.length; i < len; i++ ) {
				var name = attributes[i].name,
					value = attributes[i].value;

				// disregard attributes that are used for markdown loading/parsing
				if( /data\-(markdown|separator|vertical|notes)/gi.test( name ) ) continue;

				if( value ) {
					result.push( name + '="' + value + '"' );
				}
				else {
					result.push( name );
				}
			}

			return result.join( ' ' );

		} 

		/**
		 * Inspects the given options and fills out default
		 * values for what's not defined.
		 */
		function getSlidifyOptions ( options ) {
			options = options || {};
			options.separator = options.separator || DEFAULT_SLIDE_SEPARATOR;
			options.notesSeparator = options.notesSeparator || DEFAULT_NOTES_SEPARATOR;
			options.attributes = options.attributes || '';

			return options;

		}

		/**
		 * Helper function for constructing a markdown slide.
		 */
		function createMarkdownSlide ( content, options ) {
			options = getSlidifyOptions( options );

			var notesMatch = content.split( new RegExp( options.notesSeparator, 'mgi' ) );

			if( notesMatch.length === 2 ) {
				content = notesMatch[0] + '<aside class="notes">' + marked(notesMatch[1].trim()) + '<\/aside>';
			}

			// prevent script end tags in the content from interfering
			// with parsing
			content = content.replace( /<\/script>/g, SCRIPT_END_PLACEHOLDER );

			// return '<script type="text\/template">' + content + '<\/script>';
			return '<textarea data-template>' + content + '<\/textarea>';

		}
 
		/**
		 * Parses a data string into multiple slides based
		 * on the passed in separator arguments.
		 */
		function slidify ( markdown, options ) {
			options = getSlidifyOptions( options );

			var separatorRegex = new RegExp( options.separator 
                                             + ( options.verticalSeparator ? '|' + options.verticalSeparator : '' ), 'mg' ),
				horizontalSeparatorRegex = new RegExp( options.separator );

			var matches,
				lastIndex = 0,
				isHorizontal,
				wasHorizontal = true,
				content,
				sectionStack = [];

			// iterate until all blocks between separators are stacked up
			while( matches = separatorRegex.exec( markdown ) ) {
				var notes = null;

				// determine direction (horizontal by default)
				isHorizontal = horizontalSeparatorRegex.test( matches[0] );

				if( !isHorizontal && wasHorizontal ) {
					// create vertical stack
					sectionStack.push( [] );
				}

				// pluck slide content from markdown input
				content = markdown.substring( lastIndex, matches.index );

				if( isHorizontal && wasHorizontal ) {
					// add to horizontal stack
					sectionStack.push( content );
				}
				else {
					// add to vertical stack
					sectionStack[sectionStack.length-1].push( content );
				}

				lastIndex = separatorRegex.lastIndex;
				wasHorizontal = isHorizontal;
			}

			// add the remaining slide
			( wasHorizontal ? sectionStack : sectionStack[sectionStack.length-1] ).push( markdown.substring( lastIndex ) );

			var markdownSections = '';

			// flatten the hierarchical stack, and insert <section data-markdown> tags
			for( var i = 0, len = sectionStack.length; i < len; i++ ) {
				// vertical
				if( sectionStack[i] instanceof Array ) {
					markdownSections += '<section '+ options.attributes +'>';

					sectionStack[i].forEach( function( child ) {
						markdownSections += '<section data-markdown>' + createMarkdownSlide( child, options ) + '<\/section>';
					} );

					markdownSections += '<\/section>';
				}
				else {
					markdownSections += '<section '+ options.attributes +' data-markdown>' 
                                                            + createMarkdownSlide( sectionStack[i], options ) + '<\/section>';
				}
			}

			return markdownSections;

		}

		/**
		 * Parses any current data-markdown slides, splits
		 * multi-slide markdown into separate sections and
		 * handles loading of external markdown.
		 */
		function processSlides ( scope ) {
			return new Promise( function( resolve ) {

				var externalPromises = [];

				[].slice.call( scope.querySelectorAll( 'section[data-markdown]:not([data-markdown-parsed])') ).forEach( 
				  function( section, i ) {

					if( section.getAttribute( 'data-markdown' ).length ) {
							
						/*
						externalPromises.push( loadExternalMarkdown( section ).then(

							// Finished loading external file
							function( xhr, url ) {
								section.outerHTML = slidify( xhr.responseText, {
									separator: section.getAttribute( 'data-separator' ),
									verticalSeparator: section.getAttribute( 'data-separator-vertical' ),
									notesSeparator: section.getAttribute( 'data-separator-notes' ),
									attributes: getForwardedAttributes( section )
								});
							},

							// Failed to load markdown
							function( xhr, url ) {
								section.outerHTML = '<section data-state="alert">' +
									'ERROR: The attempt to fetch ' + url + ' failed with HTTP status ' + 
									xhr.status + '.' +
									'Check your browser\'s JavaScript console for more details.' +
									'<p>Remember that you need to serve the presentation HTML from a ' + 
									'HTTP server.<\/p>' +
									'<\/section>';
							}

						) );
						*/	

						section.outerHTML = slidify( getMarkdownFromFile( section ), {
							separator: section.getAttribute( 'data-separator' ),
							verticalSeparator: section.getAttribute( 'data-separator-vertical' ),
							notesSeparator: section.getAttribute( 'data-separator-notes' ),
							attributes: getForwardedAttributes( section )
						});

					}
					else {

						section.outerHTML = slidify( getMarkdownFromSlide( section ), {
							separator: section.getAttribute( 'data-separator' ),
							verticalSeparator: section.getAttribute( 'data-separator-vertical' ),
							notesSeparator: section.getAttribute( 'data-separator-notes' ),
							attributes: getForwardedAttributes( section )
						});

					}

				});

				Promise.all( externalPromises ).then( resolve );

			} );

		} 

		function loadExternalMarkdown ( section ) {
			return new Promise( function( resolve, reject ) {

				var xhr = new XMLHttpRequest(),
					url = section.getAttribute( 'data-markdown' );

				var datacharset = section.getAttribute( 'data-charset' );

				// see https://developer.mozilla.org/en-US/docs/Web/API/element.getAttribute#Notes
				if( datacharset != null && datacharset != '' ) {
					xhr.overrideMimeType( 'text\/html; charset=' + datacharset );
				}

				xhr.onreadystatechange = function( section, xhr ) {
					if( xhr.readyState === 4 ) {
						// file protocol yields status code 0 (useful for local debug, mobile applications etc.)
						if ( ( xhr.status >= 200 && xhr.status < 300 ) || xhr.status === 0 ) {

							resolve( xhr, url );

						}
						else {

							reject( xhr, url );

						}
					}
				}.bind( this, section, xhr );

				xhr.open( 'GET', url, true );

				try {
					xhr.send();
				}
				catch ( e ) {
					console.warn( 'Failed to get the Markdown file ' + url + 
					   '. Make sure that the presentation and the file are served by ' + 
					   'a HTTP server and the file can be found there. ' + e );
					resolve( xhr, url );
				}

			} );

		}

		/**
		 * Check if a node value has the attributes pattern.
		 * If yes, extract it and add that value as one or several attributes
		 * to the target element.
		 *
		 * You need Cache Killer on Chrome to see the effect on any FOM transformation
		 * directly on refresh (F5)
		 * http://stackoverflow.com/questions/5690269/disabling-chrome-cache-for-website-development/7000899#answer-11786277
		 */
		function addAttributeInElement ( node, elementTarget, separator ) {
			var mardownClassesInElementsRegex = new RegExp( separator, 'mg' );
			var mardownClassRegex = new RegExp( "([^\"= ]+?)=\"([^\"]+?)\"|(data-[^\"= ]+?)(?=[\" ])", 'mg' );
			var nodeValue = node.nodeValue;
			var matches,
				matchesClass;
			if( matches = mardownClassesInElementsRegex.exec( nodeValue ) ) {

				var classes = matches[1];
				nodeValue = nodeValue.substring( 0, matches.index ) + nodeValue.substring( mardownClassesInElementsRegex.lastIndex );
				node.nodeValue = nodeValue;
				while( matchesClass = mardownClassRegex.exec( classes ) ) {
					if( matchesClass[2] ) {
						elementTarget.setAttribute( matchesClass[1], matchesClass[2] );
					} else {
						elementTarget.setAttribute( matchesClass[3], "" );
					}
				}
				return true;
			}
			return false;
		}
 
		/**
		 * Add attributes to the parent element of a text node,
		 * or the element of an attribute node.
		 */
		function addAttributes ( section, element, previousElement, separatorElementAttributes, separatorSectionAttributes ) {
			if ( element != null && element.childNodes != undefined && element.childNodes.length > 0 ) {
				var previousParentElement = element;
				for( var i = 0; i < element.childNodes.length; i++ ) {
					var childElement = element.childNodes[i];
					if ( i > 0 ) {
						var j = i - 1;
						while ( j >= 0 ) {
							var aPreviousChildElement = element.childNodes[j];
							if ( typeof aPreviousChildElement.setAttribute == 'function' && 
							     aPreviousChildElement.tagName != "BR" ) {
								previousParentElement = aPreviousChildElement;
								break;
							}
							j = j - 1;
						}
					}
					var parentSection = section;
					if( childElement.nodeName ==  "section" ) {
						parentSection = childElement ;
						previousParentElement = childElement ;
					}
					if ( typeof childElement.setAttribute == 'function' || childElement.nodeType == Node.COMMENT_NODE ) {
						addAttributes( parentSection, childElement, previousParentElement, 
						               separatorElementAttributes, separatorSectionAttributes );
					}
				}
			}

			if ( element.nodeType == Node.COMMENT_NODE ) {
				if ( addAttributeInElement( element, previousElement, separatorElementAttributes ) == false ) {
					addAttributeInElement( element, section, separatorSectionAttributes );
				}
			}
		}

		/**
		 * Converts any current data-markdown slides in the
		 * DOM to HTML.
		 */
		function convertSlides () {
			var sections = deck.getRevealElement().querySelectorAll( '[data-markdown]:not([data-markdown-parsed])');

			[].slice.call( sections ).forEach( function( section ) {

				section.setAttribute( 'data-markdown-parsed', true )

				var notes = section.querySelector( 'aside.notes' );
				var markdown = getMarkdownFromSlide( section );

				section.innerHTML = marked( markdown );
				addAttributes( 	section, section, null, section.getAttribute( 'data-element-attributes' ) ||
								section.parentNode.getAttribute( 'data-element-attributes' ) ||
								DEFAULT_ELEMENT_ATTRIBUTES_SEPARATOR,
								section.getAttribute( 'data-attributes' ) ||
								section.parentNode.getAttribute( 'data-attributes' ) ||
								DEFAULT_SLIDE_ATTRIBUTES_SEPARATOR);

				// If there were notes, we need to re-add them after
				// having overwritten the section's HTML
				if( notes ) {
					section.appendChild( notes );
				}

			} );

			return Promise.resolve();

		}

		function escapeForHTML ( input ) {

		  return input.replace( /([&<>'"])/g, char => HTML_ESCAPE_MAP[char] );

		}

		window.RevealMarkdown = window.RevealMarkdown || {
			id: 'markdown',

			init: function( deck ) {
			  return initRevealMarkdownSlides( deck );
			},

			processSlides: processSlides,
			convertSlides: convertSlides,
			slidify: slidify,
			marked: marked
		};

		return this;   
	},

	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*
	 * Reveal.js menu plugin
	 * MIT licensed
	 * (c) Greg Denehy 2020
	 */

	initRevealMenu (deck) {
	       let that = this;

	       const ieVersion = (function () {
		    let browser = /(msie) ([\w.]+)/.exec(
		      window.navigator.userAgent.toLowerCase()
		    );
		    if (browser && browser[1] === 'msie') {
		      return parseFloat(browser[2]);
		    }
		    return null;
	       })();

	       // var deck;
	       var config;
	       var options;
	       var initialised = false;

	       /*
		* Extend object a with the properties of object b.
		* If there's a conflict, object b takes precedence.
		*/
	       function extend(a, b) {
		    for (var i in b) {
		      a[i] = b[i];
		    }
	       } 

	       /* 
		* Dispatches an event of the specified type from the
		* reveal DOM element.
		*/
	       function dispatchEvent (type, args) {
		    var event = document.createEvent('HTMLEvents', 1, 2);
		    event.initEvent(type, true, true);
		    extend(event, args);
		    document.querySelector('.reveal').dispatchEvent(event);

		    // If we're in an iframe, post each reveal.js event to the
		    // parent window. Used by the notes plugin
		    if (deck.getConfig().postMessageEvents && window.parent !== window.self) {
		      window.parent.postMessage(
			JSON.stringify({
			  namespace: 'reveal',
			  eventName: type,
			  state: deck.getState()
			}),
			'*'
		      );
		    }
	       }

	       function select(selector, el) {
		  if (!el) {
		     el = document;
		  }
		  return el.querySelector(selector);
	       }

	       function selectAll(selector, el) {
		    if (!el) {
		      el = document;
		    }
		    return Array.prototype.slice.call(el.querySelectorAll(selector));
	       }

	       function create(tagName, attrs, content) {
		  var el = document.createElement(tagName);
		  if (attrs) {
		     Object.getOwnPropertyNames(attrs).forEach(function (n) {
			el.setAttribute(n, attrs[n]);
		     });
		  }
		  if (content) el.innerHTML = content;
		  return el;
	       }

	       function changeStylesheet (id, href) {
		    /*
		    // take note of the previous theme and remove it, then create a new stylesheet reference and insert it
		    // this is required to force a load event so we can change the menu style to match the new style
		    var stylesheet = select('link#' + id);
		    var parent = stylesheet.parentElement;
		    var sibling = stylesheet.nextElementSibling;
		    stylesheet.remove();

		    var newStylesheet = stylesheet.cloneNode();
		    newStylesheet.setAttribute('href', href);
		    newStylesheet.onload = function () {
		      matchRevealStyle();
		    };
		    parent.insertBefore(newStylesheet, sibling);
		     */

		    // console.log("changeStylesheet id, href: ", id, href);
		    g_reveal_theme = href; 
	       }

	       function openPanel(event, ref) {
		    // console.log("openPanel()");
		    openMmenu(event);
		    var panel = ref;
		    if (typeof ref !== 'string') {
		      panel = event.currentTarget.getAttribute('data-panel');
		    }
		    select('.slide-menu-toolbar > li.active-toolbar-button').classList.remove(
		      'active-toolbar-button'
		    );
		    select('li[data-panel="' + panel + '"]').classList.add(
		      'active-toolbar-button'
		    );
		    select('.slide-menu-panel.active-menu-panel').classList.remove(
		      'active-menu-panel'
		    );
		    select('div[data-panel="' + panel + '"]').classList.add(
		      'active-menu-panel'
		    );
	       }

	       function initOptions(config) {
		    options = config.menu || {};
			
		    /*
		    options.path = options.path || scriptPath() || 'plugin/menu/';
		    if (!options.path.endsWith('/')) {
		      options.path += '/';
		    }
		     */

		    // Set defaults
		    if (options.side === undefined) options.side = 'left';

		    if (options.numbers === undefined) options.numbers = false;

		    if (typeof options.titleSelector !== 'string')
		      options.titleSelector = 'h1, h2, h3, h4, h5';

		    if (options.hideMissingTitles === undefined)
		      options.hideMissingTitles = false;

		    if (options.useTextContentForMissingTitles === undefined)
		      options.useTextContentForMissingTitles = false;

		    if (options.markers === undefined) options.markers = true;

		    if (typeof options.themesPath !== 'string')
		      options.themesPath = 'dist/theme/';
		    if (!options.themesPath.endsWith('/')) options.themesPath += '/';

		    // if (!select('link#theme')) options.themes = false;
		    if (options.themes === true) {
		      options.themes = [
			/*
			{ name: 'Black', theme: options.themesPath + 'black.css' },
			{ name: 'White', theme: options.themesPath + 'white.css' },
			{ name: 'League', theme: options.themesPath + 'league.css' },
			{ name: 'Sky', theme: options.themesPath + 'sky.css' },
			{ name: 'Beige', theme: options.themesPath + 'beige.css' },
			{ name: 'Simple', theme: options.themesPath + 'simple.css' },
			{ name: 'Serif', theme: options.themesPath + 'serif.css' },
			{ name: 'Blood', theme: options.themesPath + 'blood.css' },
			{ name: 'Night', theme: options.themesPath + 'night.css' },
			{ name: 'Moon', theme: options.themesPath + 'moon.css' },
			{ name: 'Solarized', theme: options.themesPath + 'solarized.css' }
			 */
			{ name: 'Black', theme: 'black' },
			{ name: 'White', theme: 'white' },
			{ name: 'League', theme: 'league' },
			{ name: 'Sky', theme: 'sky' },
			{ name: 'Beige', theme: 'beige' },
			{ name: 'Simple', theme: 'simple' },
			{ name: 'Serif', theme: 'serif' },
			{ name: 'Blood', theme: 'blood' },
			{ name: 'Night', theme: 'night' },
			{ name: 'Moon', theme: 'moon' },
			{ name: 'Solarized', theme: 'solarized' }
		      ];
		    } else if (!Array.isArray(options.themes)) {
		      options.themes = false;
		    }
		    // console.log("options.themes: ", options.themes);

		    if (options.transitions === undefined) options.transitions = false;
		    if (options.transitions === true) {
		      options.transitions = [
			'None',
			'Fade',
			'Slide',
			'Convex',
			'Concave',
			'Zoom'
		      ];
		    } else if (
		      options.transitions !== false &&
		      (!Array.isArray(options.transitions) ||
			!options.transitions.every(function (e) {
			  return typeof e === 'string';
			}))
		    ) {
		      console.error(
			"reveal.js-menu error: transitions config value must be 'true' or an array of strings, eg ['None', 'Fade', 'Slide')"
		      );
		      options.transitions = false;
		    }
		    if (ieVersion && ieVersion <= 9) {
		      // transitions aren't support in IE9 anyway, so no point in showing them
		      options.transitions = false;
		    }

		    if (typeof options.openButton === 'undefined') options.openButton = true;

		    if (typeof options.openSlideNumber === 'undefined')
		      options.openSlideNumber = false;

		    if (typeof options.keyboard === 'undefined') options.keyboard = true;

		    if (typeof options.sticky === 'undefined') options.sticky = false;

		    if (typeof options.autoOpen === 'undefined') options.autoOpen = true;

		    if (typeof options.delayInit === 'undefined') options.delayInit = false;

		    if (typeof options.openOnInit === 'undefined') options.openOnInit = false;

		    // console.log("options: ", options);
	       }

	       function matchRevealStyle() {
		    var revealStyle = window.getComputedStyle(select('.reveal'));
		    var element = select('.slide-menu');
		    element.style.fontFamily = revealStyle.fontFamily;
		    //XXX could adjust the complete menu style to match the theme, ie colors, etc
	       }

	       function openItem(item, force) {
		    var h = parseInt(item.getAttribute('data-slide-h'));
		    var v = parseInt(item.getAttribute('data-slide-v'));
		    var theme = item.getAttribute('data-theme');
		    var highlightTheme = item.getAttribute('data-highlight-theme');
		    var transition = item.getAttribute('data-transition');

		    if (!isNaN(h) && !isNaN(v)) {
		      deck.slide(h, v);
		    }
		     
		    // console.log("theme: ", theme);
		    if (theme) {
		      changeStylesheet('theme', theme);
		    }

		    if (highlightTheme) {
		      changeStylesheet('highlight-theme', highlightTheme);
		    }

		    if (transition) {
		      deck.configure({ transition: transition });
		    }

		    var link = select('a', item);
		    if (link) {
		      if (
			force ||
			!options.sticky ||
			(options.autoOpen && link.href.startsWith('#')) ||
			link.href.startsWith(
			  window.location.origin + window.location.pathname + '#'
			)
		      ) {
			link.click();
		      }
		    }

		    closeMenu();
	       }

	       function clicked(event) {
		    // console.log("clicked()");
		    if (event.target.nodeName !== 'A') {
		      event.preventDefault();
		    }
		    openItem(event.currentTarget);
	       }

	       function highlightCurrentSlide() {
		    var cur_id = deck.getCurrentSlide().getAttribute('id');
		    // console.log("slide change, current slide id: ", cur_id);
		    if (cur_id != null) {
		       that.g_slide_id = cur_id;	
		    }
		    // console.log("slide change, g_slide_id: ", that.g_slide_id);
	  
		    var state = deck.getState();
		    selectAll('li.slide-menu-item, li.slide-menu-item-vertical').forEach(
		      function (item) {
			item.classList.remove('past');
			item.classList.remove('active');
			item.classList.remove('future');

			var h = parseInt(item.getAttribute('data-slide-h'));
			var v = parseInt(item.getAttribute('data-slide-v'));
			if (h < state.indexh || (h === state.indexh && v < state.indexv)) {
			  item.classList.add('past');
			} else if (h === state.indexh && v === state.indexv) {
			  item.classList.add('active');
			} else {
			  item.classList.add('future');
			}
		      }
		    );

		    if (isOpen()) {
		       closeMenu();
		       openMenu();	
		    }		
	       }

  	       var mouseSelectionEnabled = true;
	       function disableMouseSelection () {
		    mouseSelectionEnabled = false;
	       } 

	       function reenableMouseSelection() {
		    // wait until the mouse has moved before re-enabling mouse selection
		    // to avoid selections on scroll
		    select('nav.slide-menu').addEventListener('mousemove', function fn(e) {
		      select('nav.slide-menu').removeEventListener('mousemove', fn);
		      //XXX this should select the item under the mouse
		      mouseSelectionEnabled = true;
		    });
	       }

	       // Keyboard handling
	       //
	       function getOffset (el) {
		    var _x = 0;
		    var _y = 0;
		    while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
		      _x += el.offsetLeft - el.scrollLeft;
		      _y += el.offsetTop - el.scrollTop;
		      el = el.offsetParent;
		    }
		    return { top: _y, left: _x };
	       }

	       function visibleOffset (el) {
		    var offsetFromTop = getOffset(el).top - el.offsetParent.offsetTop;
		    if (offsetFromTop < 0) return -offsetFromTop;
		    var offsetFromBottom =
		      el.offsetParent.offsetHeight -
		      (el.offsetTop - el.offsetParent.scrollTop + el.offsetHeight);
		    if (offsetFromBottom < 0) return offsetFromBottom;
		    return 0;
	       }

	       function keepVisible(el) {
		    var offset = visibleOffset(el);
		    if (offset) {
		      disableMouseSelection();
		      el.scrollIntoView(offset > 0);
		      reenableMouseSelection();
		    }
	       }

	       function scrollItemToTop (el) {
		    disableMouseSelection();
		    el.offsetParent.scrollTop = el.offsetTop;
		    reenableMouseSelection();
	       }

	       function scrollItemToBottom (el) {
		    disableMouseSelection();
		    el.offsetParent.scrollTop =
		      el.offsetTop - el.offsetParent.offsetHeight + el.offsetHeight;
		    reenableMouseSelection();
	       } 

	       function selectItem (el) {
		    el.classList.add('selected');
		    keepVisible(el);
		    if (options.sticky && options.autoOpen) openItem(el);
	       }

	       function onDocumentKeyDown (event) {
		    // opening menu is handled by registering key binding with Reveal below
		    if (isOpen()) {
		      event.stopImmediatePropagation();
		      switch (event.keyCode) {
			// case 77:
			// 	closeMenu();
			// 	break;
			// h, left - change panel
			case 72:
			case 37:
			  prevPanel();
			  break;
			// l, right - change panel
			case 76:
			case 39:
			  nextPanel();
			  break;
			// k, up
			case 75:
			case 38:
			  var currItem =
			    select('.active-menu-panel .slide-menu-items li.selected') ||
			    select('.active-menu-panel .slide-menu-items li.active');
			  if (currItem) {
			    selectAll('.active-menu-panel .slide-menu-items li').forEach(
			      function (item) {
				item.classList.remove('selected');
			      }
			    );
			    var nextItem =
			      select(
				'.active-menu-panel .slide-menu-items li[data-item="' +
				  (parseInt(currItem.getAttribute('data-item')) - 1) +
				  '"]'
			      ) || currItem;
			    selectItem(nextItem);
			  } else {
			    var item = select(
			      '.active-menu-panel .slide-menu-items li.slide-menu-item'
			    );
			    if (item) selectItem(item);
			  }
			  break;
			// j, down
			case 74:
			case 40:
			  var currItem =
			    select('.active-menu-panel .slide-menu-items li.selected') ||
			    select('.active-menu-panel .slide-menu-items li.active');
			  if (currItem) {
			    selectAll('.active-menu-panel .slide-menu-items li').forEach(
			      function (item) {
				item.classList.remove('selected');
			      }
			    );
			    var nextItem =
			      select(
				'.active-menu-panel .slide-menu-items li[data-item="' +
				  (parseInt(currItem.getAttribute('data-item')) + 1) +
				  '"]'
			      ) || currItem;
			    selectItem(nextItem);
			  } else {
			    var item = select(
			      '.active-menu-panel .slide-menu-items li.slide-menu-item'
			    );
			    if (item) selectItem(item);
			  }
			  break;
			// pageup, u
			case 33:
			case 85:
			  var itemsAbove = selectAll(
			    '.active-menu-panel .slide-menu-items li'
			  ).filter(function (item) {
			    return visibleOffset(item) > 0;
			  });
			  var visibleItems = selectAll(
			    '.active-menu-panel .slide-menu-items li'
			  ).filter(function (item) {
			    return visibleOffset(item) == 0;
			  });

			  var firstVisible =
			    itemsAbove.length > 0 &&
			    Math.abs(visibleOffset(itemsAbove[itemsAbove.length - 1])) <
			      itemsAbove[itemsAbove.length - 1].clientHeight
			      ? itemsAbove[itemsAbove.length - 1]
			      : visibleItems[0];
			  if (firstVisible) {
			    if (
			      firstVisible.classList.contains('selected') &&
			      itemsAbove.length > 0
			    ) {
			      // at top of viewport already, page scroll (if not at start)
			      // ...move selected item to bottom, and change selection to last fully visible item at top
			      scrollItemToBottom(firstVisible);
			      visibleItems = selectAll(
				'.active-menu-panel .slide-menu-items li'
			      ).filter(function (item) {
				return visibleOffset(item) == 0;
			      });
			      if (visibleItems[0] == firstVisible) {
				// prev item is still beyond the viewport (for custom panels)
				firstVisible = itemsAbove[itemsAbove.length - 1];
			      } else {
				firstVisible = visibleItems[0];
			      }
			    }
			    selectAll('.active-menu-panel .slide-menu-items li').forEach(
			      function (item) {
				item.classList.remove('selected');
			      }
			    );
			    selectItem(firstVisible);
			    // ensure selected item is positioned at the top of the viewport
			    scrollItemToTop(firstVisible);
			  }
			  break;
			// pagedown, d
			case 34:
			case 68:
			  var visibleItems = selectAll(
			    '.active-menu-panel .slide-menu-items li'
			  ).filter(function (item) {
			    return visibleOffset(item) == 0;
			  });
			  var itemsBelow = selectAll(
			    '.active-menu-panel .slide-menu-items li'
			  ).filter(function (item) {
			    return visibleOffset(item) < 0;
			  });

			  var lastVisible =
			    itemsBelow.length > 0 &&
			    Math.abs(visibleOffset(itemsBelow[0])) < itemsBelow[0].clientHeight
			      ? itemsBelow[0]
			      : visibleItems[visibleItems.length - 1];
			  if (lastVisible) {
			    if (
			      lastVisible.classList.contains('selected') &&
			      itemsBelow.length > 0
			    ) {
			      // at bottom of viewport already, page scroll (if not at end)
			      // ...move selected item to top, and change selection to last fully visible item at bottom
			      scrollItemToTop(lastVisible);
			      visibleItems = selectAll(
				'.active-menu-panel .slide-menu-items li'
			      ).filter(function (item) {
				return visibleOffset(item) == 0;
			      });
			      if (visibleItems[visibleItems.length - 1] == lastVisible) {
				// next item is still beyond the viewport (for custom panels)
				lastVisible = itemsBelow[0];
			      } else {
				lastVisible = visibleItems[visibleItems.length - 1];
			      }
			    }
			    selectAll('.active-menu-panel .slide-menu-items li').forEach(
			      function (item) {
				item.classList.remove('selected');
			      }
			    );
			    selectItem(lastVisible);
			    // ensure selected item is positioned at the bottom of the viewport
			    scrollItemToBottom(lastVisible);
			  }
			  break;
			// home
			case 36:
			  selectAll('.active-menu-panel .slide-menu-items li').forEach(
			    function (item) {
			      item.classList.remove('selected');
			    }
			  );
			  var item = select(
			    '.active-menu-panel .slide-menu-items li:first-of-type'
			  );
			  if (item) {
			    item.classList.add('selected');
			    keepVisible(item);
			  }
			  break;
			// end
			case 35:
			  selectAll('.active-menu-panel .slide-menu-items li').forEach(
			    function (item) {
			      item.classList.remove('selected');
			    }
			  );
			  var item = select(
			    '.active-menu-panel .slide-menu-items:last-of-type li:last-of-type'
			  );
			  if (item) {
			    item.classList.add('selected');
			    keepVisible(item);
			  }
			  break;
			// space, return
			case 32:
			case 13:
			  var currItem = select(
			    '.active-menu-panel .slide-menu-items li.selected'
			  );
			  if (currItem) {
			    openItem(currItem, true);
			  }
			  break;
			// esc
			case 27:
			  closeMenu(null, true);
			  break;
		      }
		    }
	       }

	       function openMenu(event) {
		    // console.log("options: ", options);

		    if (event) event.preventDefault();
		    if (!isOpen()) {
		      select('body').classList.add('slide-menu-active');
		      select('.reveal').classList.add(
			'has-' + options.effect + '-' + options.side
		      );
		      select('.slide-menu').classList.add('active');
		      select('.slide-menu-overlay').classList.add('active');

		      // identify active theme
		      if (options.themes) {
			selectAll('div[data-panel="Themes"] li').forEach(function (i) {
			  // console.log("i.classList: ", i.classList);
			  i.classList.remove('active');
			});
			selectAll(
			  // 'li[data-theme="' + select('link#theme').getAttribute('href') + '"]'
			  // 'li[data-theme="dist/theme/white.css"]'
			  'li[data-theme="white"]'
			).forEach(function (i) {
			  i.classList.add('active');
			});
		      }

		      // identify active transition
		      if (options.transitions) {
			selectAll('div[data-panel="Transitions"] li').forEach(function (i) {
			  i.classList.remove('active');
			});
			// selectAll('li[data-transition="' + config.transition + '"]').forEach(
			selectAll('li[data-transition="' + deck.getConfig().transition + '"]').forEach(
			  function (i) {
			    i.classList.add('active');
			  }
			);
		      }
		      
		      if (options.custom) {
			 // var state = deck.getState();
			 // if (state.indexh != undefined) {
			    var slide_id;	
			    selectAll('div[data-panel="Custom0"] li').forEach(function (i) {
			       slide_id = i.firstChild.getAttribute('href').slice(2);
			       // console.log("custom panel list link a.href id: ", slide_id);
			       if (slide_id === that.g_slide_id) {
				  i.classList.add('active');
			       } else {
				  i.classList.remove('active');
			       } 
			    });
			 // }
		      }

		      // set item selections to match active items
		      var items = selectAll('.slide-menu-panel li.active');
		      items.forEach(function (i) {
			i.classList.add('selected');
			keepVisible(i);
		      });
		    }
	       }
 
	       function closeMenu (event, force) {
		    // console.log("options: ", options);

		    if (event) event.preventDefault();
		    if (!options.sticky || force) {
		      select('body').classList.remove('slide-menu-active');
		      select('.reveal').classList.remove(
			'has-' + options.effect + '-' + options.side
		      );
		      select('.slide-menu').classList.remove('active');
		      select('.slide-menu-overlay').classList.remove('active');
		      selectAll('.slide-menu-panel li.selected').forEach(function (i) {
			i.classList.remove('selected');
		      });
		    }
	       }

	       function toggleMenu (event) {
		    let menu_opened = isOpen();
		    // console.log("toggle menu menu_opened: ", menu_opened);
		    if (menu_opened) {
		      closeMenu(event, true);
		    } else {
		      openMenu(event);
		    }
	       }

	       function isOpen () {
		  // console.log("isOpen() select('body').classList.contains('slide-menu-active')", 
                  //             select('body').classList.contains('slide-menu-active'));
		  return select('body').classList.contains('slide-menu-active');
	       }

	       function openPanel (event, ref) {
		    // console.log("openPanel(), ref: ", ref); 
		    openMenu(event);
		    var panel = ref;
		    if (typeof ref !== 'string') {
		      panel = event.currentTarget.getAttribute('data-panel');
		    }
		    // console.log("openPanel(), panel: ", panel); 
		     
		    if (select('.slide-menu-toolbar > li.active-toolbar-button') != null ) {
		       select('.slide-menu-toolbar > li.active-toolbar-button').classList.remove(
			  'active-toolbar-button'
		       );
		    }

		    select('li[data-panel="' + panel + '"]').classList.add(
		      'active-toolbar-button'
		    );

		    if (select('.slide-menu-panel.active-menu-panel') != null) { 
			    select('.slide-menu-panel.active-menu-panel').classList.remove(
			      'active-menu-panel'
			    );
		    }
		    if ( select('div[data-panel="' + panel + '"]') != null ) {
			    select('div[data-panel="' + panel + '"]').classList.add(
			      'active-menu-panel'
			    );
		    }
	       }

	       function nextPanel () {
		    var next =
		      (parseInt(select('.active-toolbar-button').getAttribute('data-button')) +
			1) %
		      buttons;
		    openPanel(
		      null,
		      select('.toolbar-panel-button[data-button="' + next + '"]').getAttribute(
			'data-panel'
		      )
		    );
	       }

	       function prevPanel() {
		    var next =
		      parseInt(select('.active-toolbar-button').getAttribute('data-button')) -
		      1;
		    if (next < 0) {
		      next = buttons - 1;
		    }
		    openPanel(
		      null,
		      select('.toolbar-panel-button[data-button="' + next + '"]').getAttribute(
			'data-panel'
		      )
		    );
	       }

	       var buttons = 0;
	       function initMenu() {
		   if (!initialised) {
		      var parent = select('.reveal').parentElement;
		      var top = create('div', { class: 'slide-menu-wrapper' });
		      parent.appendChild(top);
		      // console.log("initMenu top:", top);
		      var panels = create('nav', {
			class: 'slide-menu slide-menu--' + options.side
		      });
		      if (typeof options.width === 'string') {
			if (
			  ['normal', 'wide', 'third', 'half', 'full'].indexOf(options.width) !=
			  -1
			) {
			  panels.classList.add('slide-menu--' + options.width);
			} else {
			  panels.classList.add('slide-menu--custom');
			  panels.style.width = options.width;
			}
		      }
		      top.appendChild(panels);
		      // console.log("initMenu top panels:", panels);
		      matchRevealStyle();
		      var overlay = create('div', { class: 'slide-menu-overlay' });
		      top.appendChild(overlay);
		      // console.log("initMenu top overlay:", overlay);
		      overlay.onclick = function () {
			closeMenu(null, true);
		      };

		      var toolbar = create('ol', { class: 'slide-menu-toolbar' });
		      select('.slide-menu').appendChild(toolbar);

		      function addToolbarButton(title, ref, icon, style, fn, active) {
			var attrs = {
			  'data-button': '' + buttons++,
			  class:
			    'toolbar-panel-button' + (active ? ' active-toolbar-button' : '')
			};
			if (ref) {
			  attrs['data-panel'] = ref;
			}
			var button = create('li', attrs);

			if (icon.startsWith('fa-')) {
			  button.appendChild(create('i', { class: style + ' ' + icon }));
			} else {
			  button.innerHTML = icon + '</i>';
			}
			button.appendChild(create('br'), select('i', button));
			button.appendChild(
			  create('span', { class: 'slide-menu-toolbar-label' }, title),
			  select('i', button)
			);
			button.onclick = fn;
			toolbar.appendChild(button);
			// console.log("addToolbarButton button: ", button);
			return button;
		      }

		      // addToolbarButton('Slides', 'Slides', 'fa-images', 'fas', openPanel, true);

		      if (options.custom) {
			options.custom.forEach(function (element, index, array) {
			  addToolbarButton(
			    element.title,
			    'Custom' + index,
			    element.icon,
			    null,
			    openPanel
			  );
			});
		      }

		      if (options.themes) {
			addToolbarButton('Themes', 'Themes', 'fa-adjust', 'fas', openPanel);
		      }
		      if (options.transitions) {
			addToolbarButton(
			  'Transitions',
			  'Transitions',
			  'fa-sticky-note',
			  'fas',
			  openPanel
			);
		      }
		      var button = create('li', {
			id: 'close',
			class: 'toolbar-panel-button'
		      });
		      button.appendChild(create('i', { class: 'fas fa-times' }));
		      button.appendChild(create('br'));
		      button.appendChild(
			create('span', { class: 'slide-menu-toolbar-label' }, 'Close')
		      );
		      button.onclick = function () {
			closeMenu(null, true);
		      };
		      toolbar.appendChild(button);

		      //
		      // Slide links
		      //
		      function generateItem(type, section, i, h, v) {
			var link = '/#/' + h;
			if (typeof v === 'number' && !isNaN(v)) link += '/' + v;

			function text(selector, parent) {
			  if (selector === '') return null;
			  var el = parent ? select(selector, section) : select(selector);
			  if (el) return el.textContent;
			  return null;
			}
			var title =
			  section.getAttribute('data-menu-title') ||
			  text('.menu-title', section) ||
			  text(options.titleSelector, section);

			if (!title && options.useTextContentForMissingTitles) {
			  // attempt to figure out a title based on the text in the slide
			  title = section.textContent.trim();
			  if (title) {
			    title =
			      title
				.split('\n')
				.map(function (t) {
				  return t.trim();
				})
				.join(' ')
				.trim()
				.replace(/^(.{16}[^\s]*).*/, '$1') 
                                // limit to 16 chars plus any consecutive non-whitespace chars (to avoid breaking words)
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#039;') + '...';
			  }
			}

			if (!title) {
			  if (options.hideMissingTitles) return '';
			  type += ' no-title';
			  title = 'Slide ' + (i + 1);
			}

			var item = create('li', {
			  class: type,
			  'data-item': i,
			  'data-slide-h': h,
			  'data-slide-v': v === undefined ? 0 : v
			});

			if (options.markers) {
			  item.appendChild(
			    create('i', { class: 'fas fa-check-circle fa-fw past' })
			  );
			  item.appendChild(
			    create('i', {
			      class: 'fas fa-arrow-alt-circle-right fa-fw active'
			    })
			  );
			  item.appendChild(
			    create('i', { class: 'far fa-circle fa-fw future' })
			  );
			}

			if (options.numbers) {
			  // Number formatting taken from reveal.js
			  var value = [];
			  var format = 'h.v';

			  // Check if a custom number format is available
			  if (typeof options.numbers === 'string') {
			    format = options.numbers;
			  } else if (typeof config.slideNumber === 'string') {
			    // Take user defined number format for slides
			    format = config.slideNumber;
			  }

			  switch (format) {
			    case 'c':
			      value.push(i + 1);
			      break;
			    case 'c/t':
			      value.push(i + 1, '/', deck.getTotalSlides());
			      break;
			    case 'h/v':
			      value.push(h + 1);
			      if (typeof v === 'number' && !isNaN(v)) value.push('/', v + 1);
			      break;
			    default:
			      value.push(h + 1);
			      if (typeof v === 'number' && !isNaN(v)) value.push('.', v + 1);
			  }

			  item.appendChild(
			    create(
			      'span',
			      { class: 'slide-menu-item-number' },
			      value.join('') + '. '
			    )
			  );
			}

			item.appendChild(
			  create('span', { class: 'slide-menu-item-title' }, title)
			);

			return item;
		      }

		      function createSlideMenu() {
			if (
			  !document.querySelector(
			    'section[data-markdown]:not([data-markdown-parsed])'
			  )
			) {
			  var panel = create('div', {
			    'data-panel': 'Slides',
			    class: 'slide-menu-panel active-menu-panel'
			  });
			  panel.appendChild(create('ul', { class: 'slide-menu-items' }));
			  panels.appendChild(panel);
			  var items = select(
			    '.slide-menu-panel[data-panel="Slides"] > .slide-menu-items'
			  );
			  var slideCount = 0;
			  selectAll('.slides > section').forEach(function (section, h) {
			    var subsections = selectAll('section', section);
			    if (subsections.length > 0) {
			      subsections.forEach(function (subsection, v) {
				var type =
				  v === 0 ? 'slide-menu-item' : 'slide-menu-item-vertical';
				var item = generateItem(type, subsection, slideCount, h, v);
				if (item) {
				  // console.log("item: ", item);
				  items.appendChild(item);
				}
				slideCount++;
			      });
			    } else {
			      var item = generateItem(
				'slide-menu-item',
				section,
				slideCount,
				h
			      );
			      if (item) {
				// console.log("item: ", item);
				items.appendChild(item);
			      }
			      slideCount++;
			    }
			  });
			  selectAll('.slide-menu-item, .slide-menu-item-vertical').forEach(
			    function (i) {
			      i.onclick = clicked;
			    }
			  );
			  highlightCurrentSlide();
			} else {
			  // wait for markdown to be loaded and parsed
			  setTimeout(createSlideMenu, 100);
			}
		      }

		      //////////////////////////////////////////////////////////////////////////
		      //  if the slides panel is enabled, uncomment the following two lines
		      // createSlideMenu();
		      deck.addEventListener('slidechanged', highlightCurrentSlide);

		      //
		      // Custom menu panels
		      //
		      if (options.custom) {
			function xhrSuccess() {
			  if (this.status >= 200 && this.status < 300) {
			    this.panel.innerHTML = this.responseText;
			    enableCustomLinks(this.panel);
			  } else {
			    showErrorMsg(this);
			  }
			}
			function xhrError() {
			  showErrorMsg(this);
			}
			function loadCustomPanelContent(panel, sURL) {
			  var oReq = new XMLHttpRequest();
			  oReq.panel = panel;
			  oReq.arguments = Array.prototype.slice.call(arguments, 2);
			  oReq.onload = xhrSuccess;
			  oReq.onerror = xhrError;
			  oReq.open('get', sURL, true);
			  oReq.send(null);
			}
			function enableCustomLinks(panel) {
			  selectAll('ul.slide-menu-items li.slide-menu-item', panel).forEach(
			    function (item, i) {
			      item.setAttribute('data-item', i + 1);
			      item.onclick = clicked;
			      item.addEventListener('mouseenter', handleMouseHighlight);

			      item.classList.remove('past');
			      item.classList.remove('active');
			      item.classList.remove('future');
			
			      /*
			      // console.log("enableCustomLinks() item: ", item);	
			      // console.log("current slide Indices: ", deck.getIndices(slide=currentSlide));

			      if (h < state.indexh || (h === state.indexh && v < state.indexv)) {
				 item.classList.add('past');
			      } else if (h === state.indexh && v === state.indexv) {
				item.classList.add('active');
			      } else {
				 item.classList.add('future');
			      }
			      */
			    }
			  );

			}

			function showErrorMsg(response) {
			  var msg =
			    '<p>ERROR: The attempt to fetch ' +
			    response.responseURL +
			    ' failed with HTTP status ' +
			    response.status +
			    ' (' +
			    response.statusText +
			    ').</p>' +
			    '<p>Remember that you need to serve the presentation HTML from a HTTP server.</p>';
			  response.panel.innerHTML = msg;
			}

			options.custom.forEach(function (element, index, array) {
			  var panel = create('div', {
			    'data-panel': 'Custom' + index,
			    class: 'slide-menu-panel slide-menu-custom-panel'
			  });
			  if (element.content) {
			    panel.innerHTML = element.content;
			    enableCustomLinks(panel);
			  } else if (element.src) {
			    // loadCustomPanelContent(panel, element.src);
			    panel.innerHTML = that.links_html;
			    enableCustomLinks(panel);
			  }
			  panels.appendChild(panel);
			});

			//////////////////////////////////////////////////////////////////////////
			//  if the slides panel is enabled, comment the following three lines
			let click_custom_event = new Event('click');
			select('li[data-panel="Custom0"]').dispatchEvent(click_custom_event);
			closeMenu();

		      } // end of if (options.custom) 

		      //
		      // Themes
		      //
		      if (options.themes) {
			var panel = create('div', {
			  class: 'slide-menu-panel',
			  'data-panel': 'Themes'
			});
			panels.appendChild(panel);
			var menu = create('ul', { class: 'slide-menu-items' });
			panel.appendChild(menu);
			options.themes.forEach(function (t, i) {
			  var attrs = {
			    class: 'slide-menu-item',
			    'data-item': '' + (i + 1)
			  };
			  if (t.theme) {
			    attrs['data-theme'] = t.theme;
			  }
			  if (t.highlightTheme) {
			    attrs['data-highlight-theme'] = t.highlightTheme;
			  }
			  var item = create('li', attrs, t.name);
			  menu.appendChild(item);
			  // console.log("menu theme list item: ", item);
			  item.onclick = clicked;
			});
		      }

		      //
		      // Transitions
		      //
		      if (options.transitions) {
			var panel = create('div', {
			  class: 'slide-menu-panel',
			  'data-panel': 'Transitions'
			});
			panels.appendChild(panel);
			var menu = create('ul', { class: 'slide-menu-items' });
			panel.appendChild(menu);
			options.transitions.forEach(function (name, i) {
			  var item = create(
			    'li',
			    {
			      class: 'slide-menu-item',
			      'data-transition': name.toLowerCase(),
			      'data-item': '' + (i + 1)
			    },
			    name
			  );
			  menu.appendChild(item);
			  item.onclick = clicked;
			});
		      }

		      //
		      // Open menu options
		      //
		      if (options.openButton) {
			// add menu button
			var div = create('div', { class: 'slide-menu-button' });
			var link = create('a', { href: '#' });
			link.appendChild(create('i', { class: 'fas fa-bars' }));
			div.appendChild(link);
			select('.reveal').appendChild(div);
			// div.onclick = openMenu;
			div.onclick = toggleMenu;
		      }

		      if (options.openSlideNumber) {
			var slideNumber = select('div.slide-number');
			if (slideNumber != null) {
			   slideNumber.onclick = openMenu;
			}
		      }

		      //
		      // Handle mouse overs
		      //
		      selectAll('.slide-menu-panel .slide-menu-items li').forEach(function (
			item
		      ) {
			item.addEventListener('mouseenter', handleMouseHighlight);
		      });

		      function handleMouseHighlight(event) {
			if (mouseSelectionEnabled) {
			  selectAll('.active-menu-panel .slide-menu-items li.selected').forEach(
			    function (i) {
			      i.classList.remove('selected');
			    }
			  );
			  event.currentTarget.classList.add('selected');
			}
		      }
		    }

		    if (options.keyboard) {
		      //XXX add keyboard option for custom key codes, etc.

		      document.addEventListener('keydown', onDocumentKeyDown, false);

		      // handle key presses within speaker notes
		      window.addEventListener('message', function (event) {
			var data;
			try {
			  data = JSON.parse(event.data);
			} catch (e) {}
			if (data && data.method === 'triggerKey') {
			  onDocumentKeyDown({
			    keyCode: data.args[0],
			    stopImmediatePropagation: function () {}
			  });
			}
		      });

		      /*  
		      // Prevent reveal from processing keyboard events when the menu is open
		      if (
			config.keyboardCondition &&
			typeof config.keyboardCondition === 'function'
		      ) {
			// combine user defined keyboard condition with the menu's own condition
			var userCondition = config.keyboardCondition;
			config.keyboardCondition = function (event) {
			  return userCondition(event) && (!isOpen() || event.keyCode == 77);
			};
		      } else {
			config.keyboardCondition = function (event) {
			  return !isOpen() || event.keyCode == 77;
			};
		      }
		       */

		      deck.addKeyBinding(
			{ keyCode: 77, key: 'M', description: 'Toggle menu' },
			toggleMenu
		      );
		    }

		    if (options.openOnInit) {
		      openMenu();
		    }

		    initialised = true;
		}

		function loadPlugin() {
		    // does not support IE8 or below
		    var supported = !ieVersion || ieVersion >= 9;

		    // do not load the menu in the upcoming slide panel in the speaker notes
		    if (
		      deck.isSpeakerNotes() &&
		      window.location.search.endsWith('controls=false')
		    ) {
		      supported = false;
		    }

		    if (supported) {
		      if (!options.delayInit) initMenu();
		      dispatchEvent('menu-ready');
		    }
		}

		config = deck.getConfig();
		initOptions(config);
		loadPlugin();

		window.RevealMenu = window.RevealMenu || {
		// return {
		    id: 'menu',

		    /*	
		    init: reveal => {
		      deck = reveal;
		      config = deck.getConfig();
		      initOptions(config);
		      loadResource(options.path + 'menu.css', 'stylesheet', function () {
			if (options.loadIcons === undefined || options.loadIcons) {
			  loadResource(
			    options.path + 'font-awesome/css/all.css',
			    'stylesheet',
			    loadPlugin
			  );
			} else {
			  loadPlugin();
			}
		      });
		    },
		     */

		    toggle: toggleMenu,
		    openMenu: openMenu,
		    closeMenu: closeMenu,
		    openPanel: openPanel,
		    isOpen: isOpen,
		    initialiseMenu: initMenu,
		    isMenuInitialised: function () {
		      return initialised;
		    }
		};

		return this;
	},

       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

       /*********************************************************
	*                                                       *
	* Javascript for the Title-Footer plugin for Reveal.js  *
	*                                                       *
	* Author: Igor Leturia                                  *
	*                                                       *
	* License: GPL v3                                       *
	* http://www.gnu.org/copyleft/gpl.html        		*
	*                                                       *
	********************************************************/

       initTitleFooter: function(title, background)
       {
               let that = this;

	       function getElementsByTagNames(list, obj)
	       {
		 if (!obj)
		 {
		    var obj=document;
		 };
		 var tagNames=list.split(',');
		 var resultArray=new Array();
		 for (var i=0;i<tagNames.length;i++)
		 { 
			var tags=obj.getElementsByTagName(tagNames[i]);
			for (var j=0;j<tags.length;j++)
			{
				resultArray.push(tags[j]);
			};
		 };
		 var testNode=resultArray[0];
		 if (!testNode)
		 {
			return [];
		 };
		 if (testNode.sourceIndex)
		 {
			resultArray.sort(
				function (a,b)
				{
					return a.sourceIndex-b.sourceIndex;
				}
			);
		 }
		 else if (testNode.compareDocumentPosition)
		 {
			resultArray.sort(
				function (a,b)
				{
					return 3-(a.compareDocumentPosition(b)&6);
				}
			);
		 };
		 return resultArray;
	      }

	// Link to the Title-Footer CSS
        /*        
	var link=document.createElement("link");
	link.href="plugin/title-footer/title-footer.css";
	link.type="text/css";
	link.rel="stylesheet";
	document.getElementsByTagName("head")[0].appendChild(link);
         */

	// Initialize properties according to parameters

	this.background=background || 'rgba(0,0,0,0.1)';
	var title=title || '';
	if (title!='')
	{
		// this.title=title;
	}
	else
	{
		var first_section=document.getElementsByTagName('section')[0];
		if (first_section.getElementsByTagName('section').length>0)
		{
			first_section=first_section.getElementsByTagName('section')[0];
		};
		var title_elements = getElementsByTagNames('h1,h2,h3',first_section);
		if (title_elements.length>0)
		{
			// this.title=title_elements[0].textContent;
			for (var title_elements_index=1;title_elements_index<title_elements.length;title_elements_index++)
			{
				// this.title=this.title+' - '+title_elements[title_elements_index].textContent;
			};
		};
	};

	var div_class_reveal=document.querySelectorAll('.reveal')[0];

        /*	
	// Create the Title-Footer footer
	var title_footer=document.createElement('footer');
	title_footer.setAttribute('id','title-footer');
	title_footer.setAttribute('style','background:'+this.background);
	var title_footer_p=document.createElement('p');
	title_footer.appendChild(title_footer_p);
	var a_element=document.createElement('a');
	a_element.setAttribute('href','#/0');
	a_element.appendChild(document.createTextNode(this.title));
	title_footer_p.appendChild(a_element);
	div_class_reveal.appendChild(title_footer);
         */

        // Create the title header
	var title_header=document.createElement('header');
	title_header.setAttribute('id','title-header');
	title_header.setAttribute('style','background:'+this.background);

        /*
	var title_header_p=document.createElement('p');
	title_header.appendChild(title_header_p);

	var a_element_header=document.createElement('a');
	a_element_header.setAttribute('href','#/0');
	a_element_header.appendChild(document.createTextNode(this.title));
	title_header_p.appendChild(a_element_header);
         */

	var title_header_date = document.createElement('div');
	title_header_date.setAttribute('class','date-header');
	var a_element_date = document.createElement('a');
	a_element_date.setAttribute('href','#');
	a_element_date.appendChild(document.createTextNode(new Date().toISOString().split('T')[0]));
	title_header_date.appendChild(a_element_date);
	// title_header_date.appendChild(document.createTextNode('2023.6.23'));
	// title_header_date.appendChild(document.createTextNode(new Date().toISOString().split('T')[0]));
	title_header.appendChild(title_header_date);

	var title_header_ins = document.createElement('div');
	title_header_ins.setAttribute('class','institute-header');
	var a_element_ins = document.createElement('a');
	a_element_ins.setAttribute('href','#');
	a_element_ins.appendChild(document.createTextNode('SCSE, 武汉大学'));
	title_header_ins.appendChild(a_element_ins);
	title_header.appendChild(title_header_ins);

	var title_header_topic = document.createElement('div');
	title_header_topic.setAttribute('class','topic-header');
	var a_element_topic = document.createElement('a');
	a_element_topic.setAttribute('href','#');
	a_element_topic.appendChild(document.createTextNode('数据库系统'));
	title_header_topic.appendChild(a_element_topic);
	title_header.appendChild(title_header_topic);
	
	div_class_reveal.appendChild(title_header);
        // console.log("title_header: ", title_header);

        var title_header_div_logo = document.createElement('div');
	title_header_div_logo.setAttribute('class', "logo-div");
	// title_header.appendChild(title_header_div_logo);
	var a_element_logo = document.createElement('a');
	a_element_logo.setAttribute('href','https://www.whu.edu.cn');
	a_element_logo.setAttribute('target','_blank');
        var img_element_header = document.createElement('img');
	img_element_header.setAttribute('src', that.whu_logo);
	a_element_logo.appendChild(img_element_header);
        title_header_div_logo.appendChild(a_element_logo);

	div_class_reveal.appendChild(title_header_div_logo);
        // console.log("title_header_div_logo: ", title_header_div_logo);
       },

       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	initScreenfull() {
		'use strict';

		var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
		var isCommonjs = typeof module !== 'undefined' && module.exports;

		var fn = (function () {
			var val;

			var fnMap = [
				[
					'requestFullscreen',
					'exitFullscreen',
					'fullscreenElement',
					'fullscreenEnabled',
					'fullscreenchange',
					'fullscreenerror'
				],
				// New WebKit
				[
					'webkitRequestFullscreen',
					'webkitExitFullscreen',
					'webkitFullscreenElement',
					'webkitFullscreenEnabled',
					'webkitfullscreenchange',
					'webkitfullscreenerror'

				],
				// Old WebKit
				[
					'webkitRequestFullScreen',
					'webkitCancelFullScreen',
					'webkitCurrentFullScreenElement',
					'webkitCancelFullScreen',
					'webkitfullscreenchange',
					'webkitfullscreenerror'

				],
				[
					'mozRequestFullScreen',
					'mozCancelFullScreen',
					'mozFullScreenElement',
					'mozFullScreenEnabled',
					'mozfullscreenchange',
					'mozfullscreenerror'
				],
				[
					'msRequestFullscreen',
					'msExitFullscreen',
					'msFullscreenElement',
					'msFullscreenEnabled',
					'MSFullscreenChange',
					'MSFullscreenError'
				]
			];

			var i = 0;
			var l = fnMap.length;
			var ret = {};

			for (; i < l; i++) {
				val = fnMap[i];
				if (val && val[1] in document) {
					for (i = 0; i < val.length; i++) {
						ret[fnMap[0][i]] = val[i];
					}
					return ret;
				}
			}

			return false;
		})();

		var eventNameMap = {
			change: fn.fullscreenchange,
			error: fn.fullscreenerror
		};

		var screenfull = {
			request: function (element, options) {
				return new Promise(function (resolve, reject) {
					var onFullScreenEntered = function () {
						this.off('change', onFullScreenEntered);
						resolve();
					}.bind(this);

					this.on('change', onFullScreenEntered);

					element = element || document.documentElement;

					var returnPromise = element[fn.requestFullscreen](options);

					if (returnPromise instanceof Promise) {
						returnPromise.then(onFullScreenEntered).catch(reject);
					}
				}.bind(this));
			},
			exit: function () {
				return new Promise(function (resolve, reject) {
					if (!this.isFullscreen) {
						resolve();
						return;
					}

					var onFullScreenExit = function () {
						this.off('change', onFullScreenExit);
						resolve();
					}.bind(this);

					this.on('change', onFullScreenExit);

					var returnPromise = document[fn.exitFullscreen]();

					if (returnPromise instanceof Promise) {
						returnPromise.then(onFullScreenExit).catch(reject);
					}
				}.bind(this));
			},
			toggle: function (element, options) {
				return this.isFullscreen ? this.exit() : this.request(element, options);
			},
			onchange: function (callback) {
				this.on('change', callback);
			},
			onerror: function (callback) {
				this.on('error', callback);
			},
			on: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.addEventListener(eventName, callback, false);
				}
			},
			off: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.removeEventListener(eventName, callback, false);
				}
			},
			raw: fn
		};

		if (!fn) {
			if (isCommonjs) {
				module.exports = {isEnabled: false};
			} else {
				window.screenfull = {isEnabled: false};
			}

			return;
		}

		Object.defineProperties(screenfull, {
			isFullscreen: {
				get: function () {
					return Boolean(document[fn.fullscreenElement]);
				}
			},
			element: {
				enumerable: true,
				get: function () {
					return document[fn.fullscreenElement];
				}
			},
			isEnabled: {
				enumerable: true,
				get: function () {
					// Coerce to boolean in case of old WebKit
					return Boolean(document[fn.fullscreenEnabled]);
				}
			}
		});

		if (isCommonjs) {
			module.exports = screenfull;
		} else {
			window.screenfull = screenfull;
		}
	},

       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

       /*
	* Reveal.js toolbar plugin
	* MIT licensed
	* (c) Greg Denehy 2017
	*/

       initRevealToolbar: function(deck) {
	    let that = this;

	    var ieVersion = (function() {
	      var browser = /(msie) ([\w.]+)/.exec(
		window.navigator.userAgent.toLowerCase()
	      );
	      if (browser && browser[1] === 'msie') {
		return parseFloat(browser[2]);
	      }
	      return null;
	    })();

	    // var config = Reveal.getConfig();
	    config = {
	       postMessageEvents: false,
	    }
	    // var options = config.toolbar || {};
	    var options = 
	       {
			// Specifies where the toolbar will be shown: 'top' or 'bottom'
			position: 'bottom',

			// Add button to toggle fullscreen mode for the presentation
			fullscreen: true,

			// Add button to toggle the overview mode on and off
			overview: true,

			// Add button to pause (hide) the presentation display
			pause: true,

			// Add button to show the speaker notes
			notes: true,

			// Add button to show the help overlay
			help: false,

			// If true, the reveal.js-menu will be moved into the toolbar.
			// Set to false to leave the menu on its own.
			captureMenu: true,

			// If true, the playback control will be moved into the toolbar.
			// This is only relevant if the presentation is configured to autoSlide.
			// Set to false to leave the menu on its own.
			capturePlaybackControl: true,

			// font-awesome library the 'loadIcons' option can be set to false
			// and the menu will not attempt to load the font-awesome library.
			loadIcons: true,
		};
	    // console.log("script path: ", scriptPath()); 
	    options.path = options.path || scriptPath() || 'plugin/toolbar/';
	    if (!options.path.endsWith('/')) {
	      options.path += '/';
	    }
	    var loadIcons = options.loadIcons;
	    if (typeof loadIcons === 'undefined') loadIcons = true;

	    // Cached references to DOM elements
	    var dom = {};

	    /*
	    loadResource(
	      options.path + '/toolbar.css',
	      'stylesheet',
	      'toolbar-defaults',
	      function() {
	     */

		/*
		loadResource(
		  options.path + '/lib/screenfull/screenfull.min.js',
		  'script',
		  null,
		  function() {
		    if (loadIcons) {
		      loadResource(
			options.path +
			  '/font-awesome-5.0.2/css/fontawesome-all.min.css',
			'stylesheet',
			'',
			loadPlugin
		      );
		    } else {
		      loadPlugin();
		    }
		  }
		);
		*/

	    /*
	      }
	    );
	     */
	    
            if (
		 deck.isSpeakerNotes() &&
		 window.location.search.includes('controls=false')
            ) {
            } else {
	       loadPlugin();
	    }

	    function loadPlugin() {
	      // does not support IE8 or below
	      var initialise = !ieVersion || ieVersion >= 9;

	      // does not support IE8 or below
	      if (initialise) {
		function option(opt, def) {
		  if (typeof opt === 'undefined') return def;
		  return opt;
		}

		//
		// Set option defaults
		//
		var position = option(options.position, 'bottom'); // 'top' or 'bottom'
		var showFullscreen = option(options.fullscreen, false);
		// console.log("showFullscreen: ",  showFullscreen);
		var showOverview = option(options.overview, false);
		var showPause = option(options.pause, false);
		var showNotes = option(options.notes, false);
		var showHelp = option(options.help, false);
		var captureMenu = option(options.captureMenu, true);
		var capturePlaybackControl = option(
		  options.capturePlaybackControl,
		  true
		);

		// Cache references to key DOM elements
		dom.reveal = document.querySelector('.reveal');
		dom.toolbar = document.querySelector('.reveal-toolbar');

		// console.log("dom.toolbar: ", dom.toolbar);
		if (!dom.toolbar) {
		  // dom.toolbar = createNode(dom.reveal, 'div', 'reveal-toolbar', null);
		  // dom.toolbar = createNodewithId(dom.reveal, 'div', 'reveal-toolbar', null);
		  dom.toolbar = createNodewithId(dom.reveal, 'div', 'customcontrols', null);
		  // console.log("createNode dom.toolbar");
		} else {
		  // move the existing toolbar after the other Reveal components
		  dom.reveal.appendChild(dom.toolbar);
		  // console.log("appendChild dom.toolbar");
		}

		/*
		dom.toolbar.classList.add(
		  position == 'top' ? 'reveal-toolbar-top' : 'reveal-toolbar-bottom'
		);
		 */	

		var collapseIcon = '<i class="fa fa-chevron-down"></i>';
		var expandIcon = '<i class="fa fa-chevron-up"></i>';
		var tooltip = 'Show/hide controls';

		var toggleButton = document.createElement( 'button' );
		toggleButton.title = tooltip;
		toggleButton.innerHTML = '<span id="collapse-customcontrols">' + collapseIcon + '</span>' 
                                         + '<span id="expand-customcontrols">' + expandIcon + '</span>';

		toggleButton.addEventListener('click', function( event ) {
			// var div = document.querySelector("div#reveal-toolbar");
			var div = document.querySelector("div#customcontrols");
			if ( div.classList.contains('collapsed') ) {
				div.classList.remove('collapsed');
			}
			else {
				div.classList.add('collapsed');
			}
			toggleButton.blur(); // unfocus button
		});

		dom.toolbar.appendChild(toggleButton);

		document.addEventListener( 'resize', function( event ) {
			// expand controls to make sure they are visible
			// var div = document.querySelector("div#reveal-toolbar.collapsed");
			var div = document.querySelector("div#customcontrols.collapsed");
			if ( div ) {
				div.classList.remove('collapsed');
			}
		} );

		var controls = document.createElement( 'ul' );
		dom.toolbar.appendChild( controls );

		function createToolbarButton(icon, cb) {
		  var control_li = createNode(
		    controls,
		    'li',
		    null,
		    null
                  );

		  var button = createNode(
		    // dom.toolbar,
		    control_li,
		    'a',
		    'reveal-toolbar-button',
		    null
		  );
		  // console.log("button: ", button);
		  // console.log("cb: ", cb);
		  button.setAttribute('href', '#');
		  button.onclick = function(event) {
		    event.preventDefault();
		    cb(event);
		  };
		  createNode(button, 'i', ['fa', icon]);
		  return button;
		}

		function createToolbarOutButton(icon, cb) {
		  var control_li = createNode(
		    controls,
		    'li',
		    null,
		    null
                  );
		  
		  /*	
		  var tooltiptext = createNode(
		    control_li,
		    'span',
		    'tooltiptext',
		    'Show Slides in Body'
                  );
		   */

		  var button = createNode(
		    control_li,	
		    'a',
		    'reveal-toolbar-button',
		    null
		  );
		  // console.log("button: ", button);
		  // console.log("cb: ", cb);
		  // button.setAttribute('href', '#');

		  // console.log("current url search: ", window.location.search);
		  button.setAttribute('href', '/slides_iframe_db_chap05?frame=false');
		  button.setAttribute('target', '_blank');
		  // button.setAttribute('target', '_self');
                   
                  /*
		  button.onclick = function(event) {
		    event.preventDefault();
		    cb(event);
		  };
                   */
		  createNode(button, 'i', ['fa', icon]);
		  return button;
		}

		function createToolbarPdfButton(icon, cb) {
		  var control_li = createNode(
		    controls,
		    'li',
		    null,
		    null
                  );
		  var button = createNode(
		    // dom.toolbar,
	            control_li, 		 
		    'a',
		    'reveal-toolbar-button',
		    null
		  );
		  // console.log("button: ", button);
		  // console.log("cb: ", cb);
		  // button.setAttribute('href', '#');

		  // console.log("current url search: ", window.location.search.slice(1));
		  button.setAttribute('href', '/slides_iframe_db_chap05?print-pdf');
                  if (window.location.search.slice(1) === 'frame=false') {
		     button.setAttribute('target', '_self');
		  } else {
		     button.setAttribute('target', '_blank');
		  }
                   
                  /*
		  button.onclick = function(event) {
		    event.preventDefault();
		    cb(event);
		  };
                   */
		  createNode(button, 'i', ['fa', icon]);
		  return button;
		}

		function createToolbarPenButton(icon, cb) {
		  var control_li = createNode(
		    controls,
		    'li',
		    null,
		    null
                  );
		  var button = createNode(
		    // dom.toolbar,
                    control_li, 
		    'a',
		    'reveal-toolbar-button',
		    null
		  );
		  // console.log("button: ", button);
		  // console.log("cb: ", cb);
		  button.setAttribute('href', '#');
		  button.onclick = function(event) {
		    event.preventDefault();
		    cb(event);
		  };
		  createNode(button, 'i', ['fa-solid', icon]);
		  return button;
		}

		if (showOverview) {
		  dom.overviewButton = createToolbarButton(
		    // 'fa-th-large',
		    'fa-th',
		    deck.toggleOverview
		  );
		}

		if (showHelp) {
		  dom.helpButton = createToolbarButton(
		    'fa-question',
		    deck.toggleHelp
		  );
		}

                if ( !that.isMobile() ) {
			// if (showNotes && !window.Reveal.isSpeakerNotes()) {
			  createToolbarButton('fa-list-alt', function() {
			    if (!deck.isSpeakerNotes()) {
			       RevealNotes.openSpeakerWindow();
			    }
			  });
			  // createToolbarButton('fa-list-alt', function() { Reveal.triggerKey(83) });
			// }
		}

		// if ( !that.isMobile() ) {	
		if ( !that.isiOs() ) {	
			if (showFullscreen) {
			  dom.fullscreenButton = createToolbarButton('fa-expand', function() {
			    if (screenfull.isEnabled) {
			      screenfull.toggle(document.documentElement);
			      // let viewport = (deck.getRevealElement()).tagName == "BODY" ? document : deck.getRevealElement();
			      // screenfull.toggle(viewport);
			    }
			  });
			}
			// console.log("createToolbarButton fullscreen done");

			// set fullscreen button icon to match fullscreen state
			// if (screenfull.enabled) {
			  screenfull.on('change', function() {
			    var icon = dom.fullscreenButton.querySelector('i');
			    icon.classList.remove(
			      screenfull.isFullscreen ? 'fa-expand' : 'fa-compress'
			    );
			    icon.classList.add(
			      screenfull.isFullscreen ? 'fa-compress' : 'fa-expand'
			    );
			  });
			// }
		}

                dom.searchButton = createToolbarButton('fa-search', function() {
                   // deck.getPlugin('search').open();
                   // deck.getPlugin('search').toggle();
                   RevealSearch.toggle();
		});

                dom.showNotesButton = createToolbarButton('fa-sticky-note', function() {
                   if ( deck.getConfig().showNotes == false ) {
                      // deck.configure({showNotes: true});
                      deck.configure({showNotes: 'separate-page'});
                   } else {
                      deck.configure({showNotes: false});
                   }         
		});
                 
                dom.pdfButton = createToolbarOutButton('fa-arrow-up-right-from-square', function() {
		});

                dom.pdfButton = createToolbarPdfButton('fa-file-pdf', function() {
		});

                dom.msgButton = createToolbarButton('fa-message', function() {
		   RevealQnA.toggleQnA();	
		});

                dom.playButton = createToolbarButton('fa-play', function() {
		   // console.log("reveal config autoSlide:", deck.getConfig().autoSlide);
		   if (deck.getConfig().autoSlide == 0 || deck.getConfig().autoSlide == undefined) {
		      deck.configure({ autoSlide: 5000 });
		      deck.configure({ loop: true });
		      var icon = dom.playButton.querySelector('i');
		      icon.classList.remove('fa-play');
		      icon.classList.add('fa-pause');
                   } else {
		      deck.configure({ autoSlide: 0 });
		      deck.configure({ loop: false });
		      var icon = dom.playButton.querySelector('i');
		      icon.classList.remove('fa-pause');
		      icon.classList.add('fa-play');
 		   }	
		});

		if (showPause) {
		  dom.pauseButton = createToolbarButton(
		    'fa-eye-slash',
		    deck.togglePause
		  );
		  dom.pauseButton.classList.add('reveal-toolbar-pause-button');
		  deck.addEventListener('paused', function() {
		    var icon = dom.pauseButton.querySelector('i');
		    icon.classList.remove('fa-eye-slash');
		    icon.classList.add('fa-eye');
		  });
		  deck.addEventListener('resumed', function() {
		    var icon = dom.pauseButton.querySelector('i');
		    icon.classList.remove('fa-eye');
		    icon.classList.add('fa-eye-slash');
		  });
		}
		 
                dom.penButton = createToolbarPenButton('fa-pen', function() {
                   RevealChalkboard.toggleNotesCanvas();
		});

                dom.boardButton = createToolbarButton('fa-pen-square', function() {
                   RevealChalkboard.toggleChalkboard();
		});

                /*
		if (captureMenu) {
		  // handle async loading of plugins
		  var id_menu = setInterval(function() {
		      // if (RevealMenu && RevealMenu.isMenuInitialised()) {
		      dom.menu = document.querySelector('div.slide-menu-button');
		      if (dom.menu) {
			// console.log('Moving menu button');
			dom.toolbar.insertBefore(dom.menu, dom.toolbar.firstChild);
			dom.menu.classList.add('reveal-toolbar-button');
		      }
		      clearInterval(id_menu);
		    // }
		  }, 50);
		}
		//  console.log("cpatureMenu done");
                 */

		if (capturePlaybackControl) {
		  dom.playback = document.querySelector('canvas.playback');
		  if (dom.playback) {
		    console.log('Moving playback control');
		    dom.toolbar.appendChild(dom.playback);
		  }
		}
		// console.log("capturePlaybackControl done");

		// place default footer stylesheet before first footer stylesheet to ensure footer styles override defaults
		var defaultStylesheet = document.querySelector('#toolbar-defaults');
		var themeStylesheet = document.querySelector('.toolbar-theme');
		if (themeStylesheet) {
		  themeStylesheet.parentElement.insertBefore(
		    defaultStylesheet,
		    themeStylesheet
		  );
		}

		/**
		 * Extend object a with the properties of object b.
		 * If there's a conflict, object b takes precedence.
		 */
		function extend(a, b) {
		  for (var i in b) {
		    a[i] = b[i];
		  }
		}

		/**
		 * Dispatches an event of the specified type from the
		 * reveal DOM element.
		 */
		function dispatchEvent(type, args) {
		  var event = document.createEvent('HTMLEvents', 1, 2);
		  event.initEvent(type, true, true);
		  extend(event, args);
		  document.querySelector('.reveal').dispatchEvent(event);

		  // If we're in an iframe, post each reveal.js event to the
		  // parent window. Used by the notes plugin
		  if (config.postMessageEvents && window.parent !== window.self) {
		    window.parent.postMessage(
		      JSON.stringify({
			namespace: 'reveal',
			eventName: type,
			state: getState()
		      }),
		      '*'
		    );
		  }
		}

		dispatchEvent('toolbar-ready');
	      }
	    }

	    // modified from math plugin
	    function loadResource(url, type, id, callback) {
	      var head = document.querySelector('head');
	      var resource;

	      if (type === 'script') {
		resource = document.createElement('script');
		resource.type = 'text/javascript';
		resource.src = url;
		if (id) resource.id = id;
	      } else if (type === 'stylesheet') {
		resource = document.createElement('link');
		resource.rel = 'stylesheet';
		resource.href = url;
		if (id) resource.id = id;
	      }

	      // Wrapper for callback to make sure it only fires once
	      var finish = function() {
		if (typeof callback === 'function') {
		  callback.call();
		  callback = null;
		}
	      };

	      resource.onload = finish;

	      // IE
	      resource.onreadystatechange = function() {
		if (this.readyState === 'loaded') {
		  finish();
		}
	      };

	      // Normal browsers
	      head.appendChild(resource);
	    }

	    function scriptPath() {
	      // obtain plugin path from the script element
	      var path;
	      if (document.currentScript) {
		path = document.currentScript.src.slice(0, -10);
	      } else {
		var sel = document.querySelector('script[src$="toolbar.js"]');
		if (sel) {
		  path = sel.src.slice(0, -10);
		}
	      }
	      return path;
	    }

	    // polyfill
	    if (!String.prototype.startsWith) {
	      String.prototype.startsWith = function(searchString, position) {
		return this.substr(position || 0, searchString.length) === searchString;
	      };
	    }
	    if (!String.prototype.endsWith) {
	      String.prototype.endsWith = function(search, this_len) {
		if (this_len === undefined || this_len > this.length) {
		  this_len = this.length;
		}
		return this.substring(this_len - search.length, this_len) === search;
	      };
	    }

	    /**
	     * Creates an HTML element and returns a reference to it.
	     *
	     * @param {HTMLElement} container
	     * @param {string} tagname
	     * @param {string} classname
	     * @param {string} innerHTML
	     *
	     * @return {HTMLElement}
	     */
	    function createNode(container, tagname, classname, innerHTML) {
	      var node = document.createElement(tagname);
	      if (classname) {
		if (Array.isArray(classname)) {
		  classname.forEach(function(c) {
		    node.classList.add(c);
		  });
		} else {
		  node.classList.add(classname);
		}
	      }
	      if (typeof innerHTML === 'string') {
		node.innerHTML = innerHTML;
	      }
	      container.appendChild(node);
	      // console.log("createNode container: ", container);
	      // console.log("createNode node: ", node);

	      return node;
	    }

	    function createNodewithId(container, tagname, id, innerHTML) {
	      var node = document.createElement(tagname);
	      if (id) {
		node.setAttribute('id', id);
	      }
	      if (typeof innerHTML === 'string') {
		node.innerHTML = innerHTML;
	      }
	      container.appendChild(node);
	      // console.log("createNode container: ", container);
	      // console.log("createNode node: ", node);

	      return node;
	    }

            // console.log("dom.toolbar: ", dom.toolbar);

	    return {}; 
        },

       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
       /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*
	 * Handles opening of and synchronization with the reveal.js
	 * notes window.
	 *
	 * Handshake process:
	 * 1. This window posts 'connect' to notes window
	 *    - Includes URL of presentation to show
	 * 2. Notes window responds with 'connected' when it is available
	 * 3. This window proceeds to send the current presentation state
	 *    to the notes window
	 */

	initSpeakerView: function( deck ) {
   		let that = this;

        	let connectInterval;
        	let speakerWindow = null;

		function openSpeakerWindow () {
			// If a window is already open, focus it
			if( speakerWindow && !speakerWindow.closed ) {
				speakerWindow.focus();
			}
			else {
				speakerWindow = window.open( 'about:blank', 'reveal.js - Notes', 'width=1100, height=700' );
				speakerWindow.marked = marked;
				speakerWindow.document.write( speakerViewHTML );

				if( !speakerWindow ) {
					alert( 'Speaker view popup failed to open. Please make sure popups are allowed and reopen the speaker view.' );
					return;
				}

				connect();
			}

		}

		/*
		 * Reconnect with an existing speaker view window.
		 */
		function reconnectSpeakerWindow( reconnectWindow ) {

			if( speakerWindow && !speakerWindow.closed ) {
				speakerWindow.focus();
			}
			else {
				speakerWindow = reconnectWindow;
				window.addEventListener( 'message', onPostMessage );
				onConnected();
			}

		}

		/*
		 * Connect to the notes window through a postmessage handshake.
		 * Using postmessage enables us to work in situations where the
		 * origins differ, such as a presentation being opened from the
		 * file system.
		 */
		function connect() {
			const presentationURL = deck.getConfig().url;

			const url = typeof presentationURL === 'string' ? presentationURL :
				window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search;

			// Keep trying to connect until we get a 'connected' message back
			connectInterval = setInterval( function() {
				speakerWindow.postMessage( JSON.stringify( {
					namespace: 'reveal-notes',
					type: 'connect',
					state: deck.getState(),
					url
				} ), '*' );
			}, 500 );

			window.addEventListener( 'message', onPostMessage );

		}

		/**
		 * Calls the specified Reveal.js method with the provided argument
		 * and then pushes the result to the notes frame.
		 */
		function callRevealApi ( methodName, methodArguments, callId ) {
			let result = deck[methodName].apply( deck, methodArguments );
			speakerWindow.postMessage( JSON.stringify( {
				namespace: 'reveal-notes',
				type: 'return',
				result,
				callId
			} ), '*' );

		}

		/**
		 * Posts the current slide data to the notes window.
		 */
		function post ( event ) {
			let slideElement = deck.getCurrentSlide(),
				notesElements = slideElement.querySelectorAll( 'aside.notes' ),
				fragmentElement = slideElement.querySelector( '.current-fragment' );

			let messageData = {
				namespace: 'reveal-notes',
				type: 'state',
				notes: '',
				markdown: false,
				whitespace: 'normal',
				state: deck.getState()
			};

			// Look for notes defined in a slide attribute
			if( slideElement.hasAttribute( 'data-notes' ) ) {
				messageData.notes = slideElement.getAttribute( 'data-notes' );
				messageData.whitespace = 'pre-wrap';
			}

			// Look for notes defined in a fragment
			if( fragmentElement ) {
				let fragmentNotes = fragmentElement.querySelector( 'aside.notes' );
				if( fragmentNotes ) {
					messageData.notes = fragmentNotes.innerHTML;
					messageData.markdown = typeof fragmentNotes.getAttribute( 'data-markdown' ) === 'string';

					// Ignore other slide notes
					notesElements = null;
				}
				else if( fragmentElement.hasAttribute( 'data-notes' ) ) {
					messageData.notes = fragmentElement.getAttribute( 'data-notes' );
					messageData.whitespace = 'pre-wrap';

					// In case there are slide notes
					notesElements = null;
				}
			}

			// Look for notes defined in an aside element
			if( notesElements ) {
				messageData.notes = Array.from(notesElements).map( notesElement => notesElement.innerHTML ).join( '\n' );
				messageData.markdown = notesElements[0] && typeof notesElements[0].getAttribute( 'data-markdown' ) === 'string';
			}

			speakerWindow.postMessage( JSON.stringify( messageData ), '*' );

		}

		/**
		 * Check if the given event is from the same origin as the
		 * current window.
		 */
		function isSameOriginEvent ( event ) {

			try {
				return window.location.origin === event.source.location.origin;
			}
			catch ( error ) {
				return false;
			}

		}

		function onPostMessage ( event ) {
			// Only allow same-origin messages
			// (added 12/5/22 as a XSS safeguard)
			if( isSameOriginEvent( event ) ) {
				// console.log("event.data: ", event.data);
				let data = JSON.parse( event.data );
				// console.log("data: ", data);
				if( data && data.namespace === 'reveal-notes' && data.type === 'connected' ) {
					clearInterval( connectInterval );
					onConnected();
				}
				else if( data && data.namespace === 'reveal-notes' && data.type === 'call' ) {
					callRevealApi( data.methodName, data.arguments, data.callId );
				}

			}

		}

		/**
		 * Called once we have established a connection to the notes
		 * window.
		 */
		function onConnected () {
			// Monitor events that trigger a change in state
			deck.on( 'slidechanged', post );
			deck.on( 'fragmentshown', post );
			deck.on( 'fragmenthidden', post );
			deck.on( 'overviewhidden', post );
			deck.on( 'overviewshown', post );
			deck.on( 'paused', post );
			deck.on( 'resumed', post );

			// Post the initial state
			post();
		}

		if( !/receiver/i.test( window.location.search ) ) {

			// If the there's a 'notes' query set, open directly
			if( window.location.search.match( /(\?|\&)notes/gi ) !== null ) {
				openSpeakerWindow();
			}
			else {
				// Keep listening for speaker view hearbeats. If we receive a
				// heartbeat from an orphaned window, reconnect it. This ensures
				// that we remain connected to the notes even if the presentation
				// is reloaded.
				window.addEventListener( 'message', event => {

					if( !speakerWindow && typeof event.data === 'string' ) {
						let data;

						try {
							data = JSON.parse( event.data );
						}
						catch( error ) {}

						if( data && data.namespace === 'reveal-notes' && data.type === 'heartbeat' ) {
							reconnectSpeakerWindow( event.source );
						}
					}
				});
			}

			// Open the notes when the 's' key is hit
			deck.addKeyBinding({keyCode: 83, key: 'S', description: 'Speaker notes view'}, function() {
				openSpeakerWindow();
			} );

		}

		window.RevealNotes = window.RevealNotes || {
		    id: 'notes',
		    init: function(deck) {
			initSpeakerView(deck);
		    },
		    openSpeakerWindow: function() { return openSpeakerWindow(); },
		};

		this.openSpeakerWindow = openSpeakerWindow;

		return this;
	},

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*!
	 * reveal.js Zoom plugin
	 */

	/*!
	 * zoom.js 0.3 (modified for use with reveal.js)
	 * http://lab.hakim.se/zoom-js
	 * MIT licensed
	 *
	 * Copyright (C) 2011-2014 Hakim El Hattab, http://hakim.se
	 */
        initRevealZoom: function(deck) {
		let that = this;

		// The current zoom level (scale)
		var level = 1;

		// The current mouse position, used for panning
		var mouseX = 0,
			mouseY = 0;

		// Timeout before pan is activated
		var panEngageTimeout = -1,
			panUpdateInterval = -1;

		// Check for transform support so that we can fallback otherwise
		var supportsTransforms = 'transform' in document.body.style;

		if( supportsTransforms ) {
			// The easing that will be applied when we zoom in/out
			document.body.style.transition = 'transform 0.8s ease';
		}

		// Zoom out if the user hits escape
		document.addEventListener( 'keyup', function( event ) {
			if( level !== 1 && event.keyCode === 27 ) {
				out();
			}
		} );

		// Monitor mouse movement for panning
		document.addEventListener( 'mousemove', function( event ) {
			if( level !== 1 ) {
				mouseX = event.clientX;
				mouseY = event.clientY;
			}
		} );

		/**
		 * Applies the CSS required to zoom in, prefers the use of CSS3
		 * transforms but falls back on zoom for IE.
		 *
		 * @param {Object} rect
		 * @param {Number} scale
		 */
		function magnify ( rect, scale ) {
			var scrollOffset = getScrollOffset();

			// Ensure a width/height is set
			rect.width = rect.width || 1;
			rect.height = rect.height || 1;

			// Center the rect within the zoomed viewport
			rect.x -= ( window.innerWidth - ( rect.width * scale ) ) / 2;
			rect.y -= ( window.innerHeight - ( rect.height * scale ) ) / 2;

			if( supportsTransforms ) {
				// Reset
				if( scale === 1 ) {
					document.body.style.transform = '';
				}
				// Scale
				else {
					var origin = scrollOffset.x +'px '+ scrollOffset.y +'px',
						transform = 'translate('+ -rect.x +'px,'+ -rect.y +'px) scale('+ scale +')';

					document.body.style.transformOrigin = origin;
					document.body.style.transform = transform;
				}
			}
			else {
				// Reset
				if( scale === 1 ) {
					document.body.style.position = '';
					document.body.style.left = '';
					document.body.style.top = '';
					document.body.style.width = '';
					document.body.style.height = '';
					document.body.style.zoom = '';
				}
				// Scale
				else {
					document.body.style.position = 'relative';
					document.body.style.left = ( - ( scrollOffset.x + rect.x ) / scale ) + 'px';
					document.body.style.top = ( - ( scrollOffset.y + rect.y ) / scale ) + 'px';
					document.body.style.width = ( scale * 100 ) + '%';
					document.body.style.height = ( scale * 100 ) + '%';
					document.body.style.zoom = scale;
				}
			}

			level = scale;

			if( document.documentElement.classList ) {
				if( level !== 1 ) {
					document.documentElement.classList.add( 'zoomed' );
				}
				else {
					document.documentElement.classList.remove( 'zoomed' );
				}
			}
		}

		function zoom_in () {
			deck.getRevealElement().addEventListener( 'mousedown', function( event ) {
				// var defaultModifier = /Linux/.test( window.navigator.platform ) ? 'ctrl' : 'alt';
				var defaultModifier = 'alt';
				var outModifier = 'shiftKey';

				var modifier = ( deck.getConfig().zoomKey ? deck.getConfig().zoomKey : defaultModifier ) + 'Key';
				// var zoomLevel = ( deck.getConfig().zoomLevel ? deck.getConfig().zoomLevel : 2 );
				var zoomLevel = level + 1;

				if( event[ outModifier ] && !deck.isOverview() ) {
					event.preventDefault();
					out();
				} 
				else if( event[ modifier ] && !deck.isOverview() ) {
					event.preventDefault();

					to({
						x: event.clientX,
						y: event.clientY,
						scale: zoomLevel,
						pan: false
					});
				}
			} );
		}

		/**
		 * Pan the document when the mosue cursor approaches the edges
		 * of the window.
		 */
		function pan () {
			var range = 0.12,
				rangeX = window.innerWidth * range,
				rangeY = window.innerHeight * range,
				scrollOffset = getScrollOffset();

			// Up
			if( mouseY < rangeY ) {
				window.scroll( scrollOffset.x, scrollOffset.y - ( 1 - ( mouseY / rangeY ) ) * ( 14 / level ) );
			}
			// Down
			else if( mouseY > window.innerHeight - rangeY ) {
				window.scroll( scrollOffset.x, scrollOffset.y + ( 1 - ( window.innerHeight - mouseY ) / rangeY ) * ( 14 / level ) );
			}

			// Left
			if( mouseX < rangeX ) {
				window.scroll( scrollOffset.x - ( 1 - ( mouseX / rangeX ) ) * ( 14 / level ), scrollOffset.y );
			}
			// Right
			else if( mouseX > window.innerWidth - rangeX ) {
				window.scroll( scrollOffset.x + ( 1 - ( window.innerWidth - mouseX ) / rangeX ) * ( 14 / level ), scrollOffset.y );
			}
		}

		function getScrollOffset () {
			return {
				x: window.scrollX !== undefined ? window.scrollX : window.pageXOffset,
				y: window.scrollY !== undefined ? window.scrollY : window.pageYOffset
			}
		}

		/**
		 * Zooms in on either a rectangle or HTML element.
		 *
		 * @param {Object} options
		 *   - element: HTML element to zoom in on
		 *   OR
		 *   - x/y: coordinates in non-transformed space to zoom in on
		 *   - width/height: the portion of the screen to zoom in on
		 *   - scale: can be used instead of width/height to explicitly set scale
		 */
		function to ( options ) {
			// Due to an implementation limitation we can't zoom in
			// to another element without zooming out first
			/*
			if( level !== 1 ) {
				out();
			}
			else 
			 */
			{
				options.x = options.x || 0;
				options.y = options.y || 0;

				// If an element is set, that takes precedence
				if( !!options.element ) {
					// Space around the zoomed in element to leave on screen
					var padding = 20;
					var bounds = options.element.getBoundingClientRect();

					options.x = bounds.left - padding;
					options.y = bounds.top - padding;
					options.width = bounds.width + ( padding * 2 );
					options.height = bounds.height + ( padding * 2 );
				}

				// If width/height values are set, calculate scale from those values
				if( options.width !== undefined && options.height !== undefined ) {
					options.scale = Math.max( Math.min( window.innerWidth / options.width, window.innerHeight / options.height ), 1 );
				}

				if( options.scale > 1 ) {
					options.x *= options.scale;
					options.y *= options.scale;

					magnify( options, options.scale );

					if( options.pan !== false ) {

						// Wait with engaging panning as it may conflict with the
						// zoom transition
						panEngageTimeout = setTimeout( function() {
							panUpdateInterval = setInterval( pan, 1000 / 60 );
						}, 800 );

					}
				}
			}
		}

		/**
		 * Resets the document zoom state to its default.
		 */
		function out () {
			clearTimeout( panEngageTimeout );
			clearInterval( panUpdateInterval );

			magnify( { x: 0, y: 0 }, 1 );

			level = 1;
		}

		window.RevealZoom = window.RevealZoom || {
			id: 'zoom',
			init: function( deck ) {
			   return initRevealZoom(deck);
			},

			to: function( options ) {
			   return to (options);	
			},

			zoom_in: function() {
			   return zoom_in ();
 			}, 

			out: function() {
			   return out ();
 			}, 

			magnify: function( options ) { to( options ) },

			reset: function() { out() },

			zoomLevel: function() {
			   return level;
			},

			destroy: () => {
			   out();
			},
		};

		return this;
        }, 


        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*****************************************************************
	 ** Author: Asvin Goel, goel@telematique.eu
	 **
	 ** A plugin for reveal.js adding a chalkboard.
	 **
	 ** Version: 2.1.0
	 **
	 ** License: MIT license (see LICENSE.md)
	 **
	 ** Credits:
	 ** Chalkboard effect by Mohamed Moustafa https://github.com/mmoustafa/Chalkboard
	 ** Multi color support initially added by Kurt Rinnert https://github.com/rinnert
	 ** Compatibility with reveal.js v4 by Hakim El Hattab https://github.com/hakimel
	 ******************************************************************/

	/*
	function scriptPath() {
		// obtain plugin path from the script element
		var src;
		if ( document.currentScript ) {
			src = document.currentScript.src;
		} else {
			var sel = document.querySelector( 'script[src$="/chalkboard/plugin.js"]' )
			if ( sel ) {
				src = sel.src;
			}
		}
		var path = ( src === undefined ) ? "" : src.slice( 0, src.lastIndexOf( "/" ) + 1 );
	        //console.log("Path: " + path);
		return path;
	}
	var path = scriptPath();
	*/


	initChalkboard: function ( Reveal ) {
		let that = this;

		//console.warn(path);
		/* Feature detection for passive event handling*/
		var passiveSupported = false;

		try {
			window.addEventListener( 'test', null, Object.defineProperty( {}, 'passive', {
				get: function () {
					passiveSupported = true;
				}
			} ) );
		} catch ( err ) {}


		/*****************************************************************
		 ** Configuration
		 ******************************************************************/
		var background, pens, draw, color;
		var grid = false;
		var boardmarkerWidth = 3;
		var chalkWidth = 7;
		var chalkEffect = 1.0;
		var rememberColor = [ true, false ];
                var path = '../assets/imgs/chalkboard/';
		var eraser = {
			// src: require(path + 'sponge.png'),
			src: that.eraser_src,
			radius: 20
		};
		var boardmarkers = [ {
				color: 'rgba(100,100,100,1)',
				// cursor: 'url(' + path + 'img/boardmarker-black.png), auto'
				cursor: 'url(' + that.boardmarker_black + '), auto'
			},
			{
				color: 'rgba(30,144,255, 1)',
				// cursor: 'url(' + path + 'img/boardmarker-blue.png), auto'
				cursor: 'url(' + that.boardmarker_blue + '), auto'
			},
			{
				color: 'rgba(220,20,60,1)',
				// cursor: 'url(' + path + 'img/boardmarker-red.png), auto'
				cursor: 'url(' + that.boardmarker_red + '), auto'
			},
			{
				color: 'rgba(50,205,50,1)',
				// cursor: 'url(' + path + 'img/boardmarker-green.png), auto'
				cursor: 'url(' + that.boardmarker_green + '), auto'
			},
			{
				color: 'rgba(255,140,0,1)',
				// cursor: 'url(' + path + 'img/boardmarker-orange.png), auto'
				cursor: 'url(' + that.boardmarker_orange + '), auto'
			},
			{
				color: 'rgba(150,0,20150,1)',
				// cursor: 'url(' + path + 'img/boardmarker-purple.png), auto'
				cursor: 'url(' + that.boardmarker_purple + '), auto'
			},
			{
				color: 'rgba(255,220,0,1)',
				// cursor: 'url(' + path + 'img/boardmarker-yellow.png), auto'
				cursor: 'url(' + that.boardmarker_yellow + '), auto'
			}
		];
		var chalks = [ {
				color: 'rgba(255,255,255,0.5)',
				// cursor: 'url(' + path + 'img/chalk-white.png), auto'
				cursor: 'url(' + that.chalk_white + '), auto'
			},
			{
				color: 'rgba(96, 154, 244, 0.5)',
				// cursor: 'url(' + path + 'img/chalk-blue.png), auto'
				cursor: 'url(' + that.chalk_blue + '), auto'
			},
			{
				color: 'rgba(237, 20, 28, 0.5)',
				// cursor: 'url(' + path + 'img/chalk-red.png), auto'
				cursor: 'url(' + that.chalk_red + '), auto'
			},
			{
				color: 'rgba(20, 237, 28, 0.5)',
				// cursor: 'url(' + path + 'img/chalk-green.png), auto'
				cursor: 'url(' + that.chalk_green + '), auto'
			},
			{
				color: 'rgba(220, 133, 41, 0.5)',
				// cursor: 'url(' + path + 'img/chalk-orange.png), auto'
				cursor: 'url(' + that.chalk_orange + '), auto'
			},
			{
				color: 'rgba(220,0,220,0.5)',
				// cursor: 'url(' + path + 'img/chalk-purple.png), auto'
				cursor: 'url(' + that.chalk_purple + '), auto'
			},
			{
				color: 'rgba(255,220,0,0.5)',
				// cursor: 'url(' + path + 'img/chalk-yellow.png), auto'
				cursor: 'url(' + that.chalk_yellow + '), auto'
			}
		];
		var keyBindings = {
			toggleNotesCanvas: {
				keyCode: 67,
				key: 'C',
				description: 'Toggle notes canvas'
			},
			toggleChalkboard: {
				keyCode: 66,
				key: 'B',
				description: 'Toggle chalkboard'
			},
			clear: {
				keyCode: 46,
				key: 'DEL',
				description: 'Clear drawings on slide'
			},
			/*
			reset: {
				keyCode: 173,
				key: '-',
				description: 'Reset drawings on slide'
			},
			 */
			resetAll: {
				keyCode: 8,
				key: 'BACKSPACE',
				description: 'Reset all drawings'
			},
			colorNext: {
				keyCode: 88,
				key: 'X',
				description: 'Next color'
			},
			colorPrev: {
				keyCode: 89,
				key: 'Y',
				description: 'Previous color'
			},
			download: {
				keyCode: 68,
				key: 'D',
				description: 'Download drawings'
			}
		};

		var theme = 'chalkboard';
		var color = [ 0, 0 ];
		var toggleChalkboardButton = false;
		var toggleNotesButton = false;
		var colorButtons = true;
		var boardHandle = true;
		var transition = 800;

		var readOnly = false;
		var messageType = 'broadcast';

		var config = configure( Reveal.getConfig().chalkboard || {} );
		if ( config.keyBindings ) {
			for ( var key in config.keyBindings ) {
				keyBindings[ key ] = config.keyBindings[ key ];
			};
		}

		function configure( config ) {
			if ( config.boardmarkerWidth || config.penWidth ) boardmarkerWidth = config.boardmarkerWidth || config.penWidth;
			if ( config.chalkWidth ) chalkWidth = config.chalkWidth;
			if ( config.chalkEffect ) chalkEffect = config.chalkEffect;
			if ( config.rememberColor ) rememberColor = config.rememberColor;
			if ( config.eraser ) eraser = config.eraser;
			if ( config.boardmarkers ) boardmarkers = config.boardmarkers;
			if ( config.chalks ) chalks = config.chalks;

			if ( config.theme ) theme = config.theme;
			theme = 'whiteboard';
			switch ( theme ) {
			case 'chalkboard':
				// background = [ 'rgba(127,127,127,.1)', path + 'img/blackboard.png' ];
				background = [ 'rgba(127,127,127,.1)', that.blackboard_png ];
				draw = [ drawWithBoardmarker, drawWithChalk ];
				pens = [ boardmarkers, chalks ];
                                // console.log("chalkboard pens: ", pens); 
				grid = {
					color: 'rgb(50,50,10,0.5)',
					distance: 80,
					width: 2
				};
				break;
			case 'whiteboard':
			default:
				// background = [ 'rgba(127,127,127,.1)', path + 'img/whiteboard.png' ];
				background = [ 'rgba(127,127,127,.1)', that.whiteboard_png ];
				draw = [ drawWithBoardmarker, drawWithBoardmarker ];
				pens = [ boardmarkers, boardmarkers ];
				grid = {
					color: 'rgb(127,127,255,0.1)',
					distance: 40,
					width: 2
				};
			}

			if ( config.background ) background = config.background;
			if ( config.grid != undefined ) grid = config.grid;

			if ( config.toggleChalkboardButton != undefined ) toggleChalkboardButton = config.toggleChalkboardButton;
			if ( config.toggleNotesButton != undefined ) toggleNotesButton = config.toggleNotesButton;
			if ( config.colorButtons != undefined ) colorButtons = config.colorButtons;
			if ( config.boardHandle != undefined ) boardHandle = config.boardHandle;
			if ( config.transition ) transition = config.transition;

			if ( config.readOnly != undefined ) readOnly = config.readOnly;
			if ( config.messageType ) messageType = config.messageType;

			if ( drawingCanvas && ( config.theme || config.background || config.grid ) ) {
				var canvas = document.getElementById( drawingCanvas[ 1 ].id );
				canvas.style.background = 'url("' + background[ 1 ] + '") repeat';
				clearCanvas( 1 );
				drawGrid();
			}

			return config;
		}

		/*****************************************************************
		 ** Setup
		 ******************************************************************/
		function whenReady( callback ) {
			// wait for markdown to be parsed and code to be highlighted
			if ( !document.querySelector( 'section[data-markdown]:not([data-markdown-parsed])' ) 
			     && !document.querySelector( 'code[data-line-numbers*="|"]') 	
			) {
				callback();
			} else {
				console.log( "Wait for markdown to be parsed and code to be highlighted" );
				setTimeout( whenReady, 500, callback )
			}
		}

		function whenLoaded( callback ) {
			// wait for drawings to be loaded and markdown to be parsed
			if ( loaded !== null ) {
				callback();
			} else {
				console.log( "Wait for drawings to be loaded" );
				setTimeout( whenLoaded, 500, callback )
			}
		}

		if ( toggleChalkboardButton ) {
			console.warn( "toggleChalkboardButton is deprecated, use customcontrols plugin instead!" );
			// console.log("toggleChalkboardButton")
			var button = document.createElement( 'div' );
			button.className = "chalkboard-button";
			button.id = "toggle-chalkboard";
			button.style.visibility = "visible";
			button.style.position = "absolute";
			button.style.zIndex = 30;
			button.style.fontSize = "24px";

			button.style.left = toggleChalkboardButton.left || "30px";
			button.style.bottom = toggleChalkboardButton.bottom || "30px";
			button.style.top = toggleChalkboardButton.top || "auto";
			button.style.right = toggleChalkboardButton.right || "auto";

			button.innerHTML = '<a href="#" title="Toggle chalkboard (' + 
						keyBindings.toggleChalkboard.key 
				+ ')" onclick="RevealChalkboard.toggleChalkboard(); return false;"><i class="fa fa-pen-square"></i></a>'
			document.querySelector( ".reveal" ).appendChild( button );
		}
		if ( toggleNotesButton ) {
			console.warn( "toggleNotesButton is deprecated, use customcontrols plugin instead!" );
			//console.log("toggleNotesButton")
			var button = document.createElement( 'div' );
			button.className = "chalkboard-button";
			button.id = "toggle-notes";
			button.style.position = "absolute";
			button.style.zIndex = 30;
			button.style.fontSize = "24px";

			button.style.left = toggleNotesButton.left || "70px";
			button.style.bottom = toggleNotesButton.bottom || "30px";
			button.style.top = toggleNotesButton.top || "auto";
			button.style.right = toggleNotesButton.right || "auto";

			button.innerHTML = '<a href="#" title="Toggle slide annotation (' + 
				keyBindings.toggleNotesCanvas.key + 
				')" onclick="RevealChalkboard.toggleNotesCanvas(); return false;"><i class="fa fa-pen"></i></a>'
			document.querySelector( ".reveal" ).appendChild( button );
		}

		var drawingCanvas = [ {
			id: 'notescanvas'
		}, {
			id: 'chalkboard'
		} ];
		setupDrawingCanvas( 0 );
		setupDrawingCanvas( 1 );

		var mode = 0; // 0: notes canvas, 1: chalkboard
		var board = 0; // board index (only for chalkboard)

		var mouseX = 0;
		var mouseY = 0;
		var lastX = null;
		var lastY = null;

		var drawing = false;
		var erasing = false;

		var slideStart = Date.now();
		var slideIndices = {
			h: 0,
			v: 0
		};

		var timeouts = [
			[],
			[]
		];
		var touchTimeout = null;
		var slidechangeTimeout = null;
		var updateStorageTimeout = null;
		var playback = false;

		function createPalette( colors, length ) {
			if ( length === true || length > colors.length ) {
				length = colors.length;
			}
			var palette = document.createElement( 'div' );
		        // palette.style.zIndex = 9997;
			palette.classList.add( 'palette' );
			var list = document.createElement( 'ul' );
		        // list.style.zIndex = 9998;
			// color pickers
			for ( var i = 0; i < length; i++ ) {
				var colorButton = document.createElement( 'li' );
				colorButton.setAttribute( 'data-color', i );
				colorButton.classList.add('chalkboard_color_button');
				colorButton.style.backgroundColor = colors[ i ].color;
				colorButton.style.width = '6vh';
				colorButton.style.height = '3vh';
				colorButton.addEventListener( 'click', function ( e ) {
					// e.preventDefault();
					// console.log("color button clicked");
					var element = e.target;
					while ( !element.hasAttribute( 'data-color' ) ) {
						element = element.parentElement;
					}
					colorIndex( parseInt( element.getAttribute( 'data-color' ) ) );
				} );

				colorButton.addEventListener( 'touchstart', function ( e ) {
					var element = e.target;
					while ( !element.hasAttribute( 'data-color' ) ) {
						element = element.parentElement;
					}
					colorIndex( parseInt( element.getAttribute( 'data-color' ) ) );
				} );
                                // console.log("colorButton: ", colorButton);
				list.appendChild( colorButton );
			}
			palette.appendChild( list );
			return palette;
		};

		function switchBoard( boardIdx ) {
			selectBoard( boardIdx, true );
			// broadcast
			var message = new CustomEvent( messageType );
				message.content = {
				sender: 'chalkboard-plugin',
				type: 'selectboard',
				timestamp: Date.now() - slideStart,
				mode,
				board
			};
			document.dispatchEvent( message );	
		}

		function setupDrawingCanvas( id ) {
			var container = document.createElement( 'div' );
			container.id = drawingCanvas[ id ].id;
			container.classList.add( 'overlay' );
			container.setAttribute( 'data-prevent-swipe', 'true' );
			container.oncontextmenu = function () {
				return false;
			}
			container.style.cursor = pens[ id ][ color[ id ] ].cursor;
			// console.log("setupDrawingCanvas pens[ id ][ color[ id ] ].cursor: ", pens[ id ][ color[ id ] ].cursor);
			// console.log("setupDrawingCanvas container.style.cursor: ", container.style.cursor);

			drawingCanvas[ id ].width = window.innerWidth;
			drawingCanvas[ id ].height = window.innerHeight;
			drawingCanvas[ id ].scale = 1;
			drawingCanvas[ id ].xOffset = 0;
			drawingCanvas[ id ].yOffset = 0;

			if ( id == "0" ) {
				container.style.background = 'rgba(0,0,0,0)';
				container.style.zIndex = 24;
				container.style.opacity = 1;
				container.style.visibility = 'visible';
				container.style.pointerEvents = 'none';

				var slides = document.querySelector( '.slides' );
				var aspectRatio = Reveal.getConfig().width / Reveal.getConfig().height;
				if ( drawingCanvas[ id ].width > drawingCanvas[ id ].height * aspectRatio ) {
					drawingCanvas[ id ].xOffset = ( drawingCanvas[ id ].width - drawingCanvas[ id ].height * aspectRatio ) / 2;
				} else if ( drawingCanvas[ id ].height > drawingCanvas[ id ].width / aspectRatio ) {
					drawingCanvas[ id ].yOffset = ( drawingCanvas[ id ].height - drawingCanvas[ id ].width / aspectRatio ) / 2;
				}

				if ( colorButtons ) {
					var palette = createPalette( boardmarkers, colorButtons );
					palette.style.visibility = 'hidden'; // only show palette in drawing mode
					container.appendChild( palette );
				}
			} else {
				container.style.background = 'url("' + background[ id ] + '") repeat';
				container.style.zIndex = 26;
				container.style.opacity = 0;
				container.style.visibility = 'hidden';

				if ( colorButtons ) {
					var palette = createPalette( chalks, colorButtons );
					container.appendChild( palette );
				}
				if ( boardHandle ) {
					var handle = document.createElement( 'div' );
					handle.classList.add( 'boardhandle' );
					handle.innerHTML = '<ul><li><a id="previousboard" href="#" title="Previous board">' + 
						'<i class="fas fa-chevron-up"></i></a></li>'+
						'<li><a id="nextboard" href="#" title="Next board"><i class="fas fa-chevron-down"></i></a></li></ul>';
					handle.querySelector( '#previousboard' ).addEventListener( 'click', function ( e ) {
						e.preventDefault();
						switchBoard( board - 1 );
					} );
					handle.querySelector( '#nextboard' ).addEventListener( 'click', function ( e ) {
						e.preventDefault();
						switchBoard( board + 1 );
					} );
					handle.querySelector( '#previousboard' ).addEventListener( 'touchstart', function ( e ) {
						e.preventDefault();
						switchBoard( board - 1 );
					} );
					handle.querySelector( '#nextboard' ).addEventListener( 'touchstart', function ( e ) {
						e.preventDefault();
						switchBoard( board + 1 );
					} );

					container.appendChild( handle );
				}
			}


			var sponge = document.createElement( 'img' );
			sponge.src = eraser.src;
			sponge.id = 'sponge';
			sponge.style.visibility = 'hidden';
			sponge.style.position = 'absolute';
			container.appendChild( sponge );
			drawingCanvas[ id ].sponge = sponge;

			var canvas = document.createElement( 'canvas' );
			canvas.width = drawingCanvas[ id ].width;
			canvas.height = drawingCanvas[ id ].height;
			canvas.setAttribute( 'data-chalkboard', id );
			canvas.style.cursor = pens[ id ][ color[ id ] ].cursor;
			// console.log("setupDrawingCanvas pens[ id ][ color[ id ] ].cursor: ", pens[ id ][ color[ id ] ].cursor);
			// console.log("setupDrawingCanvas canvas.style.cursor: ", canvas.style.cursor);
			container.appendChild( canvas );
			drawingCanvas[ id ].canvas = canvas;

			drawingCanvas[ id ].context = canvas.getContext( '2d' );

			setupCanvasEvents( container );

			document.querySelector( '.reveal' ).appendChild( container );
			drawingCanvas[ id ].container = container;
		}

		/*****************************************************************
		 ** Storage
		 ******************************************************************/
		var storage = [ {
				width: Reveal.getConfig().width,
				height: Reveal.getConfig().height,
				data: []
			},
			{
				width: Reveal.getConfig().width,
				height: Reveal.getConfig().height,
				data: []
			}
		];

		var loaded = null;

		if ( config.storage ) {
			// Get chalkboard drawings from session storage
			loaded = initStorage( sessionStorage.getItem( config.storage ) );
		}

		if ( !loaded && config.src != null ) {
			// Get chalkboard drawings from the given file
			loadData( config.src );
		}

		/**
		 * Initialize storage.
		 */
		function initStorage( json ) {
			var success = false;
			try {
				var data = JSON.parse( json );
				for ( var id = 0; id < data.length; id++ ) {
					if ( drawingCanvas[ id ].width != data[ id ].width || drawingCanvas[ id ].height != data[ id ].height ) {
						drawingCanvas[ id ].scale = Math.min( drawingCanvas[ id ].width / data[ id ].width, 
										drawingCanvas[ id ].height / data[ id ].height );
						drawingCanvas[ id ].xOffset = ( drawingCanvas[ id ].width - 
										data[ id ].width * drawingCanvas[ id ].scale ) / 2;
						drawingCanvas[ id ].yOffset = ( drawingCanvas[ id ].height - 
										data[ id ].height * drawingCanvas[ id ].scale ) / 2;
					}
					if ( config.readOnly ) {
						drawingCanvas[ id ].container.style.cursor = 'default';
						drawingCanvas[ id ].canvas.style.cursor = 'default';
					}
				}
				success = true;
				storage = data;
			} catch ( err ) {
				// console.warn( "Cannot initialise storage!" );
			}
			return success;
		}


		/**
		 * Load data.
		 */
		function loadData( filename ) {
			var xhr = new XMLHttpRequest();
			xhr.onload = function () {
				if ( xhr.readyState === 4 && xhr.status != 404 ) {
					loaded = initStorage( xhr.responseText );
					updateStorage();
					console.log( "Drawings loaded from file" );
				} else {
					config.readOnly = undefined;
					readOnly = undefined;
					console.warn( 'Failed to get file ' + filename + '. ReadyState: ' + 
							xhr.readyState + ', Status: ' + xhr.status );
					loaded = false;
				}
			};

			xhr.open( 'GET', filename, true );
			try {
				xhr.send();
			} catch ( error ) {
				config.readOnly = undefined;
				readOnly = undefined;
				console.warn( 'Failed to get file ' + filename 
                        + '. Make sure that the presentation and the file are served by a HTTP server and the file can be found there. ' + error );
				loaded = false;
			}
		}


		function storageChanged( now ) {
			if ( !now ) {
				// create or update timer
				if ( updateStorageTimeout ) {
					clearTimeout( updateStorageTimeout );
				}
				updateStorageTimeout = setTimeout( storageChanged, 1000, true);
			}
			else {
				// console.log("Update storage", updateStorageTimeout,  Date.now());
				updateStorage();
				updateStorageTimeout = null;
			}
		}

		function updateStorage() {
			var json = JSON.stringify( storage )
			if ( config.storage ) {
				sessionStorage.setItem( config.storage, json )
			}
			return json;
		}

		function recordEvent( event ) {
			// console.log(event);
			event.time = Date.now() - slideStart;
			if ( mode == 1 ) event.board = board;
			var slideData = getSlideData();
			var i = slideData.events.length;
			while ( i > 0 && event.time < slideData.events[ i - 1 ].time ) {
				i--;
			}
			slideData.events.splice( i, 0, event );
			slideData.duration = Math.max( slideData.duration, Date.now() - slideStart ) + 1;

			storageChanged();
		}

		/**
		 * Get data as json string.
		 */
		function getData() {
			// cleanup slide data without events
			for ( var id = 0; id < 2; id++ ) {
				for ( var i = storage[ id ].data.length - 1; i >= 0; i-- ) {
					if ( storage[ id ].data[ i ].events.length == 0 ) {
						storage[ id ].data.splice( i, 1 );
					}
				}
			}

			return updateStorage();
		}

		/**
		 * Download data.
		 */
		function downloadData() {
			var a = document.createElement( 'a' );
			document.body.appendChild( a );
			try {
				a.download = 'chalkboard.json';
				var blob = new Blob( [ getData() ], {
					type: 'application/json'
				} );
				a.href = window.URL.createObjectURL( blob );
			} catch ( error ) {
				a.innerHTML += ' (' + error + ')';
			}
			a.click();
			document.body.removeChild( a );
		}

		/**
		 * Returns data object for the slide with the given indices.
		 */
		function getSlideData( indices, id ) {
			if ( id == undefined ) id = mode;
			if ( !indices ) indices = slideIndices;
			var data;
			for ( var i = 0; i < storage[ id ].data.length; i++ ) {
				if ( storage[ id ].data[ i ].slide.h === 
					indices.h && storage[ id ].data[ i ].slide.v === 
					indices.v && storage[ id ].data[ i ].slide.f === indices.f ) {
					data = storage[ id ].data[ i ];
					return data;
				}
			}
			var page = Number( Reveal.getCurrentSlide().getAttribute('data-pdf-page-number') ); 
			// console.log( indices, Reveal.getCurrentSlide() );
			storage[ id ].data.push( {
				slide: indices,
				page,
				events: [],
				duration: 0
			} );
			data = storage[ id ].data[ storage[ id ].data.length - 1 ];
			return data;
		}

		/**
		 * Returns maximum duration of slide playback for both modes
		 */
		function getSlideDuration( indices ) {
			if ( !indices ) indices = slideIndices;
			var duration = 0;
			for ( var id = 0; id < 2; id++ ) {
				for ( var i = 0; i < storage[ id ].data.length; i++ ) {
					if ( storage[ id ].data[ i ].slide.h === 
						indices.h && storage[ id ].data[ i ].slide.v === 
						indices.v && storage[ id ].data[ i ].slide.f === indices.f ) {
						duration = Math.max( duration, storage[ id ].data[ i ].duration );
						break;
					}
				}
			}
			// console.log( duration );
			return duration;
		}

		/*****************************************************************
		 ** Print
		 ******************************************************************/
		var printMode = ( /print-pdf/gi ).test( window.location.search );
		// console.log("createPrintout" + printMode)

		function addPageNumbers() {
			// determine page number for printouts with fragments serialised
			var slides = Reveal.getSlides();
			var page = 0;
			for ( var i=0; i < slides.length; i++) {
				slides[i].setAttribute('data-pdf-page-number',page.toString());
				// add number of fragments without fragment indices
				var count = slides[i].querySelectorAll('.fragment:not([data-fragment-index])').length;
				var fragments = slides[i].querySelectorAll('.fragment[data-fragment-index]');
				for ( var j=0; j < fragments.length; j++) {
					// increasenumber of fragments by highest fragment index (which start at 0)
					if ( Number(fragments[j].getAttribute('data-fragment-index')) + 1 > count ) {
						count = Number(fragments[j].getAttribute('data-fragment-index')) + 1;
					}
				}
				// console.log(count,fragments.length,( slides[i].querySelector('h1,h2,h3,h4')||{}).innerHTML, page); 
				page += count + 1;
			}
		}

		function createPrintout() {
			//console.warn(Reveal.getTotalSlides(),Reveal.getSlidesElement());
			if ( storage[ 1 ].data.length == 0 ) return;
			console.log( 'Create printout(s) for ' + storage[ 1 ].data.length + " slides" );
			drawingCanvas[ 0 ].container.style.opacity = 0; // do not print notes canvas
			drawingCanvas[ 0 ].container.style.visibility = 'hidden';

			var patImg = new Image();
			patImg.onload = function () {
				var slides = Reveal.getSlides();
				//console.log(slides);
				for ( var i = storage[ 1 ].data.length - 1; i >= 0; i-- ) {
					// console.log( 'Create printout for slide ' + storage[ 1 ].data[ i ].slide.h 
                                        //                + '.' + storage[ 1 ].data[ i ].slide.v );
					var slideData = getSlideData( storage[ 1 ].data[ i ].slide, 1 );
					var drawings = createDrawings( slideData, patImg );
					// console.log("Page:", storage[ 1 ].data[ i ].page );
					// console.log("Slide:", slides[storage[ 1 ].data[ i ].page] );
					addDrawings( slides[storage[ 1 ].data[ i ].page], drawings );

				}
				// Reveal.sync();
			};
			patImg.src = background[ 1 ];
		}

		function cloneCanvas( oldCanvas ) {
			//create a new canvas
			var newCanvas = document.createElement( 'canvas' );
			var context = newCanvas.getContext( '2d' );
			//set dimensions
			newCanvas.width = oldCanvas.width;
			newCanvas.height = oldCanvas.height;
			//apply the old canvas to the new one
			context.drawImage( oldCanvas, 0, 0 );
			//return the new canvas
			return newCanvas;
		}

		function getCanvas( template, container, board ) {
			var idx = container.findIndex( element => element.board === board );
			if ( idx === -1 ) {
				var canvas = cloneCanvas( template );
				if ( !container.length ) {
					idx = 0;
					container.push( {
						board,
						canvas
					} );
				} else if ( board < container[ 0 ].board ) {
					idx = 0;
					container.unshift( {
						board,
						canvas
					} );
				} else if ( board > container[ container.length - 1 ].board ) {
					idx = container.length;
					container.push( {
						board,
						canvas
					} );
				}
			}

			return container[ idx ].canvas;
		}

		function createDrawings( slideData, patImg ) {
			var width = Reveal.getConfig().width;
			var height = Reveal.getConfig().height;
			var scale = 1;
			var xOffset = 0;
			var yOffset = 0;
			if ( width != storage[ 1 ].width || height != storage[ 1 ].height ) {
				scale = Math.min( width / storage[ 1 ].width, height / storage[ 1 ].height );
				xOffset = ( width - storage[ 1 ].width * scale ) / 2;
				yOffset = ( height - storage[ 1 ].height * scale ) / 2;
			}
			mode = 1;
			board = 0;
			// console.log( 'Create printout(s) for slide ', slideData );

			var drawings = [];
			var template = document.createElement( 'canvas' );
			template.width = width;
			template.height = height;

			var imgCtx = template.getContext( '2d' );
			imgCtx.fillStyle = imgCtx.createPattern( patImg, 'repeat' );
			imgCtx.rect( 0, 0, width, height );
			imgCtx.fill();

			for ( var j = 0; j < slideData.events.length; j++ ) {
				switch ( slideData.events[ j ].type ) {
				case 'draw':
					draw[ 1 ]( getCanvas( template, drawings, board ).getContext( '2d' ),
						xOffset + slideData.events[ j ].x1 * scale,
						yOffset + slideData.events[ j ].y1 * scale,
						xOffset + slideData.events[ j ].x2 * scale,
						yOffset + slideData.events[ j ].y2 * scale,
						yOffset + slideData.events[ j ].color
					);
					break;
				case 'erase':
					eraseWithSponge( getCanvas( template, drawings, board ).getContext( '2d' ),
						xOffset + slideData.events[ j ].x * scale,
						yOffset + slideData.events[ j ].y * scale
					);
					break;
				case 'selectboard':
					selectBoard( slideData.events[ j ].board );
					break;
				case 'clear':
					getCanvas( template, drawings, board ).getContext( '2d' ).clearRect( 0, 0, width, height );
					getCanvas( template, drawings, board ).getContext( '2d' ).fill();
					break;
				default:
					break;
				}
			}

			drawings = drawings.sort( ( a, b ) => a.board > b.board && 1 || -1 );

			mode = 0;

			return drawings;
		}

		function addDrawings( slide, drawings ) {
			var parent = slide.parentElement.parentElement;
			var nextSlide = slide.parentElement.nextElementSibling;

			for ( var i = 0; i < drawings.length; i++ ) {
				var newPDFPage = document.createElement( 'div' );
				newPDFPage.classList.add( 'pdf-page' );
				newPDFPage.style.height = Reveal.getConfig().height;
				newPDFPage.append( drawings[ i ].canvas );
	//console.log("Add drawing", newPDFPage);
				if ( nextSlide != null ) {
					parent.insertBefore( newPDFPage, nextSlide );
				} else {
					parent.append( newPDFPage );
				}
			}
		}

		/*****************************************************************
		 ** Drawings
		 ******************************************************************/

		function drawWithBoardmarker( context, fromX, fromY, toX, toY, colorIdx ) {
			if ( colorIdx == undefined ) colorIdx = color[ mode ];
			context.lineWidth = boardmarkerWidth;
			context.lineCap = 'round';
			context.strokeStyle = boardmarkers[ colorIdx ].color;
			context.beginPath();
			context.moveTo( fromX, fromY );
			context.lineTo( toX, toY );
			context.stroke();
		}

		function drawWithChalk( context, fromX, fromY, toX, toY, colorIdx ) {
			if ( colorIdx == undefined ) colorIdx = color[ mode ];
			var brushDiameter = chalkWidth;
			context.lineWidth = brushDiameter;
			context.lineCap = 'round';
			context.fillStyle = chalks[ colorIdx ].color; // 'rgba(255,255,255,0.5)';
			context.strokeStyle = chalks[ colorIdx ].color;
			/*var opacity = Math.min(0.8, Math.max(0,color[1].replace(/^.*,(.+)\)/,'$1') - 0.1)) + Math.random()*0.2;*/
			var opacity = 1.0;
			context.strokeStyle = context.strokeStyle.replace( /[\d\.]+\)$/g, opacity + ')' );
			context.beginPath();
			context.moveTo( fromX, fromY );
			context.lineTo( toX, toY );
			context.stroke();
			// Chalk Effect
			var length = Math.round( Math.sqrt( Math.pow( toX - fromX, 2 ) + Math.pow( toY - fromY, 2 ) ) / ( 5 / brushDiameter ) );
			var xUnit = ( toX - fromX ) / length;
			var yUnit = ( toY - fromY ) / length;
			for ( var i = 0; i < length; i++ ) {
				if ( chalkEffect > ( Math.random() * 0.9 ) ) {
					var xCurrent = fromX + ( i * xUnit );
					var yCurrent = fromY + ( i * yUnit );
					var xRandom = xCurrent + ( Math.random() - 0.5 ) * brushDiameter * 1.2;
					var yRandom = yCurrent + ( Math.random() - 0.5 ) * brushDiameter * 1.2;
					context.clearRect( xRandom, yRandom, Math.random() * 2 + 2, Math.random() + 1 );
				}
			}
		}
	 
		function eraseWithSponge( context, x, y ) {
			context.save();
			context.beginPath();
			context.arc( x, y, eraser.radius, 0, 2 * Math.PI, false );
			context.clip();
			context.clearRect( x - eraser.radius - 1, y - eraser.radius - 1, eraser.radius * 2 + 2, eraser.radius * 2 + 2 );
			context.restore();
			if ( mode == 1 && grid ) {
				redrawGrid( x, y, eraser.radius );
			}
		}


		/**
		 * Show an overlay for the chalkboard.
		 */
		function showChalkboard() {
	//console.log("showChalkboard");
			clearTimeout( touchTimeout );
			touchTimeout = null;
			drawingCanvas[ 0 ].sponge.style.visibility = 'hidden'; // make sure that the sponge from touch events is hidden
			drawingCanvas[ 1 ].sponge.style.visibility = 'hidden'; // make sure that the sponge from touch events is hidden
			drawingCanvas[ 1 ].container.style.opacity = 1;
			drawingCanvas[ 1 ].container.style.visibility = 'visible';
			mode = 1;
		}


		/**
		 * Closes open chalkboard.
		 */
		function closeChalkboard() {
			clearTimeout( touchTimeout );
			touchTimeout = null;
			drawingCanvas[ 0 ].sponge.style.visibility = 'hidden'; // make sure that the sponge from touch events is hidden
			drawingCanvas[ 1 ].sponge.style.visibility = 'hidden'; // make sure that the sponge from touch events is hidden
			drawingCanvas[ 1 ].container.style.opacity = 0;
			drawingCanvas[ 1 ].container.style.visibility = 'hidden';
			lastX = null;
			lastY = null;
			mode = 0;
		}

		/**
		 * Clear current canvas.
		 */
		function clearCanvas( id ) {
			if ( id == 0 ) clearTimeout( slidechangeTimeout );
			drawingCanvas[ id ].context.clearRect( 0, 0, drawingCanvas[ id ].width, drawingCanvas[ id ].height );
			if ( id == 1 && grid ) drawGrid();
		}

		/**
		 * Draw grid on background
		 */
		function drawGrid() {
			var context = drawingCanvas[ 1 ].context;

			drawingCanvas[ 1 ].scale = Math.min( drawingCanvas[ 1 ].width / storage[ 1 ].width, 
								drawingCanvas[ 1 ].height / storage[ 1 ].height );
			drawingCanvas[ 1 ].xOffset = ( drawingCanvas[ 1 ].width - storage[ 1 ].width * drawingCanvas[ 1 ].scale ) / 2;
			drawingCanvas[ 1 ].yOffset = ( drawingCanvas[ 1 ].height - storage[ 1 ].height * drawingCanvas[ 1 ].scale ) / 2;

			var scale = drawingCanvas[ 1 ].scale;
			var xOffset = drawingCanvas[ 1 ].xOffset;
			var yOffset = drawingCanvas[ 1 ].yOffset;

			var distance = grid.distance * scale;

			var fromX = drawingCanvas[ 1 ].width / 2 - distance / 2 - 
					Math.floor( ( drawingCanvas[ 1 ].width - distance ) / 2 / distance ) * distance;
			for ( var x = fromX; x < drawingCanvas[ 1 ].width; x += distance ) {
				context.beginPath();
				context.lineWidth = grid.width * scale;
				context.lineCap = 'round';
				context.fillStyle = grid.color;
				context.strokeStyle = grid.color;
				context.moveTo( x, 0 );
				context.lineTo( x, drawingCanvas[ 1 ].height );
				context.stroke();
			}
			var fromY = drawingCanvas[ 1 ].height / 2 - distance / 2 - 
					Math.floor( ( drawingCanvas[ 1 ].height - distance ) / 2 / distance ) * distance;

			for ( var y = fromY; y < drawingCanvas[ 1 ].height; y += distance ) {
				context.beginPath();
				context.lineWidth = grid.width * scale;
				context.lineCap = 'round';
				context.fillStyle = grid.color;
				context.strokeStyle = grid.color;
				context.moveTo( 0, y );
				context.lineTo( drawingCanvas[ 1 ].width, y );
				context.stroke();
			}
		}

		function redrawGrid( centerX, centerY, diameter ) {
			var context = drawingCanvas[ 1 ].context;

			drawingCanvas[ 1 ].scale = Math.min( drawingCanvas[ 1 ].width / storage[ 1 ].width, 
							drawingCanvas[ 1 ].height / storage[ 1 ].height );
			drawingCanvas[ 1 ].xOffset = ( drawingCanvas[ 1 ].width - storage[ 1 ].width * drawingCanvas[ 1 ].scale ) / 2;
			drawingCanvas[ 1 ].yOffset = ( drawingCanvas[ 1 ].height - storage[ 1 ].height * drawingCanvas[ 1 ].scale ) / 2;

			var scale = drawingCanvas[ 1 ].scale;
			var xOffset = drawingCanvas[ 1 ].xOffset;
			var yOffset = drawingCanvas[ 1 ].yOffset;

			var distance = grid.distance * scale;

			var fromX = drawingCanvas[ 1 ].width / 2 - distance / 2 - 
					Math.floor( ( drawingCanvas[ 1 ].width - distance ) / 2 / distance ) * distance;

			for ( var x = fromX + distance * Math.ceil( ( centerX - diameter - fromX ) / distance ); 
				x <= fromX + distance * Math.floor( ( centerX + diameter - fromX ) / distance ); x += distance ) {
				context.beginPath();
				context.lineWidth = grid.width * scale;
				context.lineCap = 'round';
				context.fillStyle = grid.color;
				context.strokeStyle = grid.color;
				context.moveTo( x, centerY - Math.sqrt( diameter * diameter - ( centerX - x ) * ( centerX - x ) ) );
				context.lineTo( x, centerY + Math.sqrt( diameter * diameter - ( centerX - x ) * ( centerX - x ) ) );
				context.stroke();
			}
			var fromY = drawingCanvas[ 1 ].height / 2 - distance / 2 - 
					Math.floor( ( drawingCanvas[ 1 ].height - distance ) / 2 / distance ) * distance;
			for ( var y = fromY + distance * Math.ceil( ( centerY - diameter - fromY ) / distance ); 
				y <= fromY + distance * Math.floor( ( centerY + diameter - fromY ) / distance ); y += distance ) {
				context.beginPath();
				context.lineWidth = grid.width * scale;
				context.lineCap = 'round';
				context.fillStyle = grid.color;
				context.strokeStyle = grid.color;
				context.moveTo( centerX - Math.sqrt( diameter * diameter - ( centerY - y ) * ( centerY - y ) ), y );
				context.lineTo( centerX + Math.sqrt( diameter * diameter - ( centerY - y ) * ( centerY - y ) ), y );
				context.stroke();
			}
		}

		/**
		 * Set the  color
		 */
		function setColor( index, record ) {
			// protect against out of bounds (this could happen when
			// replaying events recorded with different color settings).
			if ( index >= pens[ mode ].length ) index = 0;
			color[ mode ] = index;
			drawingCanvas[ mode ].canvas.style.cursor = pens[ mode ][ color[ mode ] ].cursor;
		}

		/**
		 * Set the  board
		 */
		function selectBoard( boardIdx, record ) {
	//console.log("Set board",boardIdx);
			if ( board == boardIdx ) return;

			board = boardIdx;
			redrawChalkboard( boardIdx );
			if ( record ) {
				recordEvent( { type: 'selectboard' } );
			}
		}

		function redrawChalkboard( boardIdx ) {
			clearCanvas( 1 );
			var slideData = getSlideData( slideIndices, 1 );
			var index = 0;
			var play = ( boardIdx == 0 );
			while ( index < slideData.events.length && slideData.events[ index ].time < Date.now() - slideStart ) {
				if ( boardIdx == slideData.events[ index ].board ) {
					playEvent( 1, slideData.events[ index ], Date.now() - slideStart );
				}

				index++;
			}
		}

		/**
		 * Forward cycle color
		 */
		function cycleColorNext() {
			color[ mode ] = ( color[ mode ] + 1 ) % pens[ mode ].length;
			return color[ mode ];
		}

		/**
		 * Backward cycle color
		 */
		function cycleColorPrev() {
			color[ mode ] = ( color[ mode ] + ( pens[ mode ].length - 1 ) ) % pens[ mode ].length;
			return color[ mode ];
		}

		/*****************************************************************
		 ** Broadcast
		 ******************************************************************/
		var eventQueue = [];

		document.addEventListener( 'received', function ( message ) {
			if ( message.content && message.content.sender == 'chalkboard-plugin' ) {
				// add message to queue
				eventQueue.push( message );
				// console.log( JSON.stringify( message ) );
			}
			if ( eventQueue.length == 1 ) processQueue();
		} );

		function processQueue() {
			// take first message from queue
			var message = eventQueue.shift();

			// synchronize time with seminar host
			slideStart = Date.now() - message.content.timestamp;
			// set status
			if ( mode < message.content.mode ) {
				// open chalkboard
				showChalkboard();
			} else if ( mode > message.content.mode ) {
				// close chalkboard
				closeChalkboard();
			}
			if ( board != message.content.board ) {
				board = message.content.board;
				redrawChalkboard( board );
			};

			switch ( message.content.type ) {
			case 'showChalkboard':
				showChalkboard();
				break;
			case 'closeChalkboard':
				closeChalkboard();
				break;
			case 'erase':
				erasePoint( message.content.x, message.content.y );
				break;
			case 'draw':
				drawSegment( message.content.fromX, message.content.fromY, message.content.toX, 
						message.content.toY, message.content.color );
				break;
			case 'clear':
				clearSlide();
				break;
			case 'selectboard':
				selectBoard( message.content.board, true );
				break;
			case 'resetSlide':
				resetSlideDrawings();
				break;
			case 'init':
				storage = message.content.storage;
				for ( var id = 0; id < 2; id++ ) {
					drawingCanvas[ id ].scale = Math.min( drawingCanvas[ id ].width / storage[ id ].width, 
									drawingCanvas[ id ].height / storage[ id ].height );
					drawingCanvas[ id ].xOffset = ( drawingCanvas[ id ].width - 
									storage[ id ].width * drawingCanvas[ id ].scale ) / 2;
					drawingCanvas[ id ].yOffset = ( drawingCanvas[ id ].height - 
									storage[ id ].height * drawingCanvas[ id ].scale ) / 2;
				}
				clearCanvas( 0 );
				clearCanvas( 1 );
				if ( !playback ) {
					slidechangeTimeout = setTimeout( startPlayback, transition, getSlideDuration(), 0 );
				}
				if ( mode == 1 && message.content.mode == 0 ) {
					setTimeout( closeChalkboard, transition + 50 );
				}
				if ( mode == 0 && message.content.mode == 1 ) {
					setTimeout( showChalkboard, transition + 50 );
				}
				mode = message.content.mode;
				board = message.content.board;
				break;
			default:
				break;
			}

			// continue with next message if queued
			if ( eventQueue.length > 0 ) {
				processQueue();
			} else {
				storageChanged();
			}
		}

		document.addEventListener( 'welcome', function ( user ) {
			// broadcast storage
			var message = new CustomEvent( messageType );
			message.content = {
				sender: 'chalkboard-plugin',
				recipient: user.id,
				type: 'init',
				timestamp: Date.now() - slideStart,
				storage: storage,
				mode,
				board
			};
			document.dispatchEvent( message );
		} );

		/*****************************************************************
		 ** Playback
		 ******************************************************************/
		document.addEventListener( 'seekplayback', function ( event ) {
	//console.log('event seekplayback ' + event.timestamp);
			stopPlayback();
			if ( !playback || event.timestamp == 0 ) {
				// in other cases startplayback fires after seeked
				startPlayback( event.timestamp );
			}
			//console.log('seeked');
		} );


		document.addEventListener( 'startplayback', function ( event ) {
	//console.log('event startplayback ' + event.timestamp);
			stopPlayback();
			playback = true;
			startPlayback( event.timestamp );
		} );

		document.addEventListener( 'stopplayback', function ( event ) {
	//console.log('event stopplayback ' + (Date.now() - slideStart) );
			playback = false;
			stopPlayback();
		} );

		document.addEventListener( 'startrecording', function ( event ) {
	//console.log('event startrecording ' + event.timestamp);
			startRecording();
		} );


		function startRecording() {
			resetSlide( true );
			slideStart = Date.now();
		}

		function startPlayback( timestamp, finalMode ) {
	//console.log("playback " + timestamp );
			slideStart = Date.now() - timestamp;
			closeChalkboard();
			mode = 0;
			board = 0;
			for ( var id = 0; id < 2; id++ ) {
				clearCanvas( id );
				var slideData = getSlideData( slideIndices, id );
	//console.log( timestamp +" / " + JSON.stringify(slideData));
				var index = 0;
				while ( index < slideData.events.length && slideData.events[ index ].time < ( Date.now() - slideStart ) ) {
					playEvent( id, slideData.events[ index ], timestamp );
					index++;
				}

				while ( playback && index < slideData.events.length ) {
					timeouts[ id ].push( setTimeout( playEvent, 
									slideData.events[ index ].time - ( Date.now() - slideStart ), 
									id, slideData.events[ index ], timestamp ) );
					index++;
				}
			}
	//console.log("Mode: " + finalMode + "/" + mode );
			if ( finalMode != undefined ) {
				mode = finalMode;
			}
			if ( mode == 1 ) showChalkboard();
	//console.log("playback (ok)");

		};

		function stopPlayback() {
	//console.log("stopPlayback");
	//console.log("Timeouts: " + timeouts[0].length + "/"+ timeouts[1].length);
			for ( var id = 0; id < 2; id++ ) {
				for ( var i = 0; i < timeouts[ id ].length; i++ ) {
					clearTimeout( timeouts[ id ][ i ] );
				}
				timeouts[ id ] = [];
			}
		};

		function playEvent( id, event, timestamp ) {
	//console.log( timestamp +" / " + JSON.stringify(event));
	//console.log( id + ": " + timestamp +" / " +  event.time +" / " + event.type +" / " + mode );
			switch ( event.type ) {
			case 'open':
				if ( timestamp <= event.time ) {
					showChalkboard();
				} else {
					mode = 1;
				}

				break;
			case 'close':
				if ( timestamp < event.time ) {
					closeChalkboard();
				} else {
					mode = 0;
				}
				break;
			case 'clear':
				clearCanvas( id );
				break;
			case 'selectboard':
				selectBoard( event.board );
				break;
			case 'draw':
				drawLine( id, event, timestamp );
				break;
			case 'erase':
				eraseCircle( id, event, timestamp );
				break;
			}
		};

		function drawLine( id, event, timestamp ) {
			var ctx = drawingCanvas[ id ].context;
			var scale = drawingCanvas[ id ].scale;
			var xOffset = drawingCanvas[ id ].xOffset;
			var yOffset = drawingCanvas[ id ].yOffset;
			draw[ id ]( ctx, xOffset + event.x1 * scale, yOffset + event.y1 * scale, 
					xOffset + event.x2 * scale, yOffset + event.y2 * scale, event.color );
		};

		function eraseCircle( id, event, timestamp ) {
			var ctx = drawingCanvas[ id ].context;
			var scale = drawingCanvas[ id ].scale;
			var xOffset = drawingCanvas[ id ].xOffset;
			var yOffset = drawingCanvas[ id ].yOffset;

			eraseWithSponge( ctx, xOffset + event.x * scale, yOffset + event.y * scale );
		};

		function startErasing( x, y ) {
			drawing = false;
			erasing = true;
			drawingCanvas[ mode ].sponge.style.visibility = 'visible';
			erasePoint( x, y );
		}

		function erasePoint( x, y ) {
			var ctx = drawingCanvas[ mode ].context;
			var scale = drawingCanvas[ mode ].scale;
			var xOffset = drawingCanvas[ mode ].xOffset;
			var yOffset = drawingCanvas[ mode ].yOffset;

			// move sponge image
			drawingCanvas[ mode ].sponge.style.left = ( x * scale + xOffset - eraser.radius ) + 'px';
			drawingCanvas[ mode ].sponge.style.top = ( y * scale + yOffset - 2 * eraser.radius ) + 'px';

			recordEvent( {
				type: 'erase',
				x,
				y
			} );

			if (
				x * scale + xOffset > 0 &&
				y * scale + yOffset > 0 &&
				x * scale + xOffset < drawingCanvas[ mode ].width &&
				y * scale + yOffset < drawingCanvas[ mode ].height
			) {
				eraseWithSponge( ctx, x * scale + xOffset, y * scale + yOffset );
			}
		}

		function stopErasing() {
			erasing = false;
			// hide sponge
			drawingCanvas[ mode ].sponge.style.visibility = 'hidden';
		}

		function startDrawing( x, y ) {
			drawing = true;

			var ctx = drawingCanvas[ mode ].context;
			var scale = drawingCanvas[ mode ].scale;
			var xOffset = drawingCanvas[ mode ].xOffset;
			var yOffset = drawingCanvas[ mode ].yOffset;
			lastX = x * scale + xOffset;
			lastY = y * scale + yOffset;
		}

		function drawSegment( fromX, fromY, toX, toY, colorIdx ) {
			var ctx = drawingCanvas[ mode ].context;
			var scale = drawingCanvas[ mode ].scale;
			var xOffset = drawingCanvas[ mode ].xOffset;
			var yOffset = drawingCanvas[ mode ].yOffset;

			recordEvent( {
				type: 'draw',
				color: colorIdx,
				x1: fromX,
				y1: fromY,
				x2: toX,
				y2: toY
			} );

			if (
				fromX * scale + xOffset > 0 &&
				fromY * scale + yOffset > 0 &&
				fromX * scale + xOffset < drawingCanvas[ mode ].width &&
				fromY * scale + yOffset < drawingCanvas[ mode ].height &&
				toX * scale + xOffset > 0 &&
				toY * scale + yOffset > 0 &&
				toX * scale + xOffset < drawingCanvas[ mode ].width &&
				toY * scale + yOffset < drawingCanvas[ mode ].height
			) {
				draw[ mode ]( ctx, fromX * scale + xOffset, fromY * scale + yOffset, 
						toX * scale + xOffset, toY * scale + yOffset, colorIdx );
			}
		}

		function stopDrawing() {
			drawing = false;
		}


		/*****************************************************************
		 ** User interface
		 ******************************************************************/

		function setupCanvasEvents( canvas ) {
			// TODO: check all touchevents
			canvas.addEventListener( 'touchstart', function ( evt ) {
				evt.preventDefault();
				//console.log("Touch start");
				if ( !readOnly && evt.target.getAttribute( 'data-chalkboard' ) == mode ) {
					var scale = drawingCanvas[ mode ].scale;
					var xOffset = drawingCanvas[ mode ].xOffset;
					var yOffset = drawingCanvas[ mode ].yOffset;

					var touch = evt.touches[ 0 ];
					mouseX = touch.pageX;
					mouseY = touch.pageY;
					startDrawing( ( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale );
					touchTimeout = setTimeout( startErasing, 500,  ( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale );
				}
			}, passiveSupported ? {
				passive: false
			} : false );

			canvas.addEventListener( 'touchmove', function ( evt ) {
				evt.preventDefault();
				//console.log("Touch move");
				clearTimeout( touchTimeout );
				touchTimeout = null;
				if ( drawing || erasing ) {
					var scale = drawingCanvas[ mode ].scale;
					var xOffset = drawingCanvas[ mode ].xOffset;
					var yOffset = drawingCanvas[ mode ].yOffset;

					var touch = evt.touches[ 0 ];
					mouseX = touch.pageX;
					mouseY = touch.pageY;
					if ( mouseY < drawingCanvas[ mode ].height && mouseX < drawingCanvas[ mode ].width ) {
						// move sponge
						if ( event.type == 'erase' ) {
							drawingCanvas[ mode ].sponge.style.left = ( mouseX - eraser.radius ) + 'px';
							drawingCanvas[ mode ].sponge.style.top = ( mouseY - eraser.radius ) + 'px';
						}
					}

					if ( drawing ) {
						drawSegment( ( lastX - xOffset ) / scale, ( lastY - yOffset ) / scale, 
								( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale, color[ mode ] );
						// broadcast
						var message = new CustomEvent( messageType );
						message.content = {
							sender: 'chalkboard-plugin',
							type: 'draw',
							timestamp: Date.now() - slideStart,
							mode,
							board,
							fromX: ( lastX - xOffset ) / scale,
							fromY: ( lastY - yOffset ) / scale,
							toX: ( mouseX - xOffset ) / scale,
							toY: ( mouseY - yOffset ) / scale,
							color: color[ mode ]
						};
						document.dispatchEvent( message );

						lastX = mouseX;
						lastY = mouseY;
					} else {
						erasePoint( ( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale );
						// broadcast
						var message = new CustomEvent( messageType );
						message.content = {
							sender: 'chalkboard-plugin',
							type: 'erase',
							timestamp: Date.now() - slideStart,
							mode,
							board,
							x: ( mouseX - xOffset ) / scale,
							y: ( mouseY - yOffset ) / scale
						};
						document.dispatchEvent( message );
					}

				}
			}, false );

			canvas.addEventListener( 'touchend', function ( evt ) {
				evt.preventDefault();
				clearTimeout( touchTimeout );
				touchTimeout = null;
				// hide sponge image
				drawingCanvas[ mode ].sponge.style.visibility = 'hidden';
				stopDrawing();
			}, false );

			canvas.addEventListener( 'mousedown', function ( evt ) {
				evt.preventDefault();
				if ( !readOnly && evt.target.getAttribute( 'data-chalkboard' ) == mode ) {
					// console.log( "mousedown: " + evt.button );
					var scale = drawingCanvas[ mode ].scale;
					var xOffset = drawingCanvas[ mode ].xOffset;
					var yOffset = drawingCanvas[ mode ].yOffset;

					mouseX = evt.pageX;
					mouseY = evt.pageY;

					if ( evt.button == 2 || evt.button == 1 ) {
						startErasing( ( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale );
						// broadcast
						var message = new CustomEvent( messageType );
						message.content = {
							sender: 'chalkboard-plugin',
							type: 'erase',
							timestamp: Date.now() - slideStart,
							mode,
							board,
							x: ( mouseX - xOffset ) / scale,
							y: ( mouseY - yOffset ) / scale
						};
						document.dispatchEvent( message );
					} else {
						startDrawing( ( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale );
					}
				}
			} );

			canvas.addEventListener( 'mousemove', function ( evt ) {
				evt.preventDefault();
				//console.log("Mouse move");
				if ( drawing || erasing ) {
					var scale = drawingCanvas[ mode ].scale;
					var xOffset = drawingCanvas[ mode ].xOffset;
					var yOffset = drawingCanvas[ mode ].yOffset;

					mouseX = evt.pageX;
					mouseY = evt.pageY;

					if ( drawing ) {
						drawSegment( ( lastX - xOffset ) / scale, ( lastY - yOffset ) / scale, 
								( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale, color[ mode ] );
						// broadcast
						var message = new CustomEvent( messageType );
						message.content = {
							sender: 'chalkboard-plugin',
							type: 'draw',
							timestamp: Date.now() - slideStart,
							mode,
							board,
							fromX: ( lastX - xOffset ) / scale,
							fromY: ( lastY - yOffset ) / scale,
							toX: ( mouseX - xOffset ) / scale,
							toY: ( mouseY - yOffset ) / scale,
							color: color[ mode ]
						};
						document.dispatchEvent( message );

						lastX = mouseX;
						lastY = mouseY;
					} else {
						erasePoint( ( mouseX - xOffset ) / scale, ( mouseY - yOffset ) / scale );
						// broadcast
						var message = new CustomEvent( messageType );
						message.content = {
							sender: 'chalkboard-plugin',
							type: 'erase',
							timestamp: Date.now() - slideStart,
							mode,
							board,
							x: ( mouseX - xOffset ) / scale,
							y: ( mouseY - yOffset ) / scale
						};
						document.dispatchEvent( message );
					}

				}
			} );

			canvas.addEventListener( 'mouseup', function ( evt ) {
				evt.preventDefault();
				drawingCanvas[ mode ].canvas.style.cursor = pens[ mode ][ color[ mode ] ].cursor;
				if ( drawing || erasing ) {
					stopDrawing();
					stopErasing();
				}
			} );
		}

		function resize() {
			//console.log("resize");
			// Resize the canvas and draw everything again
			var timestamp = Date.now() - slideStart;
			if ( !playback ) {
				timestamp = getSlideDuration();
			}

			//console.log( drawingCanvas[0].scale + "/" + drawingCanvas[0].xOffset + "/" +drawingCanvas[0].yOffset );
			for ( var id = 0; id < 2; id++ ) {
				drawingCanvas[ id ].width = window.innerWidth;
				drawingCanvas[ id ].height = window.innerHeight;
				drawingCanvas[ id ].canvas.width = drawingCanvas[ id ].width;
				drawingCanvas[ id ].canvas.height = drawingCanvas[ id ].height;
				drawingCanvas[ id ].context.canvas.width = drawingCanvas[ id ].width;
				drawingCanvas[ id ].context.canvas.height = drawingCanvas[ id ].height;

				drawingCanvas[ id ].scale = Math.min( drawingCanvas[ id ].width / storage[ id ].width, 
									drawingCanvas[ id ].height / storage[ id ].height );
				drawingCanvas[ id ].xOffset = ( drawingCanvas[ id ].width - storage[ id ].width * drawingCanvas[ id ].scale ) / 2;
				drawingCanvas[ id ].yOffset = ( drawingCanvas[ id ].height - storage[ id ].height * drawingCanvas[ id ].scale ) / 2;
				//console.log( drawingCanvas[id].scale + "/" + drawingCanvas[id].xOffset + "/" +drawingCanvas[id].yOffset );
			}
			//console.log( window.innerWidth + "/" + window.innerHeight);
			startPlayback( timestamp, mode, true );
		}

		Reveal.addEventListener( 'pdf-ready', function ( evt ) {
			//console.log( "Create printouts when ready" );
			whenLoaded( createPrintout );
		});

		Reveal.addEventListener( 'ready', function ( evt ) {
			//console.log('ready');
			if ( !printMode ) {
				window.addEventListener( 'resize', resize );

				slideStart = Date.now() - getSlideDuration();
				slideIndices = Reveal.getIndices();
				if ( !playback ) {
					startPlayback( getSlideDuration(), 0 );
				}
				if ( Reveal.isAutoSliding() ) {
					var event = new CustomEvent( 'startplayback' );
					event.timestamp = 0;
					document.dispatchEvent( event );
				}
				updateStorage();
				whenReady( addPageNumbers );
			}
		} );
		Reveal.addEventListener( 'slidechanged', function ( evt ) {
			//clearTimeout( slidechangeTimeout );
			//console.log('slidechanged');
			if ( !printMode ) {
				slideStart = Date.now() - getSlideDuration();
				slideIndices = Reveal.getIndices();
				closeChalkboard();
				board = 0;
				clearCanvas( 0 );
				clearCanvas( 1 );
				if ( !playback ) {
					slidechangeTimeout = setTimeout( startPlayback, transition, getSlideDuration(), 0 );
				}
				if ( Reveal.isAutoSliding() ) {
					var event = new CustomEvent( 'startplayback' );
					event.timestamp = 0;
					document.dispatchEvent( event );
				}
			}
		} );
		Reveal.addEventListener( 'fragmentshown', function ( evt ) {
			//clearTimeout( slidechangeTimeout );
			//console.log('fragmentshown');
			if ( !printMode ) {
				slideStart = Date.now() - getSlideDuration();
				slideIndices = Reveal.getIndices();
				closeChalkboard();
				board = 0;
				clearCanvas( 0 );
				clearCanvas( 1 );
				if ( Reveal.isAutoSliding() ) {
					var event = new CustomEvent( 'startplayback' );
					event.timestamp = 0;
					document.dispatchEvent( event );
				} else if ( !playback ) {
					startPlayback( getSlideDuration(), 0 );
					//closeChalkboard();
				}
			}
		} );
		Reveal.addEventListener( 'fragmenthidden', function ( evt ) {
		//clearTimeout( slidechangeTimeout );
		//console.log('fragmenthidden');
			if ( !printMode ) {
				slideStart = Date.now() - getSlideDuration();
				slideIndices = Reveal.getIndices();
				closeChalkboard();
				board = 0;
				clearCanvas( 0 );
				clearCanvas( 1 );
				if ( Reveal.isAutoSliding() ) {
					document.dispatchEvent( new CustomEvent( 'stopplayback' ) );
				} else if ( !playback ) {
					startPlayback( getSlideDuration() );
					closeChalkboard();
				}
			}
		} );

		Reveal.addEventListener( 'autoslideresumed', function ( evt ) {
			//console.log('autoslideresumed');
			var event = new CustomEvent( 'startplayback' );
			event.timestamp = 0;
			document.dispatchEvent( event );
		} );
		Reveal.addEventListener( 'autoslidepaused', function ( evt ) {
			//console.log('autoslidepaused');
			document.dispatchEvent( new CustomEvent( 'stopplayback' ) );

			// advance to end of slide
			//closeChalkboard();
			startPlayback( getSlideDuration(), 0 );
		} );

		function toggleNotesCanvas() {
			if ( !readOnly ) {
				if ( mode == 1 ) {
					toggleChalkboard();
					notescanvas.style.background = background[ 0 ]; //'rgba(255,0,0,0.5)';
					notescanvas.style.pointerEvents = 'auto';
				}
				else {
					if ( notescanvas.style.pointerEvents != 'none' ) {
						// hide notes canvas
						if ( colorButtons ) {
							notescanvas.querySelector( '.palette' ).style.visibility = 'hidden';
						}
						notescanvas.style.background = 'rgba(0,0,0,0)';
						notescanvas.style.pointerEvents = 'none';
					}
					else {
						// show notes canvas
						if ( colorButtons ) {
							notescanvas.querySelector( '.palette' ).style.visibility = 'visible';
						}
						notescanvas.style.background = background[ 0 ]; //'rgba(255,0,0,0.5)';
						notescanvas.style.pointerEvents = 'auto';

						var idx = 0;
						if ( color[ mode ] ) {
							idx = color[ mode ];
						}

						setColor( idx, true );
					}
				}
			}
		};

		function toggleChalkboard() {
			//console.log("toggleChalkboard " + mode);
			if ( mode == 1 ) {
				if ( !readOnly ) {
					recordEvent( { type: 'close' } );
				}
				closeChalkboard();

				// broadcast
				var message = new CustomEvent( messageType );
				message.content = {
					sender: 'chalkboard-plugin',
					type: 'closeChalkboard',
					timestamp: Date.now() - slideStart,
					mode: 0,
					board
				};
				document.dispatchEvent( message );


			} else {
				showChalkboard();
				if ( !readOnly ) {
					recordEvent( { type: 'open' } );
					// broadcast
					var message = new CustomEvent( messageType );
					message.content = {
						sender: 'chalkboard-plugin',
						type: 'showChalkboard',
						timestamp: Date.now() - slideStart,
						mode: 1,
						board
					};
					document.dispatchEvent( message );

					var idx = 0;

					if ( rememberColor[ mode ] ) {
						idx = color[ mode ];
					}

					setColor( idx, true );
				}
			}
		};

		function clearSlide() {
			recordEvent( { type: 'clear' } );
			clearCanvas( mode );
		}

		function clear() {
			if ( !readOnly ) {
				clearSlide();
				// broadcast
				var message = new CustomEvent( messageType );
				message.content = {
					sender: 'chalkboard-plugin',
					type: 'clear',
					timestamp: Date.now() - slideStart,
					mode,
					board
				};
				document.dispatchEvent( message );
			}
		};

		function colorIndex( idx ) {
			// console.log("colorIndex() idx: ", idx);
			if ( !readOnly ) {
				setColor( idx, true );
			}
		}

		function colorNext() {
			if ( !readOnly ) {
				let idx = cycleColorNext();
				setColor( idx, true );
			}
		}

		function colorPrev() {
			if ( !readOnly ) {
				let idx = cycleColorPrev();
				setColor( idx, true );
			}
		}

		function resetSlideDrawings() {
			slideStart = Date.now();
			closeChalkboard();

			clearCanvas( 0 );
			clearCanvas( 1 );

			mode = 1;
			var slideData = getSlideData();
			slideData.duration = 0;
			slideData.events = [];
			mode = 0;
			var slideData = getSlideData();
			slideData.duration = 0;
			slideData.events = [];

			updateStorage();
		}

		function resetSlide( force ) {
			var ok = force || confirm( "Please confirm to delete chalkboard drawings on this slide!" );
			if ( ok ) {
	//console.log("resetSlide ");
				stopPlayback();
				resetSlideDrawings();
				// broadcast
				var message = new CustomEvent( messageType );
				message.content = {
					sender: 'chalkboard-plugin',
					type: 'resetSlide',
					timestamp: Date.now() - slideStart,
					mode,
					board
				};
				document.dispatchEvent( message );
			}
		};

		function resetStorage( force ) {
			var ok = force || confirm( "Please confirm to delete all chalkboard drawings!" );
			if ( ok ) {
				stopPlayback();
				slideStart = Date.now();
				clearCanvas( 0 );
				clearCanvas( 1 );
				if ( mode == 1 ) {
					closeChalkboard();
				}

				storage = [ {
						width: Reveal.getConfig().width,
						height: Reveal.getConfig().height,
						data: []
					},
					{
						width: Reveal.getConfig().width,
						height: Reveal.getConfig().height,
						data: []
					}
				];

				if ( config.storage ) {
					sessionStorage.setItem( config.storage, null )
				}
				// broadcast
				var message = new CustomEvent( messageType );
				message.content = {
					sender: 'chalkboard-plugin',
					type: 'init',
					timestamp: Date.now() - slideStart,
					storage,
					mode,
					board
				};
				document.dispatchEvent( message );
			}
		};

		function toggleChalkboard() {
			//console.log("toggleChalkboard " + mode);
			if ( mode == 1 ) {
				if ( !readOnly ) {
					recordEvent( { type: 'close' } );
				}
				closeChalkboard();

				// broadcast
				var message = new CustomEvent( messageType );
				message.content = {
					sender: 'chalkboard-plugin',
					type: 'closeChalkboard',
					timestamp: Date.now() - slideStart,
					mode: 0,
					board
				};
				document.dispatchEvent( message );


			} else {
				showChalkboard();
				if ( !readOnly ) {
					recordEvent( { type: 'open' } );
					// broadcast
					var message = new CustomEvent( messageType );
					message.content = {
						sender: 'chalkboard-plugin',
						type: 'showChalkboard',
						timestamp: Date.now() - slideStart,
						mode: 1,
						board
					};
					document.dispatchEvent( message );

					var idx = 0;

					if ( rememberColor[ mode ] ) {
						idx = color[ mode ];
					}

					setColor( idx, true );
				}
			}
		};

		this.toggleNotesCanvas = toggleNotesCanvas;
		this.toggleChalkboard = toggleChalkboard;
		this.colorIndex = colorIndex;
		this.colorNext = colorNext;
		this.colorPrev = colorPrev;
		this.clear = clear;
		this.reset = resetSlide;
		this.resetAll = resetStorage;
		this.download = downloadData;
		this.updateStorage = updateStorage;
		this.getData = getData;
		this.configure = configure;

		window.RevealChalkboard = window.RevealChalkboard || {
			id: 'RevealChalkboard',
			init: function ( deck ) {
				initChalkboard.call(this, deck );
			},
			configure: function ( config ) {
				configure( config );
			},
			toggleNotesCanvas: function () {
				toggleNotesCanvas();
			},
			toggleChalkboard: function () {
				toggleChalkboard();
			},
			colorIndex: function () {
				colorIndex();
			},
			colorNext: function () {
				colorNext();
			},
			colorPrev: function () {
				colorPrev();
			},
			clear: function () {
				clear();
			},
			reset: function () {
				reset();
			},
			resetAll: function () {
				resetAll();
			},
			updateStorage: function () {
				updateStorage();
			},
			getData: function () {
				return getData();
			},
			download: function () {
				download();
			},
		};

		for ( var key in keyBindings ) {
			if ( keyBindings[ key ] ) {
				Reveal.addKeyBinding( keyBindings[ key ], RevealChalkboard[ key ] );
			}
		};

		return this;
	}, 

	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*****************************************************************
	** Author: Asvin Goel, goel@telematique.eu
	**
	** A plugin for reveal.js creating an online seminar.
	**
	** Version: 0.4.4
	**
	** License: MIT license (see LICENSE.md)
	**
	******************************************************************/

	defaultLogger( event ) {
          // console.log( event  );
          // document.getElementById("seminar-status").innerHTML = event;
	},

	initSeminar: function(Reveal) {
		let that = this;

		var printMode = ( /print-pdf/gi ).test( window.location.search );
		if ( printMode ) return;

		var seminar = Reveal.getConfig().seminar || {};
		if ( !seminar.server ) {
			alert("Seminar server not specified!");
			return;
		}
		seminar.url = seminar.url || window.location.host; 
		seminar.room = seminar.room || seminar.url;
		if ( !seminar.hash ) {
			alert("Hash not specified!");
			return;
		}

		const logger = seminar.logger || that.defaultLogger;

		var socket = io.connect( seminar.server, {
			transports: ['websocket'],
			// withCredentials: true
			withCredentials: false
		});
		logger('initSeminar() socket: ', socket);

		if ( seminar.callback )
		   logger('connect to ', seminar.server);
		socket.on('connect', function() {
			logger('connected to ' + seminar.server);
		});

		const STATUS = {"CHECKEDIN": 1, "JOINING": 2, "JOINED": 3, "HOSTING": 4, "CHAIRING": 5};

		var username = null;
		var status = null;

		var receivedState = null;

		function connected() {
			return ( status >= STATUS.JOINED );
		}

		function hosting() {
			return ( status >= STATUS.HOSTING );
		}

		function dispatchStatus() {
			var event = new CustomEvent('seminar');
			event.status = status;
			document.dispatchEvent( event );
		}

		var wakeLock = null; // null -> Wake Lock API not supported

		if ( 'wakeLock' in navigator ) {
			wakeLock = false; 
        //		console.log("Screen Wake Lock API supported");
	//		logger("Screen Wake Lock API supported");
		}

		async function requestWakeLock() {
			if ( wakeLock === false ) {
				try {
					wakeLock = await navigator.wakeLock.request('screen');
	//				console.log('Wake Lock is active!');
					// logger('Wake Lock is active!');
					wakeLock.addEventListener('release', () => {
						// the wake lock has been released
	//					console.log('Wake Lock has been released');
						// logger('Wake Lock has been released');
						wakeLock = false;
					});
				} catch (err) {
					// The Wake Lock request has failed - usually system related, such as battery.
					console.warn(`${err.name}, ${err.message}`);
					wakeLock = false; 
				}
			}
		}

		function releaseWakeLock() {
			if ( wakeLock ) {
				wakeLock.release();
			}
		}

		document.addEventListener('visibilitychange', async () => {
			if ( document.visibilityState === 'visible' && connected() ) {
				requestWakeLock();
			}
		});

		function checkin( name ) {
			if ( status && name && username != name ) {
				// check out if user name changed
				socket.emit('checkout');
				status = null;
			}

			if ( !status ) {
				// use socket id as user name if not user name is not provided
				username = name || username || socket.id;

				// checkin to socket sever
				socket.emit('checkin', username, function( error ){
					if (error) {
						logger( error );
					}
					else {
						status = STATUS.CHECKEDIN;
						dispatchStatus();
						logger( `checked in as ${username}` );
					}
				});
			}
		}

		function open_or_join_room( secret ) {

			if ( status >= STATUS.HOSTING ) {
				// already hosting, ignore request to host
				logger( 'already hosting, ignoring request to host' );
				return;
			}
			if ( status == STATUS.JOINED ) {
				// leave room as participant before entering as host
				leave_room();
			}
			if ( status == STATUS.JOINING ) {
				status = STATUS.CHECKEDIN;
				dispatchStatus();
			}

			// logger( 'open_or_join_room() socket: ', socket );
			// open or join a seminar as host
			socket.emit('host_room', { venue: seminar.url, name: seminar.room, hash: seminar.hash, secret }, function( error ){
			        logger( `socket.emit host room "${seminar.url}|${seminar.room}|${seminar.hash}"` );
				if (error) {
					// console.warn( error );
					// logger( error );
		        		logger( 'host room failed' );
					that.seminar_hosted = false;
                                        document.getElementById("div_seminar_host").style.visibility = 'visible';
                                        document.getElementById("div_seminar_room").style.visibility = 'hidden';
                                        document.getElementById("div_seminar_close").style.visibility = 'hidden';
				}
				else {
					// assume that room is opened and change status later if another host is chair 
					status = Math.max(status, STATUS.HOSTING);
					dispatchStatus();
		        		logger( 'host room succeed' );
					makeHost();
					requestWakeLock();
					that.Reveal.next();
					that.Reveal.right();
					that.seminar_hosted = true;
                                        document.getElementById("div_seminar_host").style.visibility = 'hidden';
                                        document.getElementById("div_seminar_room").style.visibility = 'visible';
                                        document.getElementById("div_seminar_close").style.visibility = 'visible';
				}
			});
		}

		function leave_room() {
			socket.emit('leave_room', { venue: seminar.url, name: seminar.room, hash: seminar.hash }, function( error ){
				if (error) {
					logger( error );
				}
				else {
					status = STATUS.CHECKEDIN;
					dispatchStatus();
					logger( `left room "${seminar.url}|${seminar.room}|${seminar.hash}"` );
					releaseWakeLock();
				}
			});
		}

		function close_room( secret ) {
			socket.emit('close_room', { venue: seminar.url, name: seminar.room, hash: seminar.hash, secret }, function( error ){
				if (error) {
					logger( error );
				}
				else {
					status = STATUS.CHECKEDIN;
					dispatchStatus();
					logger( `room closed "${seminar.url}|${seminar.room}|${seminar.hash}"` );
					releaseWakeLock();
					that.seminar_hosted = false;
                                        document.getElementById("div_seminar_host").style.visibility = 'visible';
                                        document.getElementById("div_seminar_room").style.visibility = 'hidden';
                                        document.getElementById("div_seminar_close").style.visibility = 'hidden';
				}
			});
		}

		function join_room() {
			// join a seminar as regular participant
			socket.emit('join_room', { venue: seminar.url, name: seminar.room, hash: seminar.hash }, function( error ){
				logger(`try to join room "${seminar.url}|${seminar.room}|${seminar.hash}"` );
				if (error) {
					logger( error );
                                        that.seminar_joined = false;   
                                        document.getElementById("div_seminar_host").style.visibility = 'visible';
                                        document.getElementById("div_seminar_room").style.visibility = 'hidden';
					status = STATUS.JOINING;
					dispatchStatus();
					releaseWakeLock();
				}
				else {
					logger( `joined room "${seminar.url}|${seminar.room}|${seminar.hash}" as ${socket.id}` );
                                        that.seminar_joined = true;   
                                        document.getElementById("div_seminar_host").style.visibility = 'hidden';
                                        document.getElementById("div_seminar_room").style.visibility = 'visible';
					subscribe();
					status = STATUS.JOINED;
					dispatchStatus();
					requestWakeLock();
				}
			});
		}
		/*
		function announce( evt, cc ) {
			// make an announcement to everyone (else)
		}

		function send( evt, recipient, cc ) {
			// send a message to recipient
		}
		*/	
		/*
		function receive( message ) {
			// receive and process a message
			if ( message.state ) {
				receivedState = message.state;
				Reveal.setState( message.state );
			}
			if ( message.content ) {
				// forward custom events to other plugins
				var event = new CustomEvent('received');
				event.content = message.content;
				document.dispatchEvent( event );
			}
		}
		*/
		function sendMessage( evt ) {
			// send message w/o copy
			var data = {
				venue: seminar.url, 
				name: seminar.room,
				hash: seminar.hash, 
				recipient: (evt.content || {}).recipient,
				copy: (evt.content || {}).copy, 
				content: evt.content
			};
			if ( data.content ) {
				delete data.content.recipient;
				delete data.content.copy;
			}
			socket.emit( 'message', data );
		};

		function subscribe() {
			document.addEventListener( 'send', function( evt ) { 
				if ( !evt ) return;
				// send custom events which are sent by other plugins
				sendMessage(evt); 
			});
		}

		function broadcastState( evt ) {
			var data = {
				venue: seminar.url, 
				name: seminar.room,
				hash: seminar.hash, 
				recipient: null,
				copy: (evt.content || {}).copy, 
				content: { state: Reveal.getState(), custom: (evt || {}).content }
			};
			if ( data.content ) {
				delete data.content.recipient;
				delete data.content.copy;
			}
			socket.emit( 'announcement', data );
		};

		function stateChange( state ) {
			var current = Reveal.getState();
			return ( !state || !( 
			     current.indexh == state.indexh &&
			     current.indexv == state.indexv &&
			     current.indexf == state.indexf &&
			     current.paused == state.paused &&
			     current.overview == state.overview
			   ));

		}

		function broadcastStateChange( evt ) {
			if ( stateChange( receivedState ) ) {
				// broadcast state change 
				broadcastState( evt );
			}
			else {
				// ignore state change if the state is the same as the last state received 
				receivedState = null;
			}
		}

		function makeHost() {
			// Ignore notes windows
			if ( window.location.search.match( /receiver/gi ) ) return;

			subscribe();
			// Monitor events that trigger a change in state
			Reveal.on( 'slidechanged', broadcastStateChange );
			Reveal.on( 'fragmentshown', broadcastStateChange );
		
			Reveal.on( 'fragmenthidden', broadcastStateChange );
			Reveal.on( 'overviewhidden', broadcastStateChange );
			Reveal.on( 'overviewshown', broadcastStateChange );
			Reveal.on( 'paused', broadcastStateChange );
			Reveal.on( 'resumed', broadcastStateChange );
			document.addEventListener( 'broadcast', function( evt ) { 
				// broadcast custom events w/o recipient which are sent by other plugins
				if ( evt && !evt.recipient ) {
					broadcastState(evt); 
				}
			});
		}

		/*
		socket.on('rooms', ( rooms ) => {
			console.log(rooms);
		});
		*/
		socket.on('room_opened', ( room ) => {
			logger( `room opened "${room.venue}|${room.name}|..."` );

			if ( status == STATUS.JOINING && room.venue == seminar.url && room.name == seminar.room ) {
				// try to join room as regular participant
				join_room();
			}
		});

		socket.on('kicked_out', ( room ) => {
			logger( `kicked out of room "${room.venue}|${room.name}|${room.hash}"` );
			leave_room();
                        that.seminar_joined = false;   
                        document.getElementById("div_seminar_host").style.visibility = 'visible';
                        document.getElementById("div_seminar_room").style.visibility = 'hidden';
			that.seminar_hosted = false;
                        document.getElementById("div_seminar_host").style.visibility = 'visible';
                        document.getElementById("div_seminar_room").style.visibility = 'hidden';
                        document.getElementById("div_seminar_close").style.visibility = 'hidden';
			if ( status >= STATUS.JOINED ) {
				// tell other plugins that user is kicked out of the room
				var event = new CustomEvent('kicked_out');
				event.content = room;
				document.dispatchEvent( event );
				status = STATUS.JOINING;
				dispatchStatus();
				releaseWakeLock();
			}
		});

		socket.on('chair', ( room ) => {
			logger( `chairing room "${room.venue}|${room.name}|${room.hash}"` );
			status = STATUS.CHAIRING;
			dispatchStatus();
		});

		socket.on('participants', ({ room, hosts, participants }) => {
			// make sure to only accept messages within same scope (should not be necessary)
			if ( room.venue != seminar.url || room.name != seminar.room || room.hash != seminar.hash ) return; 

			// inform other plugins about participants
			var event = new CustomEvent('participants');
			event.content = { hosts, participants };
			document.dispatchEvent( event );
		});

		socket.on('entered_room', ({ room, user }) => {
			// make sure to only accept messages within same scope (should not be necessary)
			if ( room.venue != seminar.url || room.name != seminar.room || room.hash != seminar.hash ) return; 
			logger(`${user.id} entered room "${room.venue}|${room.name}|${room.hash}"` );

			if ( status == STATUS.CHAIRING ) {
				// send current state to the new participant
				// tell other plugins that they can send a welcome message to the new participant
				var event = new CustomEvent('welcome');
				event.content = { user };
				document.dispatchEvent( event );
			}
		});

		socket.on('announcement', (  { time, room, sender, content } ) => {
			// console.log("Received message: ", content );
			// make sure to only accept messages within same scope (should not be necessary)
			if ( room.venue != seminar.url || room.name != seminar.room || room.hash != seminar.hash ) return; 

			if ( content.state && stateChange( content.state ) ) {
				// change slide if necessary
				receivedState = content.state;
				Reveal.setState(content.state);
			}
			if ( content.custom ) {
				// console.log("Received announcement: ", content.custom.timestamp, content.custom.type );
				// forward custom events to other plugins
				var event = new CustomEvent('received');
				event.content = content.custom;
				document.dispatchEvent( event );
			}
		});

		socket.on('message', (  { time, room, sender, content } ) => {
			// console.log(`received message: ", content );
			// make sure to only accept messages within same scope (should not be necessary)
			if ( room.venue != seminar.url || room.name != seminar.room || room.hash != seminar.hash ) return; 

			if ( content ) {
				// forward custom events to other plugins
				var event = new CustomEvent('received');
				event.content = content;
				document.dispatchEvent( event );
			}
		});
		
		// automatically join room as participant if data is provided
		if ( seminar.autoJoin && seminar.url && seminar.room && seminar.hash ) {
			checkin();

			if ( seminar.secret ) {
				// if secret is provided open or join room as host
				open_or_join_room( seminar.secret );
			}
			else {
				// join existing room as regular participant
				join_room();
			}
		}

		this.checkin = checkin;
		this.open_or_join_room = open_or_join_room;
		this.join_room = join_room;
		this.leave_room = leave_room;
		this.close_room = close_room;
		this.connected = connected;
		this.hosting = hosting;

		window.RevealSeminar = window.RevealSeminar || {
		    id: 'RevealSeminar',
		    init: function(deck) {
			initSeminar(deck);
		    },
		    open_or_join_room: function( secret, username ) { 
			checkin( username );
			open_or_join_room( secret ); 
		    },
		    join_room: function( username ) {
			checkin( username );
			join_room(); 
		    },
		    leave_room: function() { leave_room(); },
		    close_room: function( secret ) { close_room( secret ); },
		    connected: function() { return connected(); },
		    hosting: function() { return hosting(); },
		};

		return this;
	},

	generateToken(length) {
		var token = "";
		while ( token.length < length ) {
			token += (Math.random() * new Date().getTime()).toString(36).replace(/\./g, '');
		}
		return token.substr(0,length);
	},

	getParameterByName(name, url) {
	    if (!url) {
	      url = window.location.href;
	    }
	    name = name.replace(/[\[\]]/g, "\\$&");
	    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, " "));
	},

	addParam(url, param, value) {
		var a = document.createElement('a'), regex = /(?:\?|&amp;|&)+([^=]+)(?:=([^&]*))*/g;
		var match, str = []; a.href = url; param = encodeURIComponent(param);
		while (match = regex.exec(a.search)) {
			if (param != match[1]) str.push(match[1]+(match[2]?"="+match[2]:""));
		}
		str.push(param+(value?"="+ encodeURIComponent(value):""));
		a.search = str.join("&");
		return a.href;
	},

	logger( event ) {
		// console.log( event ); 
		// document.getElementById("seminar-status").innerHTML = event;
	},
 
        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*****************************************************************
	** Author: Asvin Goel, goel@telematique.eu
	**
	** A plugin for reveal.js adding instant polls within an 
	** online seminar.
	**
	** Version: 0.1.1
	**
	** License: MIT license (see LICENSE.md)
	**
	******************************************************************/

	initPoll: function(Reveal) {
		let that = this;

		var config = Reveal.getConfig().poll;

		var polls = [];

		// Get poll index
		function getPollIndex(id) {
			return polls.findIndex(poll => poll.id === id);
		}

		function initializePolls() {
			var pollElements = document.querySelectorAll(".poll");
	//console.log(polls);
			for (var i = 0; i < pollElements.length; i++ ){
				var id = pollElements[i].getAttribute('data-poll')
				var votes = {};
				var buttons = pollElements[i].querySelectorAll("button");
				for (var j = 0; j < buttons.length; j++ ){
					// initialize number of votes for button
					votes[buttons[j].getAttribute('data-value')] = 0; 

					// make button clickable
					buttons[j].addEventListener('click', function(evt){
						if ( !RevealSeminar.connected() ) {
							alert("You are currently not connected to the live poll. Your vote is ignored.");
							return;
						}
						const button = evt.target;
						const poll = button.parentElement;
						var siblings = poll.querySelectorAll("button");
						for (var i = 0; i < siblings.length; i++ ){
							siblings[i].disabled = true;
						}
						vote( poll.getAttribute('data-poll'), button.getAttribute('data-value') );
						button.classList.add("selected"); 
						button.blur();
					});
				}
				polls.push( { id, voters: 0, votes} );
	//console.log(polls);
			}

		}

		function vote( poll, choice ) {
			// send to vote to chair
			var message = new CustomEvent('send');
			message.content = { sender: 'poll-plugin', recipient: true, type: 'vote', poll, choice };
			document.dispatchEvent( message );
		}

		document.addEventListener( 'received', function ( message ) {
			if ( message.content && message.content.sender == 'poll-plugin' ) {
	//console.log("Update: ", message.content);
				if ( message.content.type == 'vote' ) {
					const vote = message.content;
					const poll = polls[getPollIndex(message.content.poll)];
					// increment number of voters
					poll.voters++;
					var message = new CustomEvent('broadcast');
					message.content = { sender: 'poll-plugin', copy: true, type: 'voters', poll: poll.id, voters: poll.voters };
					document.dispatchEvent( message );

					// update results
					poll.votes[vote.choice]++;
	//console.log("Vote '" + vote.choice + "' received for poll ", poll );
					message = new CustomEvent('broadcast');
					message.content = { sender: 'poll-plugin', copy: true, type: 'results', poll: poll.id, votes: poll.votes };
	//console.log("Send results", message );
					document.dispatchEvent( message );
				}
				else if ( message.content.type == 'voters' ) {
	//console.log("voters", message.content )
					var voters = document.querySelectorAll('.voters[data-poll="' + message.content.poll + '"]');
					for (var j = 0; j < voters.length; j++ ){
						voters[j].innerHTML = message.content.voters;
					}

				}
				else if ( message.content.type == 'results' ) {
					// update result elements
					var results = document.querySelectorAll('.results[data-poll="' + message.content.poll + '"]');
	//console.log("Results", results )
					for (var i = 0; i < results.length; i++ ) {
	//console.log("Votes", message.content.votes )
						for (var choice in message.content.votes) {
	//console.log(choice);
							var elements = results[i].querySelectorAll('[data-value="' + choice + '"]');
							for (var j = 0; j < elements.length; j++ ) {
								elements[j].innerHTML = message.content.votes[choice];
							}
						}
					}

					// update result charts
	// console.log("RevealChart: ", RevealChart);

					if ( RevealChart ) {
						var charts = document.querySelectorAll('canvas[data-chart][data-poll="' + message.content.poll + '"]');	
						var data = [];
						for (var choice in message.content.votes) {
							data.push(message.content.votes[choice]);
						}
	// console.log("data: ", data);
						for (var i = 0; i < charts.length; i++ ) {
							RevealChart.update( charts[i], 0, data );
						}
					}

				}
			}
		});

		Reveal.addEventListener('ready', function(){
	//alert("READY");
			initializePolls();
		});
	
		window.RevealPoll = window.RevealPoll || {
	    		id: 'RevealPoll',
	    		init: function(deck) {
				initPoll(deck);
	    		},
		};

		return this;
	},

        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*****************************************************************
	** Author: Asvin Goel, goel@telematique.eu
	** Fixed for Reveal4: kotborealis@awooo.ru
	**
	** A plugin for reveal.js allowing to integrate Chart.js
	**
	** Version: 1.3.1
	**
	** License: MIT license (see LICENSE.md)
	**
	******************************************************************/

	/**
	 * Reveal Plugin
	 * https://revealjs.com/creating-plugins/
	 */

	initChart: function(Reveal) {
		let that = this;

		function parseJSON(str) {
		    var json;
		    try {
			json = JSON.parse(str);
		    } catch (e) {
			return null;
			}
		    return json;
		}

		/*
		* Recursively merge properties of two objects
		*/
		function mergeRecursive(obj1, obj2) {

		  for (var p in obj2) {
		    try {
		      // Property in destination object set; update its value.
		      if ( obj1[p] !== null && typeof obj1[p] === 'object' && typeof obj2[p] === 'object' ) {
			obj1[p] = mergeRecursive(obj1[p], obj2[p]);
		      } 
		      else {
			obj1[p] = obj2[p];
		      }
		    } catch(e) {
		      // Property in destination object not set; create it and set its value.
		      obj1[p] = obj2[p];
		    }
		  }

		  return obj1;
		}

		function createChart(canvas, CSV, comments) {
			canvas.chart = null;
			var ctx = canvas.getContext("2d");
			var chartOptions = { responsive: true, maintainAspectRatio: false };
			var chartData = { labels: null, datasets: []};
			if ( comments !== null ) for (var j = 0; j < comments.length; j++ ){
				comments[j] = comments[j].replace(/<!--/,'');
				comments[j] = comments[j].replace(/-->/,'');
				var config = parseJSON(comments[j]);
				if ( config ) {
					if ( config.data ) {
						mergeRecursive( chartData, config.data);
					}
					if ( config.options ) {
						mergeRecursive( chartOptions, config.options);
					}
				}
			}

			// var lines = CSV.split('\n').filter(function(v){return v!==''});
			var lines = CSV.split(';').filter(function(v){return v!==''});
			// if labels are not defined, get them from first line
			if ( chartData.labels === null && lines.length > 0 ) {
				chartData.labels = lines[0].split(',');
				chartData.labels.shift();
				lines.shift();
			}
			// get data values
			for (var j = 0; j < lines.length; j++ ){
				if (chartData.datasets.length <= j) chartData.datasets[j] = {};
				chartData.datasets[j].data =  lines[j].split(','); //.filter(function(v){return v!==''});
				chartData.datasets[j].label = chartData.datasets[j].data[0];
				chartData.datasets[j].data.shift();
				for (var k = 0; k < chartData.datasets[j].data.length; k++ ){
					chartData.datasets[j].data[k] = Number(chartData.datasets[j].data[k]);
				}
			}

			// add chart options
			var config = chartConfig[canvas.getAttribute("data-chart")];
			if ( config ) {
				for (var j = 0; j < chartData.datasets.length; j++ ){
					for (var attrname in config) {
						if ( !chartData.datasets[j][attrname]  ) {
							chartData.datasets[j][attrname] = config[attrname][j%config[attrname].length];
						}
					}
				}
			}

			canvas.chart = new Chart(ctx, { type: canvas.getAttribute("data-chart"), data: chartData, options: chartOptions });

		}

		function updateChart(canvas, idx, data) {
	
	/*		
	console.log("canvas: ", canvas);
	console.log("idx: ", idx);
	console.log("data: ", data);
	console.log("canvas.chart: ", canvas.chart);
	console.log("canvas.chart.data: ", canvas.chart.data);
	console.log("canvas.chart.data.datasets[idx]: ", canvas.chart.data.datasets[idx]);
	 */
			canvas.chart.data.datasets[idx].data = data;
			recreateChart( canvas );
		}

		var initializeCharts = function(){
			// Get all canvases
			var canvases = document.querySelectorAll("canvas");
			for (var i = 0; i < canvases.length; i++ ){
				// check if canvas has data-chart attribute
				if ( canvases[i].hasAttribute("data-chart") ){
					var CSV = canvases[i].innerHTML.trim();
					var comments = CSV.match(/<!--[\s\S]*?-->/g);
					CSV = CSV.replace(/<!--[\s\S]*?-->/g,'').replace(/^\s*\n/gm, "")
					if ( ! canvases[i].hasAttribute("data-chart-src") ) {
						createChart(canvases[i], CSV, comments);
					}
					else {
						var canvas = canvases[i];
						var xhr = new XMLHttpRequest();
						xhr.onload = function() {
							if (xhr.readyState === 4) {
								createChart(canvas, xhr.responseText, comments);
							}
							else {
								console.warn( 'Failed to get file ' + canvas.getAttribute("data-chart-src") + 
										". ReadyState: " + xhr.readyState + ", Status: " + xhr.status);
							}
						};

						xhr.open( 'GET', canvas.getAttribute("data-chart-src"), false );
						try {
							xhr.send();
						}
						catch ( error ) {
							console.warn( 'Failed to get file ' + canvas.getAttribute("data-chart-src") + 
									'. Make sure that the presentation and the file are served by ' + 
									'a HTTP server and the file can be found there. ' + error );
						}
					}

				}
			}
		}

		function recreateChart(canvas) {
			// clear data to redraw animation
			var data = canvas.chart.data.datasets;
			canvas.chart.data.datasets = []; 
			canvas.chart.update();
			canvas.style.visibility = "hidden";
			setTimeout( function(canvas, data) { 
				canvas.chart.data.datasets = data; 
				canvas.style.visibility = "visible"; 
				canvas.chart.update(); 
			}, 500, canvas, data); // wait for slide transition to re-add data and animation
	/*
			var config = canvas.chart.config;
			canvas.chart.destroy();
			setTimeout( function() { canvas.chart = new Chart(canvas, config);}, 500); // wait for slide transition
	*/
		}

		// check if chart option is given or not
		var chartConfig = Reveal.getConfig().chart || {};

		// set global chart options
		var config = chartConfig.defaults;
		if ( config ) {
			mergeRecursive(Chart.defaults, config);
		}

		Reveal.addEventListener('ready', function(){
			initializeCharts();
			Reveal.addEventListener('slidechanged', function(){
				var canvases = Reveal.getCurrentSlide().querySelectorAll("canvas[data-chart]");
				for (var i = 0; i < canvases.length; i++ ){
					if ( canvases[i].chart  && canvases[i].chart.config.options.animation !== false ) {
						recreateChart( canvases[i] );
					}
				}

			});
		});

		this.update = updateChart;

		window.RevealChart = window.RevealChart || {
		    id: 'RevealChart',
		    init: function(deck) {
			initChart(deck);
		    },
		    update: function(canvas, idx, data) { updateChart(canvas, idx, data); },
		};

		return this;
	},

        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*****************************************************************
	** Author: Asvin Goel, goel@telematique.eu
	**
	** A plugin for reveal.js adding a Q&A to an online seminar.
	**
	** Version: 0.1.2
	**
	** License: MIT license (see LICENSE.md)
	**
	******************************************************************/

	initQnA: function(Reveal) {
		let that = this;

		var config = Reveal.getConfig().questions || {};
		const STATUS = {"JOINED": 3, "HOSTING": 4};
		var connected = false;
		var questions = 0;
		var counter = 0;

		// create Q&A div
		var container = document.createElement("div");
		container.classList.add("qna");
		container.classList.add("dashboard");
		container.classList.add("overlay");
		container.style.visibility = "hidden";
		container.setAttribute( 'data-prevent-swipe', '' );

		container.oncontextmenu = function() { return false; }
		container.style.zIndex = 26;

		container.innerHTML = "<h1> Q&A </h1>";

		// question template
		var questionTemplate = document.createElement('div');
		questionTemplate.classList.add("qna");
		questionTemplate.classList.add("question");
		questionTemplate.innerHTML = 	'<div class="user">Anonymous</div>' +
					'<div class="text">Text</div>' +
					'<div class="votes"><span>-1</span> <i class="fa fa-thumbs-up"></i></div>' +
					'<div class="close"><i class="fa fa-check"></i></div>';

		container.innerHTML = '<div class="qna ask"><input type="text" placeholder="Enter question" required="" autocomplete="off"></input>' + 
					'<button>Ask <i class="fa fa-paper-plane"></button></div>';

		container.querySelector("input").addEventListener('keypress', function( e ) {
			e.stopPropagation(); // consume all key presses and do not allow other to listen to them
			if (e.which === 13) {
				// ask question when hitting enter
				this.nextSibling.click();
			}
		});

		container.querySelector("button").addEventListener('click', function() {
			var inputElement = this.parentElement.firstChild;
			if ( inputElement.value ) {
				ask( inputElement.value );
	//			createQuestion( { id: 0, text: inputElement.value, user: "Anonymous", votes: 0, open: true } );
				inputElement.value = "";
			}
		});

		var questionList = document.createElement("div");
		questionList.classList.add("qna");
		questionList.classList.add("questions");
		container.appendChild(questionList);
		document.querySelector( '.reveal' ).appendChild( container );

		var toggleQnAButton = config.toggleQnAButton || false;

		if ( toggleQnAButton ) {
	console.warn( "toggleQnAButton is deprecated, use customcontrols plugin instead!" );
			var button = document.createElement( 'div' );
			button.className = "toggle-questions";
			button.id = "toggle-questions";
			button.style.visibility = "hidden";
			button.style.position = "absolute";
			button.style.zIndex = 30;
			button.style.fontSize = "24px";

			button.style.left = toggleQnAButton.left || "30px";
			button.style.bottom = toggleQnAButton.bottom ||  "30px";
			button.style.top = toggleQnAButton.top ||  "auto";
			button.style.right = toggleQnAButton.right ||  "auto";

			button.innerHTML = '<a href="#" title="Toggle Q&A dashboard (Q)" onclick="RevealQnA.toggleQnA(); return false;">' +
					'<span class="fa-stack" style="margin: -10px;"><span class="fa fa-comment fa-stack-1x"></span>' + 
					'<strong class="fa-stack-1x fa-inverse qna question-counter" style="font-size:0.5em;"></strong></span>' +
					// <i class="fa fa-comment"></i>
					'</a>';
			document.querySelector(".reveal").appendChild( button );
		}

	/*
		function initializeQnA() {

		}
	*/

		function toggleQnA( show ) {
			if ( show == undefined ) {
				show = document.querySelector('.qna.dashboard').style.visibility == "hidden";
			}

			document.querySelector('.qna.dashboard').style.visibility = show ? "visible" : "hidden";
		}

		function getQuestion( id ) {
			// returns undefined if question is not found
			return document.querySelector(`.qna.question[data-id="${id}"]`);
		}

		function ask( text ) {
			// ask a question
			var message = new CustomEvent('send');
			message.content = { sender: 'questions-plugin', recipient: true, type: 'ask', text, username: 'Anonymous' };
			document.dispatchEvent( message );
		}

		function upvote( questionElement ) {
	//		questionElement.question.votes++;
			var message = new CustomEvent('send');
			message.content = { sender: 'questions-plugin', recipient: true, type: 'upvote', id: questionElement.question.id  };
			document.dispatchEvent( message );
		}

		function close( questionElement ) {
			// close a question (only host)
			var question = Object.assign({}, questionElement.question );
			question.open = false;

			var message = new CustomEvent('broadcast');
			message.content = { sender: 'questions-plugin', copy: true, question };
			document.dispatchEvent( message );
		}

		function bubbleUp ( questionElement ) {
			// bubble question upwards if necessary
			while ( questionElement.previousSibling ) {
				if ( questionElement.question.votes > questionElement.previousSibling.question.votes || 
					questionElement.question.open > questionElement.previousSibling.question.open ) {
					questionElement = questionElement.parentElement.insertBefore( questionElement, questionElement.previousSibling );
				}
				else {
					break;
				}
			}
			return questionElement;
		};

		function bubbleDown ( questionElement ) {
			// bubble question downwards if necessary
			while ( questionElement.nextSibling ) {
				if ( questionElement.nextSibling.question.open > questionElement.question.open || 
					questionElement.nextSibling.question.votes > questionElement.question.votes  ) {
					questionElement = questionElement.parentElement.insertBefore( questionElement, 
								questionElement.nextSibling.nextSibling );
				}
				else {
					break;
				}
			}
			return questionElement;
		};

		function createQuestion( question ) {
			// add new question and show it
			var div = questionTemplate.cloneNode(true);
			div.dataset.id = question.id;

			div.querySelector(".user").innerHTML = question.username;
			div.querySelector(".votes > span").innerHTML = question.votes;
			div.querySelector(".text").innerHTML = question.text;

			div.querySelector(".votes").addEventListener( 'click', function( e ) {
				if ( !this.classList.contains("disabled") && !this.parentElement.classList.contains("closed") ) {
					this.classList.add("disabled");
					upvote( this.parentElement );
				}
			});

			if ( RevealSeminar.hosting() && question.open ) {
				div.querySelector(".close").addEventListener( 'click', function( e ) {
					if ( !this.parentElement.classList.contains("closed") ) {
						close( this.parentElement );
					}
				});
			}
			else {
				div.querySelector(".close").style.visibility = "hidden";
			}

			div.question = question;

			// increment open question counter
			if ( question.open ) {
				counter++;
				var elements = document.querySelectorAll('.qna.question-counter');
				for ( var i=0; i < elements.length; i++ ) {
					elements[i].innerHTML = counter;
				}
			}
			else {
				div.classList.add("closed");	
			}

			return bubbleUp( document.querySelector('.qna > .questions').appendChild(div) );
		}

		document.addEventListener( 'seminar', function ( message ) {
			// update status
	//console.log(message.status);
			var connected = ( message.status >= STATUS.JOINED );
			var buttons = document.querySelectorAll('#toggle-questions');
			for (var i = 0; i < buttons.length; i++) {
				buttons[i].style.display = connected ? "inherit" : "none";
			}
			if ( !connected ) {
				toggleQnA( false ); // close Q&A
				Reveal.removeKeyBinding( 81 );
			}
			else {
				Reveal.addKeyBinding( { keyCode: 81, key: 'Q', description: 'Toggle Q&A' }, () => {
					toggleQnA();
				} )
			}
		});

		document.addEventListener( 'received', function ( message ) {
			if ( message.content && message.content.sender == 'questions-plugin' ) {
	//console.log("Received", message.content);
				switch (message.content.type) {
					case 'ask':
	//if ( !RevealSeminar.hosting() ) alert("I should be host!");
						questions++;
	//console.log("Broadcast", message.content.text);
						var event = new CustomEvent('broadcast');
						event.content = { sender: 'questions-plugin', copy: true, 
								  question: { id: questions, username: message.content.username, 
									      text: message.content.text, votes: 0, open: true} };
						document.dispatchEvent( event );
					break;
					case 'upvote':
	//if ( !RevealSeminar.hosting() ) alert("I should be host!");
						var questionElement = getQuestion(message.content.id);
	//console.log(message.content.id, questionElement);
						var question = Object.assign({}, questionElement.question);
						question.votes++;
						var event = new CustomEvent('broadcast');
						event.content = { sender: 'questions-plugin', copy: true, question };
						document.dispatchEvent( event );
	//					questionElement.question.votes--; // undo increment and do it later again
					break;
					default:
						var questionElement = getQuestion(message.content.question.id);
						if ( !questionElement ) {
							createQuestion( message.content.question );
							break;
						}
					
	//console.log("Update", questionElement.question, message.content.question);
						// update existing question
						if ( questionElement.question.open && !message.content.question.open ) {
	//console.log("Close");
							// decrement open question counter
							counter--;
							var elements = document.querySelectorAll('.qna.question-counter');
							for ( var i=0; i < elements.length; i++ ) {
								elements[i].innerHTML = (counter == 0) ? '' : counter;
							}
		
							// close question
							questionElement.classList.add("closed");	

							// update data
							questionElement.question = message.content.question;
							bubbleDown( questionElement );
						}
						else if ( questionElement.question.votes < message.content.question.votes ) {
	//console.log("Upvoted", questionElement.question.votes , message.content.question.votes);
							// update votes
							var element = questionElement.querySelector('.votes > span');
							if ( element ) {
								element.innerHTML = message.content.question.votes;
							}

							// update data
							questionElement.question = message.content.question;
							bubbleUp( questionElement );
						}

				}
			}
		});

		this.toggleQnA = toggleQnA;

		window.RevealQnA = window.RevealQnA || {
		    id: 'RevealQnA',
		    init: function(deck) {
			initQnA(deck);
		    },
		    toggleQnA: function() { toggleQnA(); },
		};

		return this;
	},

        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

	/*!
	 * Handles finding a text string anywhere in the slides and showing the next occurrence to the user
	 * by navigatating to that slide and highlighting it.
	 *
	 * @author Jon Snyder <snyder.jon@gmail.com>, February 2013
	 */

	// const Plugin = () => {
	initSearch: function(Reveal) {
		let that = this;

		// The reveal.js instance this plugin is attached to
		let deck = Reveal;

		let searchElement;
		let searchButton;
		let searchInput;

		let matchedSlides;
		let currentMatchedIndex;
		let searchboxDirty;
		let hilitor;

		function render() {

			searchElement = document.createElement( 'div' );
			searchElement.classList.add( 'searchbox' );
			searchElement.style.position = 'absolute';
			searchElement.style.top = '10px';
			searchElement.style.right = '10px';
			searchElement.style.zIndex = 10;

			//embedded base64 search icon Designed by Sketchdock - http://www.sketchdock.com/:
			searchElement.innerHTML = `<input type="search" class="searchinput" placeholder="Search..." style="vertical-align: top;"/>
			</span>`;

			searchInput = searchElement.querySelector( '.searchinput' );
			searchInput.style.width = '240px';
			searchInput.style.fontSize = '14px';
			searchInput.style.padding = '4px 6px';
			searchInput.style.color = '#000';
			searchInput.style.background = '#fff';
			searchInput.style.borderRadius = '2px';
			searchInput.style.border = '0';
			searchInput.style.outline = '0';
			searchInput.style.boxShadow = '0 2px 18px rgba(0, 0, 0, 0.2)';
			searchInput.style['-webkit-appearance']  = 'none';

			deck.getRevealElement().appendChild( searchElement );

			// searchButton.addEventListener( 'click', function(event) {
			// 	doSearch();
			// }, false );

			searchInput.addEventListener( 'keyup', function( event ) {
				switch (event.keyCode) {
					case 13:
						event.preventDefault();
						doSearch();
						searchboxDirty = false;
						break;
					default:
						searchboxDirty = true;
				}
			}, false );

			closeSearch();

		}

		function openSearch() {
			if( !searchElement ) render();

			searchElement.style.display = 'inline';
			searchInput.focus();
			searchInput.select();
		}

		function closeSearch() {
			if( !searchElement ) render();

			searchElement.style.display = 'none';
			if(hilitor) hilitor.remove();
		}

		function toggleSearch() {
			if( !searchElement ) render();

			if (searchElement.style.display !== 'inline') {
				openSearch();
			}
			else {
				closeSearch();
			}
		}

		function doSearch() {
			//if there's been a change in the search term, perform a new search:
			if (searchboxDirty) {
				var searchstring = searchInput.value;

				if (searchstring === '') {
					if(hilitor) hilitor.remove();
					matchedSlides = null;
				}
				else {
					//find the keyword amongst the slides
					hilitor = new Hilitor("slidecontent");
					matchedSlides = hilitor.apply(searchstring);
					currentMatchedIndex = 0;
				}
			}

			if (matchedSlides) {
				//navigate to the next slide that has the keyword, wrapping to the first if necessary
				if (matchedSlides.length && (matchedSlides.length <= currentMatchedIndex)) {
					currentMatchedIndex = 0;
				}
				if (matchedSlides.length > currentMatchedIndex) {
					deck.slide(matchedSlides[currentMatchedIndex].h, matchedSlides[currentMatchedIndex].v);
					currentMatchedIndex++;
				}
			}
		}

		// Original JavaScript code by Chirp Internet: www.chirp.com.au
		// Please acknowledge use of this code by including this header.
		// 2/2013 jon: modified regex to display any match, not restricted to word boundaries.
		function Hilitor(id, tag) {

			var targetNode = document.getElementById(id) || document.body;
			var hiliteTag = tag || "EM";
			var skipTags = new RegExp("^(?:" + hiliteTag + "|SCRIPT|FORM)$");
			var colors = ["#ff6", "#a0ffff", "#9f9", "#f99", "#f6f"];
			var wordColor = [];
			var colorIdx = 0;
			var matchRegex = "";
			var matchingSlides = [];

			this.setRegex = function(input)
			{
				input = input.replace(/^[^\w]+|[^\w]+$/g, "").replace(/[^\w'-]+/g, "|");
				matchRegex = new RegExp("(" + input + ")","i");
			}

			this.getRegex = function()
			{
				return matchRegex.toString().replace(/^\/\\b\(|\)\\b\/i$/g, "").replace(/\|/g, " ");
			}

			// recursively apply word highlighting
			this.hiliteWords = function(node)
			{
				if(node == undefined || !node) return;
				if(!matchRegex) return;
				if(skipTags.test(node.nodeName)) return;

				if(node.hasChildNodes()) {
					for(var i=0; i < node.childNodes.length; i++)
						this.hiliteWords(node.childNodes[i]);
				}
				if(node.nodeType == 3) { // NODE_TEXT
					var nv, regs;
					if((nv = node.nodeValue) && (regs = matchRegex.exec(nv))) {
						//find the slide's section element and save it in our list of matching slides
						var secnode = node;
						while (secnode != null && secnode.nodeName != 'SECTION') {
							secnode = secnode.parentNode;
						}

						var slideIndex = deck.getIndices(secnode);
						var slidelen = matchingSlides.length;
						var alreadyAdded = false;
						for (var i=0; i < slidelen; i++) {
							if ( (matchingSlides[i].h === slideIndex.h) && (matchingSlides[i].v === slideIndex.v) ) {
								alreadyAdded = true;
							}
						}
						if (! alreadyAdded) {
							matchingSlides.push(slideIndex);
						}

						if(!wordColor[regs[0].toLowerCase()]) {
							wordColor[regs[0].toLowerCase()] = colors[colorIdx++ % colors.length];
						}

						var match = document.createElement(hiliteTag);
						match.appendChild(document.createTextNode(regs[0]));
						match.style.backgroundColor = wordColor[regs[0].toLowerCase()];
						match.style.fontStyle = "inherit";
						match.style.color = "#000";

						var after = node.splitText(regs.index);
						after.nodeValue = after.nodeValue.substring(regs[0].length);
						node.parentNode.insertBefore(match, after);
					}
				}
			};

			// remove highlighting
			this.remove = function()
			{
				var arr = document.getElementsByTagName(hiliteTag);
				var el;
				while(arr.length && (el = arr[0])) {
					el.parentNode.replaceChild(el.firstChild, el);
				}
			};

			// start highlighting at target node
			this.apply = function(input)
			{
				if(input == undefined || !input) return;
				this.remove();
				this.setRegex(input);
				this.hiliteWords(targetNode);
				return matchingSlides;
			};

		}

                /*
		return {

			id: 'search',

			init: reveal => {

				deck = reveal;
				deck.registerKeyboardShortcut( 'CTRL + Shift + F', 'Search' );

				document.addEventListener( 'keydown', function( event ) {
					if( event.key == "F" && (event.ctrlKey || event.metaKey) ) { //Control+Shift+f
						event.preventDefault();
						toggleSearch();
					}
				}, false );

			},

			open: openSearch,
			toggle: toggleSearch,

		}
                 */

		Reveal.registerKeyboardShortcut( 'CTRL + Shift + F', 'Search' );

		document.addEventListener( 'keydown', function( event ) {
			if( event.key == "F" && (event.ctrlKey || event.metaKey) ) { //Control+Shift+f
				event.preventDefault();
				toggleSearch();
			}
		}, false );

		// this.toggleQnA = toggleQnA;

		window.RevealSearch = window.RevealSearch || {
		    id: 'search',
		    init: function(deck) {
			initSearch(deck);
		    },
		    open: function() { openSearch(); },
		    toggle: function() { toggleSearch(); },
		};

		return this;
	}, 

    }, // end of methods 
 
  } // end of export default
</script>


<style scoped>
  @import "reveal.js/dist/reveal.css";
  @import "reveal.js/dist/theme/white.css";
  @import "reveal.js/plugin/highlight/monokai.css";
  @import "@/assets/css/fontawesome-free-6.4.0-web/css/all.css";
  @import "@/assets/css/menu.css";
  @import "@/assets/css/customcontrols.css";
  @import "@/assets/css/title-footer.css";
  @import "@/assets/css/chalkboard.css";
  @import "@/assets/css/poll.css";
  @import "@/assets/css/questions.css";

  @import "@/assets/css/globalslidescn.css";
</style>
